import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src2184593401/src/src/templates/markdown-page.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Metadata = makeShortcode("Metadata");
const Box = makeShortcode("Box");
const Stack = makeShortcode("Stack");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Metadata name="resellerConditional" match="host" value="rebel.com" mdxType="Metadata">
  <h1>Terms & Conditions</h1>
  <Box justifyContent="space-between" mb={4} mdxType="Box">
    <Stack mdxType="Stack">
      <p>
        <strong>
          <a href="#mainterms">Main Terms and Conditions</a>
        </strong>
      </p>
      <p>
        <strong>
          <a href="#schedulea">Schedule A</a>:
        </strong>{' '}
        Terms and Conditions Relating to Domain Name Registration
      </p>
      <p>
        <strong>
          <a href="#scheduleb">Schedule B</a>:
        </strong>{' '}
        Terms and Conditions Applicable to Email Services
      </p>
      <p>
        <strong>
          <a href="#schedulec">Schedule C</a>:
        </strong>{' '}
        Terms and Conditions Applicable to Web Hosting Services
      </p>
      <p>
        <strong>
          <a href="#scheduled">Schedule D</a>:
        </strong>{' '}
        Terms and Conditions Applicable to the High Security Service
      </p>
      <p>
        <strong>
          <a href="#schedulee">Schedule E</a>:
        </strong>{' '}
        Terms and Conditions Applicable to Privacy Services
      </p>
      <p>
        <strong>
          <a href="#schedulef">Schedule F</a>:
        </strong>{' '}
        Terms and Conditions Applicable to SSL Certificate Services
      </p>
      <p>
        <strong>
          <a href="#scheduleg">Schedule G</a>:
        </strong>{' '}
        Terms and Conditions Relating to Afternic Fast Transfer
      </p>
      <p>
        <strong>
          <a href="#scheduleh">Schedule H</a>:
        </strong>{' '}
        Terms and Conditions Relating to Expiry Protection and Ownership Protection Services
      </p>
      <p>
        <strong>
          <a href="#schedulei">Schedule I</a>:
        </strong>{' '}
        Terms and Conditions Relating to Preferred Partner Program
      </p>
      <p>
        <strong>
          <a href="#registrant">
            Registrant Rights, Benefits & Responsibilities
          </a>
        </strong>
      </p>
    </Stack>
    <Box border={2} p={3} mdxType="Box">
      <div>
        <h3>Additional Terms &amp; Conditions</h3>
        <div>
          <Stack mdxType="Stack">
            <li className="unit size1of3">
              <a href="/terms-conditions/asia">.ASIA </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/au">.AU </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/biz"> .BIZ </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/ca">.CA </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/cn">.CN </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/co">.CO </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/eu">.EU </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/info"> .INFO </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/mobi">.MOBI </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/name">.NAME </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/sucks">.SUCKS </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/us">.US </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/xxx"> .XXX </a>
            </li>
            <li className="unit size1of3">
              <a href="/terms-conditions/highly-regulated">
                .LAWYER, .DENTIST & .ATTORNEY
              </a>
            </li>
          </Stack>
        </div>
      </div>
    </Box>
  </Box>
  <h1 id="mainterms">
    <a href="#mainterms" name="mainterms">
      Main Terms and Conditions
    </a>
  </h1>
  <p>
    <strong>1. INTRODUCTION</strong> In this Service Agreement
    (&#34;Agreement&#34;), &#34;Registrant&#34; &#34;you&#34; and &#34;your&#34;
    refer to each user, customer (collectively &#34;Customer&#34;) and its
    agents, and &#34;Registrar&#34;, &#34;we&#34;, &#34;us&#34; and
    &#34;our&#34; refer to <Metadata name="BlueSnapTitle" mdxType="Metadata" /> (or collectively “
    <Metadata name="title" mdxType="Metadata" />
    ”). This Agreement explains our obligations to you, and your obligations to
    us in relation to the service(s) that you purchase and use from us. By
    selecting <Metadata name="title" mdxType="Metadata" /> service(s) you have agreed to establish
    an account with us for such service(s). When you use your account or permit
    someone else to use your account to purchase or otherwise acquire access to
    additional <Metadata name="title" mdxType="Metadata" /> service(s) or to modify or cancel your{' '}
    <Metadata name="title" mdxType="Metadata" /> service(s) (even if we were not notified of such
    authorization), this Agreement covers any such service or actions. Any
    acceptance of your application(s) for our service(s) and the performance of
    our service(s) will occur at our offices in the location of our principal
    place of business. You agree that each person listed in your account
    information as being associated with your account for any service(s)
    provided to you is your agent with full authority to act on your behalf for
    such services in accordance with the permissions granted, including but not
    limited to the authorization to terminate, transfer (where permitted by this
    Agreement), or to modify or purchase additional service(s). You also agree
    that if you list, directly or by default, <Metadata name="title" mdxType="Metadata" /> as a
    contact for your account for any of the service(s), we have the right,
    without notice, to remove our name and/or information from any such
    service(s) and to replace the same with the name and/or information provided
    by you.
  </p>
  <p>
    You agree that <Metadata name="title" mdxType="Metadata" /> may, in its sole discretion, renew
    a domain using any registrar owned by a parent, subsidiary, entity under
    common control and/or entity owned by the same beneficial owner, at any time
    <Metadata name="BlueSnapSubsidiaryRef" mdxType="Metadata" />
    . In addition, you agree that <Metadata name="title" mdxType="Metadata" /> may, in its sole
    discretion, transfer or share your <Metadata name="title" mdxType="Metadata" /> account
    information, domains, hosting, additional products, billing history, payment
    information (including without limitation credit card information if
    applicable), payment profile, and/or all other products or services to or
    with a parent, subsidiary, entity under common control and/or entity owned
    by the same beneficial owner, at any time
    <Metadata name="BlueSnapSubsidiaryRef" mdxType="Metadata" />.
  </p>
  <p>
    <strong>Principal place of business & Mailing Address:</strong>
  </p>
  <p>
    <Metadata name="BlueSnapTitle" mdxType="Metadata" />: <Metadata name="address" mdxType="Metadata" />
  </p>
  <p>
    IMPORTANT NOTICE - ARBITRATION AGREEMENT AND CLASS ACTION WAIVER: BY
    AGREEING TO BE BOUND BY THE TERMS OF SERVICE, YOU AGREE THAT ALL DISPUTES
    BETWEEN US WILL BE RESOLVED BY BINDING ARBITRATION, EXCEPT FOR CERTAIN
    LIMITED TYPES OF DISPUTES DESCRIBED IN SECTION 23 BELOW. YOUR AGREEMENT TO
    ARBITRATION MEANS YOU ARE GIVING UP THE RIGHT TO GO TO COURT AND THE RIGHT
    TO A TRIAL BY JURY, AND INSTEAD, DISPUTES WILL BE DECIDED BY A NEUTRAL
    ARBITRATOR. YOU ALSO AGREE THAT ALL DISPUTES BETWEEN US, WHETHER IN COURT OR
    IN ARBITRATION, WILL BE BROUGHT ONLY ON AN INDIVIDUAL BASIS AND YOU ARE
    WAIVING YOUR RIGHT TO BRING OR PARTICIPATE IN A CLASS ARBITRATION OR CLASS
    ACTION. PLEASE READ SECTION 23 OF THIS AGREEMENT FOR FURTHER DETAILS.
  </p>
  <p>
    <strong>2. SECURITY</strong> When you register a domain name or subscribe
    to our service(s) with us, we provide you with a password or passphrase that
    can be used to modify your information. It is your responsibility to
    safeguard your password or passphrase. You accept full responsibility for
    modifications made to your service(s) using this password or passphrase.
  </p>
  <p>
    <strong>3. VARIOUS SERVICES</strong> Unless otherwise stated, all
    promotions and special offers are for the first year only and products
    and/or services will renew at regular price. The terms of this Agreement are
    applicable to any and all of the <Metadata name="title" mdxType="Metadata" />
    &#39;s service(s) you have chosen, including any additional services you may
    choose in the future which may be offered by <Metadata name="title" mdxType="Metadata" /> from time
    to time. <b>NOTICE REGARDING BUNDLED SERVICES:</b> If you purchase <Metadata name="title" mdxType="Metadata" />{' '}
    services that are sold together as a “bundled” package (e.g., you select a web
    site package that includes both a domain name and hosting services, as opposed
    to your purchasing such services separately) (&#34;Bundled Services&#34;), termination
    of any part of the service will result in termination of all services provided
    as part of the bundled package.{' '}
  </p>
  <p>
    <strong>4. FEES AND PAYMENT</strong> As consideration for the services you
    have selected, you agree to pay <Metadata name="title" mdxType="Metadata" /> the applicable
    service(s) fees set forth on our Web site at the time of your selection. All
    fees are due immediately and are non-refundable. <Metadata name="title" mdxType="Metadata" />{' '}
    may take all remedies available to collect fees owed and may recover from
    you all costs and expenses (including reasonable attorney fees) incurred by{' '}
    <Metadata name="title" mdxType="Metadata" /> to collect such fees. If you qualify, we may
    extend payment terms to you. You agree to recurring payments and a recurring
    billing schedule for your services. We reserve the right to change our
    prices and will post{' '}
    <a href="/Domain-Pricing.aspx">prices on our website</a>.{' '}
  </p>
  <p>
    <strong>5. TERM OF SERVICE</strong> Unless otherwise specified, each{' '}
    <Metadata name="title" mdxType="Metadata" /> service is for a one-year initial term and is
    automatically renewed thereafter for successive one-year terms. A domain
    registered by you will be billed annually, until you choose to cancel the
    domain. Domain renewals, recovery or other services with us are subject to
    our then current Terms and Conditions as well as payment of all applicable
    service fees at the time of the recurring charge. Domain name renewals and
    recovery are subject to the registry&#39;s acceptance of your domain name
    registration.
  </p>
  <p>
    Should you select to pay upfront for a multiple year term, each year on the
    anniversary of the registration <Metadata name="title" mdxType="Metadata" /> will pay on your
    behalf to the registry the required registry fees until the term you have
    purchased expires or we are no longer your registrar.
    Should the registry raise its fees, <Metadata name="title" mdxType="Metadata" /> will inform
    you and collect the difference for the term remaining.
  </p>
  <p>
    In addition to other termination provisions contained in this Agreement, if
    you purchase Bundled Services, any termination relating to such bundle will
    terminate all <Metadata name="title" mdxType="Metadata" /> services included in such bundle.
    For instance, any domain name registered with or maintained by{' '}
    <Metadata name="title" mdxType="Metadata" /> under this Agreement will be cancelled and may
    thereafter be available for registration by another party. Upon the
    effective date of termination, <Metadata name="title" mdxType="Metadata" /> will no longer
    provide the bundled services to you, any leases granted to you shall
    immediately terminate, and you will cease using such services immediately;
    provided, however, that <Metadata name="title" mdxType="Metadata" /> may, in its sole
    discretion and subject to your agreeing to be bound by the applicable
    agreement(s) and to pay the applicable fees for such services, allow you to
    convert certain services included in the bundled services to stand alone
    services.
  </p>
  <p>
    <strong>6. ACCURATE INFORMATION</strong> As further consideration for the{' '}
    <Metadata name="title" mdxType="Metadata" /> service(s), you agree to:{' '}
  </p>
  <blockquote>
    <p>
      6.1 provide certain current, complete and accurate information about you
      as required;{' '}
    </p>
    <p>
      6.2 maintain and update this information as needed to keep it current,
      complete and accurate; and{' '}
    </p>
    <p>
      6.3 respond within fifteen (15) calendar days to a request by us to update
      or confirm the accuracy of your information.{' '}
    </p>
  </blockquote>
  <p>
    We rely on this information to carry out our services for you and comply
    with the requirements of the registries of domain names and our service
    providers and to send you important information and notices regarding your
    account and our services. Any failure by you to provide or update such
    information or to respond to our request is a material breach of this
    Agreement.{' '}
  </p>
  <p>
    <strong>7. PRIVACY POLICY</strong> Our privacy policy, located on our Web
    site at <Metadata name="link" path="/privacy-policy" mdxType="Metadata" /> incorporated herein
    by reference, sets forth your and our rights and responsibilities with
    regard to your personal information. You agree to read the privacy policy.
    You agree that we, in our sole discretion, may modify our privacy policy. We
    will post such revised statement on our Web site at least thirty (30)
    calendar days before it becomes effective. You agree to periodically review
    our Web site to be aware of any such revisions. You agree that, by using our
    services after modifications to the privacy policy become effective, you
    have agreed to these modifications. You acknowledge that if you do not agree
    to any such modification, you may terminate this Agreement by providing us
    with notice in accordance with Section 25 below. We will not refund any fees
    paid by you if you terminate your Agreement with us. We will not process the
    personal information that we collect from you in a way incompatible with the
    purposes and other limitations described in our privacy policy, and we will
    take reasonable precautions to protect your personal information from loss,
    misuse and unauthorized access, disclosure, alteration or destruction.{' '}
  </p>
  <p>
    <strong>8. THIRD PARTY INFORMATION</strong> You represent and warrant that
    you have provided notice to, and obtained consent from, any third party
    individuals whose personal information you supply to us as part of our
    services with regard to:{' '}
  </p>
  <blockquote>
    <p>
      8.1 the purposes for which such third party&#39;s personal information has
      been collected;
    </p>
    <p>
      8.2 the intended recipients or categories of recipients of the third
      party&#39;s personal information;{' '}
    </p>
    <p>
      8.3 which parts of the third party&#39;s information are obligatory and
      which parts, if any, are voluntary; and{' '}
    </p>
    <p>
      8.4 how the third party can access and, if necessary, rectify the third
      party&#39;s personal information..{' '}
    </p>
  </blockquote>
  <p>
    You further agree to provide such notice and obtain such consent with regard
    to any third party personal information you supply to us in the future. We
    are not responsible for any consequences resulting from your failure to
    provide notice or receive consent from such individuals or for your
    providing outdated, incomplete or inaccurate information.{' '}
  </p>
  <p>
    <strong>9. MODIFICATIONS TO AGREEMENT</strong> Except as otherwise provided
    in this Agreement, you agree, during the term of this Agreement, that we
    may:{' '}
  </p>
  <blockquote>
    <p>
      9.1 revise the terms and conditions of this Agreement at any time;
      and/or{' '}
    </p>
    <p>9.2 change the services provided under this Agreement at any time.</p>
  </blockquote>
  <p>
    Any such revision or change will be binding and effective ten (10) calendar
    days after the revised Agreement or change to the service(s) is posted on{' '}
    <Metadata name="title" mdxType="Metadata" />
    &#39;s Web site, or upon notification to you in accordance with Section 25 below.
    You agree to periodically review our Web site, including the current version
    of this Agreement available on our Web site, to be aware of any such revisions.
    If you do not agree with any revision to the Agreement or change to the services,
    you may terminate this Agreement at any time by providing us with notice in accordance
    with Section 25 below. Notice of your termination will be effective on receipt
    and processing by us. Any fees paid by you prior to termination of your Agreement
    with us are nonrefundable, and you will not incur any additional fees. By continuing
    to use <Metadata name="title" mdxType="Metadata" />
    &#39;s services ten (10) calendar days after any revision to this Agreement
    or change in service(s) is posted on our Web site, you agree to abide by and
    be bound by any such revisions or changes. We are not bound by and you may
    not rely on any representation concerning this Agreement or our services
    made by:{' '}
  </p>
  <blockquote>
    <p>
      a. any agent, representative or employee of any third party that you may
      use to apply for our services; and/or
    </p>
    <p>
      b. information posted on our Web site of a general informational nature.
      No employee, contractor, agent or representative of{' '}
      <Metadata name="title" mdxType="Metadata" /> is authorized to alter or amend the terms and
      conditions of this Agreement.{' '}
    </p>
  </blockquote>
  <p>
    <strong>10. MODIFICATIONS TO YOUR ACCOUNT</strong> In order to change any
    of your account information with us, you must use the account number and the
    password or passphrase that was provided to you by <Metadata name="title" mdxType="Metadata" />
    . Please safeguard your account number and password or any security
    authentication option from any unauthorized use. In no event will we be
    liable for the unauthorized use or misuse of your account number and
    password or passphrase.{' '}
  </p>
  <p>
    <strong>11. AGENTS</strong> You agree that, if your agent purchased our
    service(s) on your behalf, you are nonetheless bound as a principal by all
    terms and conditions herein, including the ICANN UDRP, ICANN URS and the
    Dispute Policy, whether your agent was authorized by you or not. You certify
    that your agent is authorized to apply for our services on your behalf, that
    he or she is authorized to bind you to the terms and conditions of this
    Agreement and that he or she has apprised you of the terms and conditions of
    this Agreement. In addition, you are responsible for any errors made by your
    agent. We will not refund any fees paid by you or your agent on your behalf
    for any reason based on any act or omission of your agent.{' '}
  </p>
  <p>
    <strong>12. NOTICES AND ANNOUNCEMENTS</strong> You authorize us to notify
    you electronically, as our Customer, of information that we deem is of
    potential interest to you. Notices and announcements may include commercial
    emails and other notices describing changes, upgrades, new products and
    services or other information pertaining to domain names, Internet security
    or to enhance your identity on the Internet and/or other relevant matters.
    If you do not wish to receive bulk email solicitation notices or
    announcements please send us an email at{' '}
    <Metadata addr="service" name="mailLink" mdxType="Metadata" />.{' '}
  </p>
  <p>
    <strong>13. LIMITATION OF LIABILITY</strong> To the maximum extent
    permitted at law, <Metadata name="title" mdxType="Metadata" />, its parent, subsidiary,
    affiliated companies, and/or companies under common control, and/or their
    respective owners, beneficial owners, directors, officers, shareholders,
    employees, contractors, agents, partners, affiliates, successors and assigns
    shall not be liable for any direct, indirect, incidental, special or
    consequential damages resulting from your use or inability to use any of the{' '}
    <Metadata name="title" mdxType="Metadata" /> services or for the cost of procurement of
    substitute services. Moreover, <Metadata name="title" mdxType="Metadata" />
    &#39;s suppliers, service providers, and/or their respective owners, beneficial
    owners, directors, officers, shareholders, employees, contractors, agents, partners,
    affiliates, successors and assigns, shall not be liable for any direct, indirect,
    incidental, special or consequential damages resulting from your use or inability
    to use any of the <Metadata name="title" mdxType="Metadata" /> services or for the cost of procurement
    of substitute services. We collectively expressly disclaim any and all loss or
    liability resulting from, but not limited to:{' '}
  </p>
  <blockquote>
    <p>13.1 any failure or inability to register the domain name;</p>
    <p>
      13.2 any third party claims arising from or based on your domain name or
      use of our services;
    </p>
    <p>13.3 access delays or access interruptions;</p>
    <p>13.4 data non-delivery or data mis-delivery;</p>
    <p>13.5 acts of God;</p>
    <p>
      13.6 the unauthorized use or misuse of your account number or password or
      passphrase;
    </p>
    <p>
      13.7 errors, omissions, or misstatements in any and all information or
      service(s) provided under this Agreement;
    </p>
    <p>13.8 the deletion of or failure to store email messages;</p>
    <p>13.9 the development or interruption of your Web site;</p>
    <p>
      13.10 our processing of your application for our services, our processing
      of any authorized modification to your domain name record or your agents
      failure to pay any fees, including the initial registration fee or
      re-registration fee; or
    </p>
    <p>
      13.11 the application of the ICANN UDRP, ICANN URS or the Dispute
      Policy.{' '}
    </p>
  </blockquote>
  <p>
    You agree that our entire liability, and your exclusive remedy, with respect
    to any <Metadata name="title" mdxType="Metadata" /> service(s) provided under this Agreement
    and/or for any breach of this Agreement is solely limited to the amount you
    paid for such service(s).{' '}
  </p>
  <p>
    <strong>14. INDEMNITY</strong> You agree to release, indemnify, and hold{' '}
    <Metadata name="title" mdxType="Metadata" /> and its parent, subsidiary, affiliated companies,
    and/or companies under common control, and their respective owners,
    beneficial owners, directors, officers, shareholders, employees,
    contractors, agents, partners, affiliates, successors and assigns - as well
    as <Metadata name="title" mdxType="Metadata" />
    &#39;s suppliers or service providers, or their respective owners, beneficial
    owners, directors, officers, shareholders, employees, contractors, agents, partners,
    affiliates, successors and assigns harmless from all liabilities, claims, damages,
    costs and expenses, including reasonable attorneys&#39; fees and expenses, relating
    to or arising from your domain name registration or use of your domain name or
    the <Metadata name="title" mdxType="Metadata" /> services provided hereunder. When we are threatened
    with suit or sued by a third party, we may seek written assurances from you concerning
    your promise to indemnify us. Your failure to provide those assurances may be
    considered by us to be a material breach of this Agreement. In the event we are
    made a party to any claim, suit or action by you which is unsuccessful or by
    a third party in each case relating to or arising from your domain name registration
    or use of your domain name or the <Metadata name="title" mdxType="Metadata" /> services provided
    hereunder, you will reimburse us, at a reasonable rate, for all personnel time
    and expenses expended by us in response to such claim, suit or action including
    without limitation, all attorney fees and expenses incurred by us with respect
    to such response.
  </p>
  <p>
    In addition, you agree to indemnify and hold harmless the applicable
    registry operator and its owners, beneficial owners, directors, officers,
    shareholders, employees and agents from and against any and all claims,
    damages, liabilities, costs and expenses (including reasonable legal fees
    and expenses) arising out of or related to your domain name registration.
  </p>
  <p>
    <strong>15. BREACH</strong> You agree that your failure to abide by any
    provision of this Agreement, any <Metadata name="title" mdxType="Metadata" /> operating rule or
    policy, the ICANN UDRP, ICANN URS or the Dispute Policy may be considered by
    us to be a material breach of this Agreement and that we may provide to you
    a written notice in accordance with Section 25 below, describing the breach,
    to you. If within ten (10) calendar days of the date of such notice, you
    fail to provide evidence, which is reasonably satisfactory to us, that you
    have not breached your obligations under the Agreement, then we may delete
    the registration or reservation of your domain name, transfer the domain
    name to <Metadata name="title" mdxType="Metadata" /> and/or terminate the other{' '}
    <Metadata name="title" mdxType="Metadata" /> service(s) you are using without further notice.
    We will not refund any fees paid by you prior to the termination of your
    Agreement due to your breach. Any such breach by you shall not be deemed to
    be excused simply because we did not act earlier in response to that, or any
    other breach, by you.{' '}
  </p>
  <p>
    <strong>16. REPRESENTATIONS AND WARRANTIES</strong> You agree and warrant
    that:{' '}
  </p>
  <blockquote>
    <p>
      16.1 the information that you or your agent on your behalf provide to us
      during the application process to register your domain name or to apply
      for other <Metadata name="title" mdxType="Metadata" />
      &#39;s service(s) is, accurate and complete, and that any future changes to
      this information will be provided to us in a timely manner;
    </p>
    <p>
      16.2 to the best of your knowledge and belief that neither the
      registration of your domain name nor the manner in which you intend to use
      such domain name will directly or indirectly infringe the legal rights of
      any third party;
    </p>
    <p>
      16.3 you have all requisite power and authority to execute this Agreement
      and to perform your obligations hereunder;
    </p>
    <p>
      16.4 you have selected the necessary security option(s) for your domain
      name registration record; and
    </p>
    <p>
      16.5 you are of legal age of 18 years or over to enter into this
      Agreement.{' '}
    </p>
  </blockquote>
  <p>
    You agree that your use of our service(s) is solely at your own risk. You
    agree that all of our services are provided on an &#34;as is,&#34; and
    &#34;as available&#34; basis.{' '}
  </p>
  <p>
    <strong>17. DISCLAIMER</strong> WE EXPRESSLY DISCLAIM ALL CONDITIONS,
    WARRANTIES AND REPRESENTATIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
    INCLUDING BUT NOT LIMITED TO THE IMPLIED CONDITIONS AND WARRANTIES OF
    MERCHANTABLE QUALITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
    WE MAKE NO WARRANTY OR REPRESENTATION THAT OUR SERVICE(S) WILL MEET YOUR
    REQUIREMENTS, OR THAT THE SERVICE(S) WILL BE UNINTERRUPTED, TIMELY, SECURE,
    OR ERROR FREE; NOR DO WE MAKE ANY WARRANTY AS TO THE RESULTS THAT MAY BE
    OBTAINED FROM THE USE OF THE SERVICE(S) OR AS TO THE ACCURACY OR RELIABILITY
    OF ANY INFORMATION OBTAINED THROUGH OUR SERVICE. YOU UNDERSTAND AND AGREE
    THAT ANY MATERIAL AND/OR DATA DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE
    USE OF OUR SERVICE IS DONE AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL
    BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA
    THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL AND/OR DATA. WE MAKE NO
    WARRANTY OR REPRESENTATION REGARDING ANY GOODS OR SERVICES PURCHASED OR
    OBTAINED THROUGH ANY OF OUR SERVICES OR ANY TRANSACTIONS ENTERED INTO
    THROUGH SUCH SERVICES. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN,
    OBTAINED BY YOU FROM US SHALL CREATE ANY CONDITION OR WARRANTY NOT EXPRESSLY
    MADE HEREIN. TO THE EXTENT JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF
    CERTAIN WARRANTIES, SOME OF THE ABOVE EXCLUSIONS MAY NOT APPLY TO YOU.{' '}
  </p>
  <p>
    <strong>18. RIGHT OF REFUSAL</strong> We, in our sole discretion, reserve
    the right to:{' '}
  </p>
  <blockquote>
    <p>
      18.1 refuse to register or renew your chosen domain name or register or
      renew you for other <Metadata name="title" mdxType="Metadata" /> service(s); and/or
    </p>
    <p>
      18.2 cancel or terminate your domain name registration, domain name
      renewal and/or any other services provided by us, at any time and for any
      reason; in such event, we will refund any applicable fee(s) you have paid,
      less applicable administration fees.
    </p>
  </blockquote>
  <p>
    You agree that we shall not be liable to you for loss or damages that may
    result from our refusal to register your domain name, the deletion your
    domain name or our refusal to register you for other{' '}
    <Metadata name="title" mdxType="Metadata" /> service(s).{' '}
  </p>
  <p>
    <strong>19. SEVERABILITY</strong> You agree that the terms of this
    Agreement are severable. If any term or provision is declared invalid or
    unenforceable, that term or provision will be construed consistent with
    applicable law as nearly as possible to reflect the original intentions of
    the parties, and the remaining terms and provisions will remain in full
    force and effect.{' '}
  </p>
  <p>
    <strong>20. ENTIRETY</strong> You agree that this Agreement, the rules and
    policies published by us, the ICANN UDRP, ICANN URS, the Dispute Policy and
    the privacy statement are the complete and exclusive agreement between you
    and us regarding our services. This Agreement, our rules and policies, the
    ICANN UDRP, ICANN URS, the Dispute Policy and the privacy statement
    supersede all prior agreements, representations and understandings, whether
    established by custom, practice, policy or precedent.{' '}
  </p>
  <p>
    <strong>21. NON-ASSIGNMENT</strong> Your rights under this Agreement are
    not assignable. Any attempt by you to assign your rights shall render this
    Agreement voidable at our option. Any attempt by your creditors to obtain an
    interest in your rights under this Agreement, whether by attachment,
    garnishment or otherwise, shall render this Agreement voidable at our
    option.{' '}
  </p>
  <p>
    <strong>22. GOVERNING LAW</strong> You agree that this Agreement and any
    disputes hereunder shall be governed in all respects by and construed in
    accordance with the laws of the Turks & Caicos Islands, excluding its
    conflict of laws rules. You and we each submit to exclusive subject matter
    jurisdiction, personal jurisdiction and venue of the Turks & Caicos Islands.
  </p>
  <p>
    <strong>23. WAIVER OF CLASS ACTIONS; ARBITRATION</strong>
  </p>
  <p>
    23.1 Binding Arbitration. You and <Metadata name="title" mdxType="Metadata" /> acknowledge that
    any statutory or common law claims related to intellectual property may
    require forms of equitable relief that are best administered by courts;
    accordingly, you and <Metadata name="title" mdxType="Metadata" /> agree that, except for i)
    statutory or common law claims related to intellectual property, and ii) any
    claims that may be brought in small claims court where the amount in
    controversy is properly within the jurisdiction of such court (collectively,
    “Excluded Claims”), any controversy or claim arising out of or relating to
    this Agreement, your relationship to <Metadata name="title" mdxType="Metadata" /> as a
    Customer, or your use of any of <Metadata name="title" mdxType="Metadata" /> services and/or
    services provided by its parent, subsidiary, entity under common control
    and/or entity owned by the same beneficial owner, whether based in contract,
    tort, statute, fraud, misrepresentation or any other legal theory (the
    “Covered Claims”), will be resolved by binding, individual arbitration. YOUR
    AGREEMENT TO ARBITRATION MEANS THAT FOR ALL COVERED CLAIMS, YOU ARE GIVING
    UP YOUR RIGHT TO FILE A LAWSUIT IN COURT AND THE RIGHT TO A TRIAL BY JURY.
    INSTEAD, YOU WILL HAVE A HEARING BEFORE A NEUTRAL ARBITRATOR.
  </p>
  <p>
    23.2 WAIVER OF CLASS ACTIONS. YOU AND{' '}
    <span style={{
          textTransform: 'uppercase'
        }}>
      <Metadata name="title" mdxType="Metadata" />
    </span>{' '}
    AGREE THAT EACH PARTY MAY BRING DISPUTES RELATING TO BOTH COVERED CLAIMS AND
    EXCLUDED CLAIMS AGAINST THE OTHER PARTY ONLY IN AN INDIVIDUAL CAPACITY, AND
    NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE
    PROCEEDING, INCLUDING, WITHOUT LIMITATION, A FEDERAL OR CLASS ACTION LAWSUIT
    OR A CLASS ARBITRATION.
  </p>
  <p>
    23.3. Conduct of Arbitration; Governing Rules. Any arbitration shall be
    submitted exclusively to final and binding arbitration. The parties agree
    the arbitration shall be governed by the International Centre for Dispute
    Resolution in accordance with its International Arbitration Rules. The
    parties agree that three (3) arbitrators shall preside – each party will
    select an arbitrator and those two arbitrators will select the third. The
    arbitration shall be held in the Turks & Caicos Islands unless three (3)
    arbitrators are not available in the Turks & Caicos Islands and then in such
    case, the parties agree that arbitration shall be held in the United Kingdom
    but in any event, Turks & Caicos law shall govern.
  </p>
  <p>
    The arbitrators shall have the power to decide any motions brought by either
    party to the arbitration, including motions requesting that a judgment be
    awarded on any claims raised in arbitration. The arbitrators shall be
    empowered to award any appropriate relief, including remedies at law, in
    equity or injunctive relief (including a temporary restraining order). The
    arbitrators may award either party any remedy to which that party is
    entitled under applicable law, but such remedies shall be limited to those
    that would be available to a party in a court of law for the claims
    presented to and decided by the arbitrators. The arbitrators will issue a
    decision or award in writing, stating the essential findings of fact and
    conclusions of law. A court of competent jurisdiction shall have the
    authority to enter a judgment upon the award made pursuant to the
    arbitration proceeding.
  </p>
  <p>
    All issues are for the arbitrator to decide, except those issues relating to
    the scope, application, and enforceability of the arbitration
    provision–including whether any claims are Covered Claims or Excluded Claims
    within the meaning of this provision–are for the court to decide. As stated
    in Section 22, Turks & Caicos law applies to any arbitration under this
    section.
  </p>
  <p>
    Prior to initiating arbitration for a Covered Claim, both parties agree that
    they will provide individualized written notice of the potential claim to
    the opposing party setting forth: (1) the factual and legal basis for the
    claim; (2) contact information for the potential claimant and their counsel,
    if any; and (3) the remedies sought, including the amount of claimed
    monetary damages (the “Notice”). Following receipt of the Notice by the
    opposing party, the parties agree to make a good faith effort for at least
    30 days to resolve the claim before resorting to more formal means of
    resolution, including, without limitation, arbitration or any court action.
    To provide notice of a claim to us, send it both via email to
    legal@rebel.com and in writing to Rebel Ltd. Attn: Legal Department , P.O.
    Box 209, Chancery Court, Leeward Highway, Providenciales, Turks and Caicos
    Islands, TCKA 1ZZ.
  </p>
  <p>
    Payment of all filing, administration, and arbitrator fees will be governed
    by the International Centre for Dispute Resolution Rules, except that if the
    arbitrator finds at any time that a claim was filed frivolously, for
    purposes of harassment, or otherwise in bad faith, then the filing party
    will reimburse the other party for all costs and fees, including
    attorneys&#39; fees, associated with that claim.
  </p>
  <p>
    Judgment on the award rendered by the arbitrator may be entered in any court
    of competent jurisdiction located in the Turks & Caicos Islands. The
    arbitrator may award money or equitable relief in favor of only the
    individual party seeking relief and only to the extent necessary to provide
    relief warranted by that party&#39;s individual claim. To reduce the time
    and expense of the arbitration, the arbitrator will not provide a statement
    of reasons for his or her award unless requested to do so by both parties.
  </p>
  <p>
    23.4 For all litigation regarding Excluded Claims and any other controversy
    or claim for which arbitration is denied, the sole jurisdiction and venue
    for such litigation will be an appropriate court located in the Turks &
    Caicos Islands.
  </p>
  <p>
    23.5 All provisions of this Dispute Resolution – Arbitration and Waiver of
    Class Actions Section will survive termination of this Agreement, your
    relationship with us, and/or your account or profile.
  </p>
  <p>
    <strong>24. AGREEMENT TO BE BOUND</strong> By applying for the service(s)
    of <Metadata name="title" mdxType="Metadata" /> or an affiliated site or service on or through
    our online application process or by applying for and registering a domain
    name using the service(s) provided by <Metadata name="title" mdxType="Metadata" />, its
    affiliates, entities under common control and/or entities owned by the same
    beneficial owner, you acknowledge that you have read and agree to be bound
    by all terms and conditions of this Agreement, the ICANN UDRP, ICANN URS the
    Dispute Policy and any pertinent rules or policies that are or may be
    published by <Metadata name="title" mdxType="Metadata" /> or ICANN. In addition, if you are
    registering other top level or country-code domain names (including, but not
    limited to .AU, .BIZ, .EU, .ORG, and/or other domain names) or any
    additional services, you have read and agree to the terms and conditions of
    those provisions.
  </p>
  <p>
    <strong>25. NOTICES</strong> All notices to be provided under this
    Agreement to the other shall be validly given if sent by email, personal or
    courier delivery or by ordinary mail as follows:{' '}
  </p>
  <blockquote>
    <p>
      25.1 to <Metadata name="title" mdxType="Metadata" />: via email sent to legal@rebel.com and
      in writing sent to Rebel Ltd. Attn: Legal Department , P.O. Box 209,
      Chancery Court, Leeward Highway, Providenciales, Turks and Caicos Islands,
      TCKA 1ZZ
    </p>
    <p>
      25.2 to Customer: via email to the e-mail address you provided us as the
      primary account contact. You agree that all notices, disclosures, and
      other communications we provide you electronically satisfy any legal
      requirement that such communications be in writing. You agree that you can
      store such electronic communications such that they remain accessible to
      you in an unchanged form.{' '}
    </p>
  </blockquote>
  <p>
    Confirmation of annual billing for domains will be received by email to the
    primary account contact. Around the time of cancellation due to user
    request, failed payment, or for any other reason a domain is cancelled, the
    owned customer will receive two notification emails (a month and a week
    prior to expiry date) to their primary email address. The customer will also
    receive another notification email after one week of the expiry date.
  </p>
  <p>
    <strong>26. TIME CALCULATIONS</strong> <Metadata name="title" mdxType="Metadata" /> operates
    in accordance with Greenwich Mean Time (GMT). Any and all references to
    timing in this Agreement, and all schedules and appendices hereto, are to be
    interpreted in accordance with GMT.
  </p>
  <p>
    <strong>27. INCORPORATION BY REFERENCE</strong> EACH REGISTRY FOR DOMAIN
    NAMES AND CERTAIN OTHER SERVICE PROVIDERS WHO SUPPLY CERTAIN{' '}
    <Metadata name="title" mdxType="Metadata" /> CORP. SERVICES OFFERED BY{' '}
    <Metadata name="title" mdxType="Metadata" /> CORP. TO YOU, REQUIRE US TO INCORPORATE CERTAIN
    TERMS AND CONDITIONS INTO OUR AGREEMENT WITH YOU, AS SET FORTH BELOW.{' '}
  </p>
  <p>
    ALL SUCH TERMS, AND ALL OF THE OTHER SCHEDULES ATTACHED TO THESE MAIN TERMS
    AND CONDITIONS, ARE INCORPORATED BY REFERENCE INTO THIS AGREEMENT AND APPLY
    TO YOUR DOMAIN NAME(S) AND ANY APPLICABLE <Metadata name="title" mdxType="Metadata" /> CORP.
    SERVICES PURCHASED BY YOU, AND YOU AGREE TO BE BOUND BY THEM.
  </p>
  <p>
    <strong>28. SURVIVAL</strong> In the event this Agreement terminates as
    provided herein, Sections 1, 3, 4, 11, 13, 14, 17, 20, 21, 22, 23, 24, 25,
    26, 27 and 28 of this Agreement, and all releases, indemnities, waivers and
    disclaimers set forth in any Schedule annexed hereto, shall survive such
    expiration or termination.
  </p>
  <p>
    <strong>29. CANCELLED DOMAINS</strong> Domains can be cancelled following
    the user&#39;s cancellation request, or by us due to payment failure, a
    violation of our Terms of Use or a delinquent account.
  </p>
  <p>
    29.1 A recovery fee of USD$5.00 will be charged to recover domains in
    cancelled status (available for 30 days after a domain has been
    cancelled).{' '}
  </p>
  <p>
    29.2 To recover domains in a &#34;Redemption Grace Period&#34; status, there
    is an additional recovery fee of USD$50.00 for each .CA domain, and
    USD$100.00 for any other domains in other TLDs.{' '}
  </p>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulea">
    <a href="#schedulea" name="schedulea">
      Schedule A
    </a>
    : Terms and Conditions Relating to Domain Name Registration
  </h2>
  <p>
    <strong>1. NO GUARANTY</strong> You agree that, the registration of your
    chosen domain name does not confer immunity from objection to either the
    registration or use of your domain name.
  </p>
  <p>
    <strong>2 SECURITY</strong> <Metadata name="title" mdxType="Metadata" /> does not guarantee
    the security of your domain name registration records, and you assume all
    risks that the password and/or passphrase you select may be compromised as a
    result of fraudulent, unauthorized or illegal use.
  </p>
  <p>
    <strong>3. TRANSFERS</strong> You agree that you may not transfer your
    domain name registration to another domain name registrar during the first
    sixty (60) days from the effective date of your initial domain name
    registration with us (except for .au and .name domain names).{' '}
  </p>
  <p>
    <strong>4. LICENSING OF DOMAIN NAME</strong> You hereby acknowledge and
    agree that if you license use of your domain name to a third party you
    nonetheless remain the registrant of record and are responsible for
    providing your own full contact information and for providing and updating
    accurate technical and administrative contact information adequate to
    facilitate timely resolution of any problems that arise in connection with
    the domain name. If you are licensing use of a domain name you hereby accept
    liability for harm caused by wrongful use of the domain name, unless you
    disclose the identity of the licensee within seven (7) days to the party
    providing reasonable evidence of actionable harm.{' '}
  </p>
  <p>
    <strong>5. PROVISION OF REGISTRATION DATA</strong> As part of the
    registration process, you are required to provide us with certain
    information and to update this information and correct and update them
    within seven (7) days of any change during the term of the registration.
    This information includes: the full name, postal address, e-mail address,
    voice telephone number, and fax number if available of the Registered Name
    Holder; name of authorized person for contact purposes in the case of an
    Registered Name Holder that is an organization, association, or corporation;
    the names of the primary nameserver and secondary nameserver(s) of the
    registered name; The name, postal address, e-mail address, voice telephone
    number, and (where available) fax number of the technical contact for the
    registered name; and the name, postal address, e-mail address, voice
    telephone number, and (where available) fax number of the administrative
    contact for the registered name.{' '}
  </p>
  <p>
    Willful provision of inaccurate or unreliable information, its willful
    failure promptly to update information provided within seven (7) days of any
    change, or its failure to respond for over fifteen (15) calendar days to
    inquiries concerning the accuracy of contact details associated with the
    registration shall constitute a material breach and be a basis for
    suspension and/or cancellation of the registration.{' '}
  </p>
  <p>
    <strong>6. USE OF INFORMATION</strong>
  </p>
  <blockquote>
    <p>
      6.1 In accordance with our privacy statement, which can be found at{' '}
      <Metadata name="link" path="/privacy-policy" mdxType="Metadata" />, and in order for us to
      comply with the current rules and policies of the domain name system, you
      hereby grant <Metadata name="title" mdxType="Metadata" /> the right to disclose to the public
      the following mandatory information that you are required to provide when
      registering or reserving a domain name:{' '}
    </p>
    <blockquote>
      <p>6.1.1 the domain name(s) registered by you;</p>
      <p>6.1.2 your name and postal address; </p>
      <p>
        6.1.3 the name(s), postal address(es), email address(es), voice
        telephone number(s) and where available the fax number(s) of the
        technical and administrative contacts for your domain name(s);
      </p>
      <p>
        6.1.4 the Internet protocol numbers of the primary nameserver and
        secondary nameserver(s) for such domain name(s);
      </p>
      <p>6.1.5 the corresponding names of those nameserver(s);</p>
      <p>6.1.6 the original creation date of the registration; and</p>
      <p>6.1.7 the domain&#39;s expiry date</p>
    </blockquote>
    <p>
      6.2 In addition, we are required to make this information available in
      bulk form to third parties who agree not to use it to (a) allow, enable or
      otherwise support the transmission of mass unsolicited, commercial
      advertising or solicitations via email (spam) or (b) enable high volume,
      automated, electronic processes that apply to our systems to register
      domain names.{' '}
    </p>
  </blockquote>
  <p>
    <strong>7. DOMAIN NAME DISPUTE POLICY</strong> If you reserved or
    registered a domain name through us, you agree to be bound by ICANN&#39;s
    Uniform Domain-Name Dispute-Resolution Policy (the &#34;ICANN UDRP&#34; and
    others as applicable), ICANN&#39;s Uniform Rapid Suspension Policy (the
    “ICANN URS” and others as applicable) that are incorporated herein and made
    a part of this Agreement by reference. The current version of the ICANN UDRP
    may be found at ICANN&#39;s Web site:{' '}
    <a href="http://www.icann.org/udrp/udrp.htm" rel="noreferrer" target="_blank">
      http://www.icann.org/udrp/udrp.htm
    </a>
    . The current version of the ICANN URS may be found at ICANN&#39;s Web site:{' '}
    <a href="https://www.icann.org/urs-en" rel="noreferrer" target="_blank">
      https://www.icann.org/urs-en
    </a>. Please take the time to familiarize yourself with those policies.{' '}
  </p>
  <p>
    <strong>8. DOMAIN NAME DISPUTES</strong> You agree that, if your use of our
    domain name registration services is challenged by a third party, you will
    be subject to the provisions specified in the <Metadata name="title" mdxType="Metadata" />{' '}
    dispute policy (the &#34;Dispute Policy&#34;) in effect at the time of the
    dispute.{' '}
  </p>
  <p>The Dispute Policy is currently as follows:</p>
  <p>
    Notwithstanding anything in this Agreement to the contrary, you agree that
    in the event a domain name dispute arises with any third party, (i) you will
    submit, without prejudice to other potentially applicable jurisdictions, to
    the jurisdiction of the courts of your domicile and the Turks & Caicos
    Islands and (ii) you will indemnify and hold us harmless pursuant to the
    terms and conditions set forth below in this Agreement. If we are notified
    that a complaint has been filed with a judicial or administrative body
    regarding your domain name registration or your use of our domain name
    registration services, you will not be permitted to make any changes to your
    domain name record without our prior approval. We will not allow you to make
    changes to such domain name record until:
  </p>
  <blockquote>
    <p>
      8.1 we are directed to do so by the judicial or administrative body, or
    </p>
    <p>
      8.2 we receive written notification by you and the other party contesting
      your registration or use of our domain name registration services that the
      dispute has been settled.{' '}
    </p>
  </blockquote>
  <p>
    Furthermore, you agree that if we and/or you are subject to litigation
    regarding your registration or use of our domain name registration services,
    we may deposit control of your domain name record into the registry of the
    judicial or administrative body by supplying a party with a registrar
    certificate from us.{' '}
  </p>
  <p>
    <strong>9. DOMAIN NAME DISPUTE POLICY MODIFICATIONS</strong> You agree that
    we, in our sole discretion, may modify our Dispute Policy. We will post any
    such revised policy on our Web site at least thirty (30) calendar days
    before it becomes effective. You agree to periodically review our Web Site
    to be aware of such revisions. You agree that, by maintaining the
    reservation or registration of your domain name after modifications to the
    Dispute Policy become effective, you have agreed to these modifications. You
    acknowledge that if you do not agree to any such modification, you may
    terminate this Agreement by providing written notice to us in accordance
    with Section 25 under the Main Terms and Conditions. We will not refund any
    fees paid by you if you terminate your Agreement with us.{' '}
  </p>
  <p>
    <strong>10. CANCELLED DOMAINS</strong> You agree that we may, but are not
    obligated to, bill you annually for a domain that you have registered until
    you cancel the domain. You agree to cancel a domain when you no longer wish
    to have that domain registered. You agree that no refunds will be issued for
    domains cancelled prior to their annual billing date. A domain will be
    cancelled immediately following your cancellation request. Should you cancel
    your domain name, you agree that you have 30 days to recover your cancelled
    domain, after which time we will, in our sole discretion, delete the domain
    registration, renew the registration or transfer the domain name to a third
    party on your behalf (the &#34;Transfer&#34;). A domain name can be deleted
    in our sole discretion at any time if it violates our Terms or Use or after
    it is cancelled by the user. When possible we will offer a 30 day user
    recovery period. An additional 30 day Recovery Grace Period (RGP) may be
    available for some domains. In To recovery a domain in RGP period, you agree
    to contact customer service and to pay the RGP Recovery Fee in addition to
    the annual domain fee. In the event we are able to identify a third party
    (&#34;Third Party&#34;) and Transfer a cancelled domain, we will notify you
    via email after the transaction is completed (&#34;Transfer
    Notification&#34;). You acknowledge and agree that the Transfer may be
    facilitated through a single Third Party, or through an auction involving
    one or more parties interested in your domain name. You agree that we shall
    have no obligation to pay you, and you shall have no right to receive, any
    percentage of the proceeds of the Transfer. We cannot guarantee, and we make
    no representation or promise, that any Transfer will occur with respect to
    your domain name.
  </p>
  <p>
    <strong>11. NEW CUSTOMERS THROUGH AN AFTERMARKET SERVICE PROVIDER</strong>{' '}
    If you are registering a domain name through an aftermarket service provider
    and that domain was registered with, and not yet deleted by,{' '}
    <Metadata name="title" mdxType="Metadata" /> at the time of your purchase, you acknowledge and
    agree that the term of your registration will be for a period of one year
    from the original expiration date for the domain name immediately prior to
    your purchase, as the registration is the result of a Transfer (as defined
    in section 9). If you are registering a domain name through an aftermarket
    service provider and the domain name was not registered with{' '}
    <Metadata name="title" mdxType="Metadata" /> at the time of your purchase but was deleted by
    the applicable top-level domain registry at the time of your purchase, you
    acknowledge and agree that the term of your registration will be for a
    period of one year from the date it is initially registered with{' '}
    <Metadata name="title" mdxType="Metadata" /> by the provider of the backorder service.
  </p>
  <p>
    <strong>12. PARKED AND COMING SOON PAGES FOR ACTIVE DOMAINS</strong> You
    acknowledge and agree that any and all domain names that are (i) registered
    with <Metadata name="title" mdxType="Metadata" />, (ii) hosted by a third party through{' '}
    <Metadata name="title" mdxType="Metadata" /> as part of a Subscription Service, and (iii) do
    not otherwise resolve to an active website, may resolve to a &#34;coming
    soon&#34; or similar temporary web page (&#34;Coming Soon Page&#34;), and
    that <Metadata name="title" mdxType="Metadata" /> may place on any such Coming Soon Page
    promotions, advertisements and other information for, and links to,{' '}
    <Metadata name="title" mdxType="Metadata" />
    &#39;s website, <Metadata name="title" mdxType="Metadata" />
    &#39;s product and service offerings, third party websites, third party
    product and service offerings and/or Internet search engines. You agree that{' '}
    <Metadata name="title" mdxType="Metadata" /> may change the content and/or appearance of, or
    disable, any Coming Soon Page at any time, in its sole discretion, and
    without prior notice. You agree that any and all revenue generated from such
    a Coming Soon Page enures to the benefit of <Metadata name="title" mdxType="Metadata" />. You
    may discontinue use of the Coming Soon Page for your registered domain at
    any time by logging into your account and making such changes.
  </p>
  <p>
    <strong>13. PARKED AND RESTORATION PAGES FOR DELETED DOMAINS</strong> You
    agree that after you have cancelled a domain we may direct your domain name
    to an IP address designated by us, including, without limitation, an IP
    address which hosts a Restore domain landing page, or a temporary page
    (&#34;Coming Soon Page&#34;) that may include promotions, advertisements and
    other information for, and links to, <Metadata name="title" mdxType="Metadata" />
    &#39;s website, <Metadata name="title" mdxType="Metadata" />
    &#39;s product and service offerings, third party websites, third party
    product and service offerings and/or Internet search engines, and you agree
    that we may place our contact information in the WHOIS or RDAP output for the
    cancelled domain. You agree that <Metadata name="title" mdxType="Metadata" /> may change the
    content and/or appearance of, or disable, any Domain Restoration or Coming
    Soon Page at any time, in its sole discretion, and without prior notice. You
    agree that any and all revenue generated from a temporary page belongs to{' '}
    <Metadata name="title" mdxType="Metadata" /> or such third party as designated by{' '}
    <Metadata name="title" mdxType="Metadata" />.
  </p>
  <p>
    In the case of a canceled or deleted CA domain we will not modify the
    domain&#39;s contact information and your domain&#39;s nameservers will not
    be changed.{' '}
  </p>
  <p>
    <strong>14. REVOCATION</strong> You agree that we may cancel or delete your
    domain name if the information that you provide to us or subsequently modify
    contains false or misleading information, or conceals or omits any
    information we would likely consider material to our decision to register
    your domain name or to continue to provide you domain name registration
    services. You agree that we may terminate immediately and without notice our
    service(s), including our domain name registration services, in the event
    that you use such service(s) for any improper purpose, as determined in our
    sole discretion. Furthermore, you agree that we may suspend, delete, cancel
    or transfer your domain name in order to:
  </p>
  <blockquote>
    <p>
      14.1 comply with any Specification or Policy, or any{' '}
      <Metadata name="title" mdxType="Metadata" /> or registry operator procedure not inconsistent
      with any Specification or Policy; or
    </p>
    <p>
      14.2 correct mistakes made by us or the registry in registering your
      chosen domain name; or{' '}
    </p>
    <p>
      14.3 resolve a dispute under the ICANN UDRP or the Dispute Policy. We will
      not refund any fees paid by you prior to termination of our services.{' '}
    </p>
  </blockquote>
  <p>
    <strong>15. SURVIVAL</strong> In the event this Agreement or Schedule
    terminates, Sections 3, 4, 5, 6, 7, 8, 9, 10 and 14 of this Schedule shall
    survive such expiration or termination.
  </p>
  <h2 id="scheduleb">
    <a href="#scheduleb" name="scheduleb">
      Schedule B
    </a>
    : Terms and Conditions applicable to <Metadata name="title" mdxType="Metadata" /> Corp. Email Services
  </h2>
  <p>
    The following terms and conditions of use and any amendments thereto (the
    &#34;Email Terms&#34;) apply to your access to, and use of, the email and
    related services offered by <Metadata name="title" mdxType="Metadata" /> (the &#34;Email
    Service&#34;). These Email Terms may be changed in the future without
    further notice, and your continued use of the Email Service following any
    such changes constitutes your acceptance of the new terms. These Email Terms
    do not alter in any way the non-conflicting terms or conditions of this
    Agreement or any other agreement you may have with <Metadata name="title" mdxType="Metadata" />{' '}
    for products, services or otherwise. To the extent any of the Email Terms
    are in conflict or inconsistent with any other term or condition of the
    Agreement, these Email Terms shall govern to the extent of the conflict or
    inconsistency.
  </p>
  <p>
    <strong>1. Privacy Policy</strong>
  </p>
  <p>
    In addition to the terms of the <Metadata name="title" mdxType="Metadata" /> privacy statement,
    you agree that <Metadata name="title" mdxType="Metadata" /> may access and disclose information
    about you or your use of the Email Service when <Metadata name="title" mdxType="Metadata" />{' '}
    deems necessary or appropriate to comply with the law or legal process, to
    protect <Metadata name="title" mdxType="Metadata" />
    &#39;s systems and customers, or to ensure the integrity and operation of <Metadata name="title" mdxType="Metadata" />
    &#39;s business and systems. Such disclosure may include, without
    limitation, user profile information (e.g., name, email address, etc.), IP
    address and traffic information, usage history, and posted content.{' '}
    <Metadata name="title" mdxType="Metadata" />
    &#39;s right to disclose any such information shall govern over any terms of{' '}
    <Metadata name="title" mdxType="Metadata" />
    &#39;s privacy statement.
  </p>
  <p>
    <strong>2. Access Restriction &amp; Password Security</strong>
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> reserves the right to deny in its sole discretion
    any user access to the Email Service or any portion thereof without notice.
    You are responsible for safeguarding the confidentiality of your password(s)
    and user name(s) issued to you by <Metadata name="title" mdxType="Metadata" />, and for any use
    or misuse of your account or the Email Service resulting from any third
    party using a password or user name issued to you.
  </p>
  <p>
    <strong>3. No &#34;Spamming&#34;</strong>
  </p>
  <p>
    You shall not use the Email Service for chain letters, junk mail,
    &#34;spamming&#34; or any use of distribution lists to any person who has
    not given specific permission to be included in such a process. An email
    advertisement which is (a) addressed to a recipient with whom the initiator
    does not have an existing business or personal relationship and (b) is not
    sent at the request of or with the express consent of the recipient to
    receive such communications from you (&#34;spam&#34; or &#34;spamming&#34;)
    is strictly prohibited by <Metadata name="title" mdxType="Metadata" />. If any user uses the
    Email Service for spamming, <Metadata name="title" mdxType="Metadata" /> reserves the right to
    immediately terminate that user&#39;s access to the Email Service and to
    seek appropriate legal recourse as necessary. If any user believes that
    others are using the Email Service for spam, please contact{' '}
    <Metadata name="title" mdxType="Metadata" /> at <Metadata addr="service" name="mailLink" mdxType="Metadata" />.
  </p>
  <p>
    <strong>4. User Conduct</strong>
  </p>
  <blockquote>
    <p>
      4.1 <Metadata name="title" mdxType="Metadata" /> reserves the right, but does not assume the
      responsibility, to monitor or review user conduct on the Email Service.
      Use of the Email Service is subject to all applicable local, state,
      provincial, federal and international laws and regulations. You agree: (1)
      to comply with applicable law regarding the transmission of technical data
      exported from the United States or Canada through the Email Service; (2)
      not to use the Email Service for illegal purposes; and (3) not to
      interfere or disrupt networks connected to the Email Service.
    </p>
    <p>4.2 In using the service, you agree not to:</p>
    <blockquote>
      <p>
        4.2.1. Harvest or otherwise collect information about others, including
        without limitation names and email addresses, without their consent;
      </p>
      <p>
        4.2.2. Transmit through the Email Service any unlawful, harassing,
        defamatory, abusive, threatening, harmful, vulgar, obscene, sexually
        explicit, or otherwise objectionable material of any kind or nature;
      </p>
      <p>
        4.2.3. Invade another&#39;s privacy or violate rights of publicity or
        intellectual property rights (including but not limited to copyright,
        trademark and patent rights) while using the Email Service;
      </p>
      <p>
        4.3.3. Transmit any material that encourages conduct that could
        constitute a criminal offense, give rise to civil liability or otherwise
        violate any applicable local, state, provincial, federal or
        international law or regulation;
      </p>
      <p>
        4.3.4. Interfere with another User&#39;s use and enjoyment of the Email
        Service or another entity&#39;s use and enjoyment of similar services;
      </p>
      <p>
        4.3.5. Advertise or offer to sell or buy any goods or services for any
        non-personal purpose;
      </p>
      <p>
        4.3.6. Transmit or upload any material that contains viruses, trojan
        horses, worms, time bombs, cancelbots, or any other harmful or
        deleterious programs;
      </p>
      <p>
        4.3.7. Interfere with or disrupt networks connected to the Email Service
        or violate the regulations, policies or procedures of such networks;
      </p>
      <p>
        4.3.8. Attempt to gain unauthorized access to the Email Service, other
        accounts, computer systems or networks connected to the Email Service,
        through password mining or any other means;
      </p>
      <p>
        4.3.9. Use or attempt to use another&#39;s account, service or system
        without authorization from <Metadata name="title" mdxType="Metadata" />, or create or use a
        false identity on this Email Service; or
      </p>
      <p>
        4.3.10. Engage in any other conduct which, in <Metadata name="title" mdxType="Metadata" />
        &#39;s sole discretion, is considered unauthorized or objectionable.
      </p>
    </blockquote>
  </blockquote>
  <p>
    <strong>5. Proprietary Rights</strong>
  </p>
  <blockquote>
    <p>
      5.1 You acknowledge and agree that any material, including but not limited
      to text, compilations, graphics, software, music, sound, photographs,
      video, or other material contained or distributed on or through the Email
      Service, by <Metadata name="title" mdxType="Metadata" />, its advertisers or other third
      parties (&#34;Content&#34;), is protected by copyrights, trademarks,
      service marks, patents or other proprietary rights and laws. You may not
      use or distribute any Content received through the Email Service without
      the authorization of the content owner, except for your personal,
      non-exclusive use. You agree not to modify, copy, reproduce, republish,
      upload, post, transmit, sell or distribute Content available through the
      Email Service, including code and software, in violation of applicable
      copyright and other intellectual property laws.
    </p>
    <p>
      5.2 WITHOUT LIMITING THE FOREGOING, COPYING OR REPRODUCTION OF THE{' '}
      <Metadata name="title" mdxType="Metadata" /> SOFTWARE TO ANY OTHER SERVER OR LOCATION FOR
      FURTHER REPRODUCTION OR REDISTRIBUTION IS EXPRESSLY PROHIBITED. YOU MAY
      NOT DECOMPILE, DISASSEMBLE, REVERSE ENGINEER OR OTHERWISE ATTEMPT TO
      DISCOVER ANY TRADE SECRET CONTAINED IN ANY SOFTWARE PROVIDED HEREUNDER.
    </p>
    <p>
      5.3 You acknowledge that the Software, and any accompanying documentation
      and/or technical information, is subject to applicable export control laws
      and regulations of the United States and Canada. You agree not to export
      or re-export the Software, directly or indirectly, to any countries that
      are subject to U.S. or Canadian export restrictions.
    </p>
  </blockquote>
  <p>
    <strong>6. Trademarks</strong>
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> and the <Metadata name="title" mdxType="Metadata" /> logo are
    trademarks of <Metadata name="title" mdxType="Metadata" />, and may not be copied, imitated or
    used, in whole or in part, without the prior written permission of{' '}
    <Metadata name="title" mdxType="Metadata" />. In addition, all page headers, custom graphics,
    button icons, and scripts are service marks, trademarks, and/or trade dress
    of <Metadata name="title" mdxType="Metadata" /> or its contractors or suppliers, and may not be
    copied, imitated, or used, in whole or in part, without the prior written
    permission of <Metadata name="title" mdxType="Metadata" />. All other trademarks, registered
    trademarks, product names and company names or logos mentioned herein are
    the property of their respective owners.
  </p>
  <p>
    <strong>7. Submissions</strong>
  </p>
  <p>
    You agree that any materials, including but not limited to questions,
    comments, suggestions, ideas, plans, notes, drawings, original or creative
    materials or other information, provided by you in the form of email or
    submissions to <Metadata name="title" mdxType="Metadata" />, or postings on this Email Service,
    are non-confidential and shall become the sole property of{' '}
    <Metadata name="title" mdxType="Metadata" />. <Metadata name="title" mdxType="Metadata" /> shall own exclusive
    rights, including all intellectual property rights, and shall be entitled to
    the unrestricted use of these materials for any purpose, commercial or
    otherwise, without acknowledgment or compensation to you. The submission of
    any materials to <Metadata name="title" mdxType="Metadata" />, including the posting of
    materials to any forum or interactive area, irrevocably waives any and all
    &#34;moral rights&#34; in such materials, including the rights of paternity
    and integrity.
  </p>
  <p>
    <strong>8. Linking</strong>
  </p>
  <blockquote>
    <p>
      8.1 You may not use, frame or utilize framing techniques to enclose any{' '}
      <Metadata name="title" mdxType="Metadata" /> trademark, logo or other proprietary
      information, including the images found at this Email Service, the content
      of any text, or the layout/design of any page or form contained on a page,
      without <Metadata name="title" mdxType="Metadata" />
      &#39;s express written consent. Further, you may not use any meta tags or any
      other &#34;hidden text&#34; utilizing any <Metadata name="title" mdxType="Metadata" /> name, trademark,
      or product name without <Metadata name="title" mdxType="Metadata" />
      &#39;s express written consent. Except as noted above, you are not
      conveyed any right or license by implication, estoppel, or otherwise in or
      under any patent, trademark, copyright, or proprietary right of{' '}
      <Metadata name="title" mdxType="Metadata" /> or any third party.
    </p>
    <p>
      8.2 <Metadata name="title" mdxType="Metadata" /> makes no claim or representation regarding,
      and accepts no responsibility for, the quality, content, nature or
      reliability of Web sites accessible by hyperlink from this Email Service,
      or Web sites linking to this Email Service. The linked sites are not under
      the control of <Metadata name="title" mdxType="Metadata" />, and <Metadata name="title" mdxType="Metadata" /> is
      not responsible for the contents of any linked site or any link contained
      in a linked site, or any review, changes or updates to such sites.{' '}
      <Metadata name="title" mdxType="Metadata" /> is providing these links to you only as a
      convenience, and the inclusion of any link does not imply affiliation,
      endorsement, or adoption by or between <Metadata name="title" mdxType="Metadata" /> and any
      third party.
    </p>
  </blockquote>
  <p>
    <strong>9. Third Party Content &amp; Email Services</strong>
  </p>
  <blockquote>
    <p>
      9.1 <Metadata name="title" mdxType="Metadata" /> may provide links to Web pages and content
      of third parties (&#34;Third Party Content&#34;) as a service to those
      interested in this information. <Metadata name="title" mdxType="Metadata" /> does not
      monitor, and has no control over, any Third Party Content or third party
      Web sites. <Metadata name="title" mdxType="Metadata" /> does not endorse or adopt any Third
      Party Content and can make no guarantee as to its accuracy or
      completeness. <Metadata name="title" mdxType="Metadata" /> does not represent or warrant the
      accuracy of any information contained therein, and undertakes no
      responsibility to update or review any Third Party Content.
    </p>
    <p>
      9.2 When leaving the <Metadata name="title" mdxType="Metadata" /> site, you should be aware
      that <Metadata name="title" mdxType="Metadata" />
      &#39;s terms and policies no longer govern, and, therefore, you should review
      the applicable terms and policies, including privacy and data gathering practices,
      of that site. Your use of these links and Third Party Content contained therein
      is at your sole risk.
    </p>
  </blockquote>
  <p>
    <strong>10. Copyright Policy &amp; Copyright Agent</strong>
  </p>
  <blockquote>
    <p>
      10.1 <Metadata name="title" mdxType="Metadata" /> may remove content that appears to infringe
      the copyright or other intellectual property rights of others. In
      addition, <Metadata name="title" mdxType="Metadata" /> may terminate the accounts of users
      who appear to infringe the copyright or other intellectual property rights
      of others.
    </p>
    <p>
      10.2 If you believe that <Metadata name="title" mdxType="Metadata" /> or any user of our site
      has infringed your copyright in any material way, please notify{' '}
      <Metadata name="title" mdxType="Metadata" />, and provide the following information (the
      &#34;Notice&#34;):
    </p>
    <blockquote>
      <p>
        10.2.1. A physical or electronic signature of the person authorized to
        act on behalf of the owner of the copyright interest.
      </p>
      <p>
        10.2.2. An identification of the copyrighted work claimed to have been
        infringed.
      </p>
      <p>
        10.2.3. An identification of the material that you claim is infringing
        so that we may locate it on the Email Service.
      </p>
      <p>10.2.4. Your address, telephone number, and email address.</p>
      <p>
        10.2.5. A statement by you that you have a good faith belief that the
        disputed use is not authorized by the copyright owner, its agent, or the
        law.
      </p>
      <p>
        10.2.6. A statement by you that the above information in your Notice is
        accurate, made under penalty of perjury, and that you are authorized to
        act on behalf of the owner of the copyright interest involved.
      </p>
    </blockquote>
  </blockquote>
  <p>
    However, unless ordered by a court of a competent jurisdiction or an
    administrative body, <Metadata name="title" mdxType="Metadata" /> does not have to take any
    action against an alleged infringement.
  </p>
  <p>
    <strong>11. No Resale</strong>
  </p>
  <p>
    You agree not to resell or make any commercial use of the Email Service
    without <Metadata name="title" mdxType="Metadata" />
    &#39;s express written consent.
  </p>
  <p>
    <strong>12. Termination</strong>
  </p>
  <p>
    Notwithstanding any of these terms and conditions of use,{' '}
    <Metadata name="title" mdxType="Metadata" /> reserves the right, without notice and in its sole
    discretion, to terminate your use of this Email Service, to change or
    eliminate any of the services we provide, and to block or prevent future
    access to and use of this Email Service. If your account is terminated for
    violation of these Email Terms, you will not be entitled to any refunds.
    Should you object to these Email Terms or become dissatisfied with the Email
    Service in any way, your only recourse is to immediately discontinue your
    use of the Email Service and terminate your account.
  </p>
  <p>
    <strong>13. Severability</strong>
  </p>
  <p>
    If any provision of these terms and conditions shall be deemed unlawful,
    void, or for any reason unenforceable, then that provision shall be deemed
    severable from these terms and conditions and shall not affect the validity
    and enforceability of any remaining provisions. The terms of this section
    survive any termination of the Email Terms.
  </p>
  <p>
    <strong>14. Modification &amp; Amendments</strong>
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> reserves the right to amend at any time any
    policies governing this Email Service, including these Email Terms, by
    posting the amended terms and providing notice of such amendments. The
    amended terms shall be effective upon posting. If you do not accept the
    amended terms, you should cease using this Email Service.
  </p>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulec">
    <a href="#schedulec" name="schedulec">
      Schedule C
    </a>
    : Terms and Conditions Applicable to all Web Site and Hosting Services
  </h2>
  <p>
    <strong>1. Definitions</strong>
  </p>
  <p>
    For purposes of this Schedule, the following capitalized terms shall have
    the meanings ascribed to them below:
  </p>
  <blockquote>
    <p>
      1.1. &#34;
      <Metadata name="title" mdxType="Metadata" /> Corp. Web Site&#34; means any pre-designed, customizable{' '}
      <Metadata name="title" mdxType="Metadata" /> Corp. Web site template including websites provisioned
      from third parties. licensed by us to end users.
      By using these services, end users also agree to such third party terms and conditions, as applicable.
    </p>
    <p>
      1.2. &#34;Subscription Service&#34; means any of the{' '}
      <Metadata name="title" mdxType="Metadata" /> Corp. subscription service packages that are
      available for purchase by end users on a monthly or yearly basis, for a monthly or yearly fee,
      that combine the <Metadata name="title" mdxType="Metadata" /> Corp. Web Site license, the Web
      Site Manager Service and the Web Hosting Service, all as described on the{' '}
      <Metadata name="title" mdxType="Metadata" /> Corp. Web site located at the URL{' '}
      <Metadata name="link" mdxType="Metadata" />.{' '}
    </p>
    <p>
      1.3. &#34;Web Site Manager Service&#34; means the{' '}
      <Metadata name="title" mdxType="Metadata" /> Corp. on-line tool that allows customers to
      access their <Metadata name="title" mdxType="Metadata" /> Corp. Web Site, add/modify content,
      upload images and make generic changes to their <Metadata name="title" mdxType="Metadata" />{' '}
      Corp. Web Site.{' '}
    </p>
    <p>
      1.4. &#34;Web Hosting Service&#34; means the Web hosting services provided
      by a third party through <Metadata name="title" mdxType="Metadata" /> Corp. as part of a
      Subscription Service.
    </p>
  </blockquote>
  <p>
    <strong>2. Payment </strong>
  </p>
  <p>
    In addition to the payment terms u Section 4 under the Main Terms and
    Conditions of the Agreement, the following provisions shall also apply
    solely with respect to the Subscription Service:{' '}
  </p>
  <blockquote>
    <p>
      2.1. <Metadata name="title" mdxType="Metadata" /> in its sole discretion, shall determine the
      prices it will charge for the Subscription Service, and the terms and
      conditions applicable to the same, and <Metadata name="title" mdxType="Metadata" /> Corp.
      may, upon providing thirty (30) days&#39; notice to you, amend such
      pricing and/or terms and conditions. If you do not agree to the change(s),
      you may terminate your Subscription Service as provided in Section 5 of
      this Schedule within that thirty (30) days; otherwise all such changes
      shall thereafter be effective with respect to your account, and you agree
      that we are authorized to charge your credit card for the new monthly
      Subscription Service fee.{' '}
    </p>
    <p>
      2.2 Billing for the Subscription Service will be by valid credit card
      (acceptable to <Metadata name="title" mdxType="Metadata" /> Corp) at the time of purchase. If
      you elect to subscribe to a service that requires a monthly payment, your
      monthly payments for the same will be automatically charged to the credit
      card provided by you (and acceptable to <Metadata name="title" mdxType="Metadata" /> Corp) at
      the time of your purchase (with such payments being charged in advance on
      a monthly basis), and you hereby agree that <Metadata name="title" mdxType="Metadata" />{' '}
      Corp. is authorized to so charge your credit card.{' '}
    </p>
  </blockquote>
  <p>
    <strong>3. Conduct </strong>
  </p>
  <p>
    You agree to abide by the terms and conditions set forth herein and be bound
    by the applicable provisions of any applicable <Metadata name="title" mdxType="Metadata" />{' '}
    Corp. Acceptable Use Policy and other applicable <Metadata name="title" mdxType="Metadata" />{' '}
    policies and procedures, incorporated herein and made part of this Agreement
    by reference, in connection with your use of the services described in this
    Schedule. You are responsible for ensuring that your web site conforms to
    all local, state, federal and international laws. You are also responsible
    for ensuring that you have obtained authorization to use any copyright
    images, audio files, text or other web site elements that are not provided
    by <Metadata name="title" mdxType="Metadata" />. You warrant that the web site being hosted by{' '}
    <Metadata name="title" mdxType="Metadata" /> Corp. will not be used in connection with any
    illegal activity and that it will not conflict with the legal rights of a
    third party or a third party&#39;s trademarks or trade name.
  </p>
  <p>
    <strong>
      4. <Metadata name="title" mdxType="Metadata" />
      &#39;s Rights.
    </strong>
  </p>
  <blockquote>
    <p>
      4.1 <Metadata name="title" mdxType="Metadata" /> explicitly reserves the right and sole
      discretion to{' '}
    </p>
    <blockquote>
      <p>
        4.1.1 suspend any web site (including indefinite suspension) without
        notice for non-payment of fees due hereunder;{' '}
      </p>
      <p>
        4.1.2 censor any web site hosted that, in <Metadata name="title" mdxType="Metadata" />{' '}
        Corp&#39;s sole discretion, is deemed inappropriate;{' '}
      </p>
      <p>
        4.1.3 review every Web Hosting account for excessive space and bandwidth
        utilization and to terminate or apply additional fees to those accounts
        that exceed allowed levels;{' '}
      </p>
      <p>4.1.4 modify its pricing through email notification; </p>
      <p>
        4.1.5 terminate your Subscription Service for unsolicited, commercial
        emailing (i.e., SPAM); illegal access to other computers or networks
        (i.e., hacking); distribution of Internet viruses or similar destructive
        activities; non-payment of Web Hosting fees; and other activities
        whether lawful or unlawful that <Metadata name="title" mdxType="Metadata" /> Corp.
        determines to be harmful to its other customers, operations, or
        reputation;{' '}
      </p>
      <p>
        4.1.6 terminate Your Subscription Service if the contents of your web
        site result in, or are the subject of, legal action or threatened legal
        action, against <Metadata name="title" mdxType="Metadata" /> Corp. or any of its affiliates
        or partners, without consideration for whether such legal action or
        threatened legal action is eventually determined to be with or without
        merit.
      </p>
    </blockquote>
    <p>
      4.2 You agree you will not be entitled to a refund of any fees paid to{' '}
      <Metadata name="title" mdxType="Metadata" /> if, for any reason, <Metadata name="title" mdxType="Metadata" />{' '}
      takes corrective action with respect to your improper or illegal use of
      the Subscription Service.{' '}
    </p>
  </blockquote>
  <p>
    <strong>5. Cancellation</strong>{' '}
  </p>
  <p>
    You may cancel your Subscription Service at any time. To cancel your
    Subscription Service you must submit your written notice of cancellation to{' '}
    <Metadata name="title" mdxType="Metadata" /> (as provided herein) and include the following
    information: (i) Your <Metadata name="title" mdxType="Metadata" /> customer identification
    number and username; (ii) your <Metadata name="title" mdxType="Metadata" /> Web Site Web
    address; and (iii) your reason for requesting cancellation. Unless
    terminated earlier as provided herein, your Subscription Service will be
    canceled as of the expiration of the monthly billing cycle in which your
    notice was received. In the absence of such written notice of cancellation,{' '}
    <Metadata name="title" mdxType="Metadata" /> will automatically renew the Subscription Service
    indefinitely and will charge the credit card you have on file with{' '}
    <Metadata name="title" mdxType="Metadata" /> , at <Metadata name="title" mdxType="Metadata" /> then current rates.
  </p>
  <p>
    <strong>6. Term and Termination </strong>
  </p>
  <blockquote>
    <p>
      6.1 Term: Your Subscription Service shall be on a month-to-month basis for
      successive monthly periods, unless either party notifies the other of
      termination in accordance with this Agreement.{' '}
    </p>
    <p>
      6.2 Notice of Service Cancellation by You. Any termination of your
      Subscription Service must be in accordance with our cancellation policy.
      Unless terminated earlier as provided herein, this Schedule, and the
      Agreement (if you have no other services with <Metadata name="title" mdxType="Metadata" />{' '}
      Corp) will be terminated as of the expiration of the monthly billing cycle
      in which your cancellation notice was received and processed by{' '}
      <Metadata name="title" mdxType="Metadata" />{' '}
    </p>
  </blockquote>
  <p>
    <strong>7. Service Uptime Guarantee</strong>{' '}
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> offers a Service uptime guarantee of 99.9%
    (“Service Uptime Guarantee”) of available time per month. The uptime of the
    server is defined as the reported uptime from the operating system and the
    Apache Web Server which may differ from the uptime reported by other
    individual services. If we fail to maintain this Service Uptime Guarantee in
    a particular month (as solely determined by us), you will be eligible upon
    request to receive a credit to apply to future services billing cycles based
    upon the Unavailability for that month. The credit may be used only for the
    purchase of further products and services from us, and is exclusive of any
    applicable taxes. Third party monitoring service reports may not be used for
    justification due to a variety of factors including the monitor&#39;s
    network capacity/transit availability. The Service Uptime Guarantee does not
    apply to service interruptions caused by: (1) periodic scheduled maintenance
    or repairs we may undertake from time to time; (2) interruptions caused by
    you from custom scripting, coding or the installation of third-party
    applications; (3) outages that do not affect the appearance of your website
    but merely affect access to your website such as FTP and email; (4) causes
    beyond our control or that are not reasonably foreseeable; and (5) outages
    related to the reliability of certain programming environments.
  </p>
  <p>
    <strong>8. Hosting Migrations </strong>
  </p>
  <blockquote>
    <p>
      8.1 If your web hosting is provided by a third-party, we may, at your
      request and in our sole discretion, attempt to assist you to move the web
      hosting and the domain name to us. Hosting Migrations are provided as a
      courtesy service, and we do not make any guarantee regarding the
      availability, possibility, or time required to complete a Hosting
      Migration. Each hosting company is configured differently, and some
      hosting platforms save data in an incompatible or proprietary format,
      which may make us unable to assist you in the transfer of data from a
      third-party host.{' '}
    </p>
    <p>
      8.2 The free Hosting Migration service is available for thirty (30) days
      from your sign up date. Transfers outside of the thirty (30) day period
      will incur a charge; please contact a member of our Hosting Migration
      department to receive a price quote.{' '}
    </p>
    <p>
      8.3 You are solely responsible for reviewing the functionality and
      accuracy of migrated content in its new location following a Hosting
      Migration. We will not perform website backups or archives in connection
      with a Hosting Migration, and we recommend that you back up your
      third-party hosted website before migration to ensure that no data is
      lost. You agree not to make any changes or revisions to your website
      during the migration process.{' '}
    </p>
    <p>
      8.4 You agree that we are not liable for any delay in website resolution
      or loss of data related to your Hosting Migration.{' '}
    </p>
    <p>
      8.5 We may install a plugin on your external WordPress site for the
      purpose of facilitating your WordPress migration into our own Managed
      WordPress hosting environment. This plugin will not change anything on
      your source site. Its purpose is to facilitate the Hosting Migration of
      your WordPress files. You are welcome to disable the plugin on your source
      site after the Hosting Migration has been completed.{' '}
    </p>
  </blockquote>
  <p>
    <strong>9. Backups and Security </strong>
  </p>
  <blockquote>
    <p>
      9.1 You shall be solely responsible for undertaking measures to: (1)
      prevent any loss or damage to your website or server content; (2) maintain
      independent archival and backup copies of your website or server content;
      and (3) ensure the security, confidentiality and integrity of all your
      website or server content transmitted through or stored on our
      servers.{' '}
    </p>
    <p>
      9.2 <Metadata name="title" mdxType="Metadata" />
      &#39;s backup service runs once a day and overwrites any of our previous backups.
      Only four weeks of backups are stored in the remote server. This service is
      provided only to shared and reseller accounts as a courtesy and may be modified
      at any time at <Metadata name="title" mdxType="Metadata" />
      &#39;s sole discretion. <Metadata name="title" mdxType="Metadata" /> is not responsible for
      files and/or data residing on your account. You agree to take full
      responsibility for all files and data transferred and to maintain all
      appropriate backup of files and data stored on <Metadata name="title" mdxType="Metadata" />{' '}
      &#39;s servers.{' '}
    </p>
    <p>
      9.3 Our servers are not an archive and we shall have no liability to you
      or any other person for loss, damage or destruction of any of your
      content. The Hosting Services are not intended to provide a PCI (Payment
      Card Industry) or HIPAA (Health Insurance Portability and Accountability
      Act) compliant environment and therefore should not be used or considered
      as one. You shall not use the Service in any way, in our sole discretion,
      that shall impair the functioning or operation of our services or
      equipment. Specifically by way of example and not as a limitation, you
      shall not use the Hosting Services as: (1) a repository or instrument for
      placing or storing archived files; and/or (2) placing or storing material
      that can be downloaded through other websites. You acknowledge and agree
      that we have the right to carry out a forensic examination in the event of
      a compromise to your server or account.{' '}
    </p>
  </blockquote>
  <p>
    <strong>10. Website/Server Content</strong>{' '}
  </p>
  <p>
    Your website may not include any of the following content: (1) image hosting
    scripts that allow an anonymous user to upload an image for display on
    another website (similar to Photobucket or Tinypic); (2) banner ad services
    for display on other websites or devices (commercial banner ad rotation);
    (3) file dump/mirror scripts that allow an anonymous user to upload a file
    for other to download (similar to rapidshare); (4) commercial audio
    streaming (more than one or two streams); (5) push button mail scripts that
    allow the user to specify recipient email addresses; (6) anonymous or bulk
    SMS gateways; (7) backups of content from another computer or website; (8)
    Bittorrent trackers; or (9) any script that causes a degradation in the
    performance of our server or network environment.
  </p>
  <p>
    <strong>11. Disk Space/Bandwidth/Website Plans</strong>{' '}
  </p>
  <p>
    Your use of our Service is subject to your current Plan or package. In the
    event your Service usage, or the content you host, exceeds your plan or
    package, presents a risk to the stability, performance or uptime of our
    servers, data storage, networking or other infrastructure, you may be
    required to reduce usage, upgrade your current Plan or package, or we may
    take action to restrict the resources your website is utilizing.
  </p>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduled">
    <a href="#scheduled" name="scheduled">
      Schedule D
    </a>
    : Terms and Conditions Applicable to the High Security Service
  </h2>
  <p>
    <strong>1.</strong> <Metadata name="title" mdxType="Metadata" /> has introduced a &#34;High
    Security&#34; service to address issues of domain name security. The High
    Security service is provided to you as a courtesy and helps to prevent
    domains you have registered from being unintentionally transferred, deleted,
    or expired. Unless you inform <Metadata name="title" mdxType="Metadata" /> that you do not want
    this service, you will be automatically enrolled for{' '}
    <Metadata name="title" mdxType="Metadata" />
    &#39;s High Security service. The High Security service includes &#34;Registrar
    Lock&#34; and &#34;Auto-renewal&#34;, described below. <Metadata name="title" mdxType="Metadata" />{' '}
    may introduce additional security features in the future.
  </p>
  <p>
    <strong>2. Registrar Lock</strong>
  </p>
  <p>
    When High Security is enabled for a domain name, you are preventing
    registrars, other than <Metadata name="title" mdxType="Metadata" />, to transfer or modify your
    domain name. If you choose to transfer a domain to another registrar, you
    must log into your account and remove the lock prior to our receipt of the
    transfer request from the gaining registrar. This service is being provided
    as a convenience to you but in no way guarantees that a domain name will not
    be maliciously transferred to another registrar or registrant, due to
    technical and policy weaknesses in the worldwide domain name system or by{' '}
    <Metadata name="title" mdxType="Metadata" />
    &#39;s error. <Metadata name="title" mdxType="Metadata" /> will, however, use commercially reasonable
    efforts in stopping any such transfer without your express consent. Please note
    that not all registries support the concept of a Registrar Lock in which case,
    High Security will not include a Registrar Lock.
  </p>
  <p>
    <strong>3. Auto-renewal</strong>
  </p>
  <blockquote>
    <p>
      3.1 When High Security is enabled for a domain, <Metadata name="title" mdxType="Metadata" />{' '}
      will attempt to renew the registration of a domain approximately 75 days
      prior to its expiry date. The renewal is for a one-year term and extends
      the existing registration period. For example, if the expiry date for your
      domain name is September 1, 2003, the new expiry date will be September 1,
      2004. When High Security is enabled, you have authorized and consented to{' '}
      <Metadata name="title" mdxType="Metadata" /> to automatically charge your credit card the
      then-current retail price for such one-year renewal. The automatic renewal
      service is provided as a convenience for you but in no way guarantees a
      desired renewal. It is your obligation to affirmatively renew any desired
      domain. In addition, <Metadata name="title" mdxType="Metadata" /> has no obligation to
      attempt to renew your domain if your most recent credit card on file with
      us for your account is not accepted according to <Metadata name="title" mdxType="Metadata" />
      &#39;s payment processing systems. After your domains have been successfully
      renewed, you will receive a confirmation email. Note: The Auto-renewal process
      requires a valid credit card to be kept on file in your account. You will be
      notified if the Auto-renewal transaction is declined for any reason.{' '}
    </p>
    <p>
      3.2 If you do not choose to have the High Security service as part of your
      Subscription Service, you must contact Customer Support by logging into
      your <Metadata name="title" mdxType="Metadata" /> account at <Metadata name="link" mdxType="Metadata" /> and
      disabling the High Security feature on those domains you choose not to
      protect. Your failure to expressly opt out of the High Security service
      constitutes your authorization and consent for <Metadata name="title" mdxType="Metadata" />{' '}
      to enable Registrar-Lock and Auto-renewal, and attempt to automatically
      charge your credit card the then-current retail price for such renewal.
    </p>
    <p>
      3.3 You are solely responsible for the credit card and billing contact
      information you provide to <Metadata name="title" mdxType="Metadata" /> and you acknowledge
      and agree that you will promptly inform <Metadata name="title" mdxType="Metadata" /> of any
      changes thereto (e.g., change of expiration date or account number).{' '}
    </p>
    <p>
      3.4 You are solely responsible for ensuring the security of your domains.{' '}
      <span style={{
            textTransform: 'uppercase'
          }}>
        <Metadata name="title" mdxType="Metadata" />
      </span>{' '}
      WILL HAVE NO LIABILITY TO YOU OR ANY THIRD PARTY IN CONNECTION WITH THE
      HIGH SECURITY FEATURES, INCLUDING ATTEMPTED OR SUCCESSFUL TRANSFERS OF
      DOMAINS EVEN THOUGH THE HIGH SECURITY SERVICE IN ENABLED, OR RENEWAL OR
      ANY ATTEMPT TO RENEW DOMAINS AS DESCRIBED HEREIN, INCLUDING, BUT NOT
      LIMITED TO, ANY FAILURE OR ERRORS IN TRANSFERS, RENEWING OR ATTEMPTING TO
      RENEW THE DOMAINS. The foregoing limitation of liability is in addition to
      any other limitations of liability set forth in this Agreement.{' '}
    </p>
    <p>
      3.5 You understand and agree that the release, indemnity and other
      obligations in favour of <Metadata name="title" mdxType="Metadata" /> and certain other
      persons in Section 14 of the Main Terms and Conditions apply to your use
      of the High Security feature.
    </p>
  </blockquote>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulee">
    <a href="#schedulee" name="schedulee">
      Schedule E
    </a>
    : Terms and Conditions Applicable to <Metadata name="title" mdxType="Metadata" /> Privacy Service
  </h2>
  <p>
    <strong>1.</strong> <Metadata name="title" mdxType="Metadata" /> has introduced a
    &#34;Privacy&#34; service to address issues of domain name privacy through
    the services of Privacy Hero Ltd. By using the Services and/or website of
    Privacy Hero Inc., a Turks and Caicos company (&#34;Privacy Hero&#34;), You
    agree to all the terms and conditions set forth both herein and in the
    Privacy Hero Terms and Conditions, which is incorporated by reference and
    can be found by clicking&nbsp;
    <a href="https://www.privacyhero.company/en/terms" rel="noreferrer" target="_blank">
      here
    </a>
    .&nbsp; You acknowledge that Privacy Hero may amend this Agreement at any
    time upon posting the amended terms on its website, and that any new,
    different or additional features changing the services provided by Privacy
    Hero will automatically be subject to this Agreement. If You do not agree to
    be bound by, or if You object to, the terms and conditions of this Agreement
    and any amendments hereto, do not use or access Privacy Hero&#39;s services.
    Continued use of Privacy Hero&#39;s services and its website after any such
    changes to this Agreement have been posted, constitutes Your acceptance of
    those changes.
  </p>
  <p>
    <strong>2. Good Faith</strong> By enabling the Privacy service, you agree
    to use the domain name and associated websites in good faith. Without
    limiting the generality of the foregoing, you will not use the Privacy
    services for purposes of engaging in, participating in, sponsoring or hiding
    your involvement in illegal or morally objectionable activities, including
    but not limited to, activities which are designed, intended to or otherwise:
    (a) appeal primarily to prurient interests; (b) defame, embarrass, harm,
    abuse, threaten, or harass; (c) violate state or federal local laws and/or
    foreign territories; (d) involve hate crimes, terrorism or child
    pornography; (e) are tortious, vulgar, obscene, invasive of a third
    party&#39;s privacy, race, ethnicity, or are otherwise objectionable; (f)
    impersonate the identity of a third party; (g) harm minors in any way; or
    (h) relate to or transmit viruses, Trojan Horses, access codes, backdoors,
    worms, timebombs or any other code, routine, mechanism, device or item that
    corrupts, damages, impairs, interferes with, intercepts or misappropriates
    any software, hardware, firmware, network, system, data or personally
    identifiable information. Any alleged misconduct in connection with your use
    of the domain name and/or the associated website in contravention of this
    Section 2 will be cause for termination of the Privacy service in accordance
    with Section 4 below.
  </p>
  <p>
    <strong>3. Term of Service</strong> Unless otherwise specified, and subject
    to earlier termination as contemplated by Section 2 and Section 4, the
    Privacy service will initially be activated for a one-year term. At the end
    of such one-year term, and at the end of each subsequent one-year term
    thereafter, the Privacy service will automatically renew for consecutive
    one-year terms at then current rates, unless you request cancellation of the
    Privacy service by notifying <Metadata name="title" mdxType="Metadata" /> at least thirty (30)
    days before the end of the then-current term. You acknowledge and agree that
    in connection with any automatic renewal <Metadata name="title" mdxType="Metadata" /> will
    attempt to charge the credit card you have on file at the then current
    rates, and you waive any requirement to obtain your ongoing affirmative
    consent to any such automatic renewal. It is your responsibility to keep
    your credit card information current and accurate, including the expiration
    date. If <Metadata name="title" mdxType="Metadata" /> is unable to collect renewal or other
    fees, you agree that <Metadata name="title" mdxType="Metadata" /> may contact you, but is not
    obliged to do so, and you agree that <Metadata name="title" mdxType="Metadata" /> may suspend
    or terminate the Privacy service as a result of inability to obtain payment.
    FEES WILL NOT BE PRO RATED OR OTHERWISE REFUNDED IF THE PRIVACY SERVICE IS
    CANCELLED OR OTHERWISE TERMINATED BEFORE THE END OF THE THEN-CURRENT TERM.
    Without limiting the generality of the foregoing, you understand that the
    Privacy services term may be different than the registration term of a
    domain which is associated with the Privacy services. If a domain expires
    and is deleted before the end of the term of the associated Privacy
    services, then the Privacy services associated with the domain will end when
    the domain is deleted and you understand that there will be no refund for
    any resulting unused portion of a Privacy services term.
  </p>
  <p>
    <strong>4. Disclosure and Termination</strong> You agree that in the event:
  </p>
  <blockquote>
    <p>
      (a) <Metadata name="title" mdxType="Metadata" /> or its parent, subsidiary, entity under
      common control and/or entity owned by the same beneficial owner, or their
      respective owners, beneficial owners, directors, officers, shareholders,
      employees, contractors, agents, partners, affiliates, successors or
      assigns is threatened, receives a complaint, notice of action or any
      demand from a third party with respect to a domain name and/or associated
      websites for which the Privacy service is activated, or
    </p>
    <p>
      (b) there is alleged infringement, abuse or misuse of, or activity of any
      nature that could result in loss or legal liability (civil or criminal) to{' '}
      <Metadata name="title" mdxType="Metadata" /> or its parent, subsidiary, entity under common
      control and/or entity owned by the same beneficial owner, or their
      respective owners, directors, officers, shareholders, employees,
      contractors, agents, partners, affiliates, successors or assigns with
      respect to a domain name and/or associated websites for which the Privacy
      service is activated, or
    </p>
    <p>
      (c) you are not, in <Metadata name="title" mdxType="Metadata" />
      &#39;s opinion, using the Privacy service in good faith as required by Section
      2,
    </p>
    <p>
      you have provided us with your prior consent to disable the Privacy
      service and to disclose your technical and administrative contact
      information to any complainant or third party requesting such information
      and to make such information publicly available for a WHOIS query. You
      agree that no further prior authorization or approval from you or your
      agent is necessary for such disclosure. You understand and agree that{' '}
      <Metadata name="title" mdxType="Metadata" /> is under no obligation to provide the Privacy
      service to you, and that <Metadata name="title" mdxType="Metadata" /> may, in its sole
      discretion, for any reason or no reason, disable the Privacy service
      without notice or warning, either with respect to a specific domain
      name(s) or with respect to all domain names in your account (even if
      “customer” level Privacy service has been selected). YOU WILL NOT BE
      ENTITLED TO ANY FEE REFUND AS A RESULT OF DISCLOSURE OF YOUR
      ADMINISTRATIVE OR TECHNICAL CONTACT INFORMATION AND/OR TERMINATION OF THE
      PRIVACY SERVICE AS CONTEMPLATED BY SECTION 3 OR 4 HEREOF.
    </p>
    <p>
      Without limiting the generality of the foregoing,{' '}
      <Metadata name="title" mdxType="Metadata" /> shall be entitled to suspend access or service
      to your account in order to disable the Privacy service.
    </p>
  </blockquote>
  <p>
    <strong>5. Limitation of Liability</strong> TO THE EXTENT PERMITTED BY LAW,
    NEITHER{' '}
    <span style={{
          textTransform: 'uppercase'
        }}>
      <Metadata name="title" mdxType="Metadata" />
    </span>{' '}
    NOR, ITS PARENT, SUBSIDIARY, ENTITY UNDER COMMON CONTROL AND/OR ENTITY OWNED
    BY THE SAME BENEFICIAL OWNER, AND/OR THEIR RESPECTIVE OWNERS, DIRECTORS,
    OFFICERS, SHAREHOLDERS, EMPLOYEES, CONTRACTORS, AGENTS, PARTNERS,
    AFFILIATES, SUCCESSORS AND ASSIGNS SHALL NOT BE LIABLE FOR ANY DIRECT,
    INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES RESULTING FROM YOUR
    USE OF THE PRIVACY SERVICE, OR THE DISCLOSURE OF YOUR ADMINISTRATIVE OR
    TECHNICAL CONTACT INFORMATION AND/OR TERMINATION OF THE PRIVACY SERVICE AS
    CONTEMPLATED BY SECTION 3 OR 4 HEREOF. The foregoing limitation of liability
    is in addition to any other limitations of liability set forth in this
    Agreement.
  </p>
  <p>
    <strong>6. Indemnity, etc.</strong> You understand and agree that the
    release, indemnity and other obligations in favour of{' '}
    <Metadata name="title" mdxType="Metadata" /> and certain other persons in Section 14 of the
    Main Terms and Conditions apply to your use of the Privacy service.
  </p>
  <p>
    <strong>7. Accurate Information</strong> As a condition of your use of the
    Privacy service, you agree to: (a) provide current, complete and accurate
    information about you as required by the domain name application and
    registration process; (b) maintain and update such information as needed to
    keep it current, complete and accurate; and (b) respond within five (5)
    calendar days to a request by us to update or confirm the accuracy of your
    information. We rely on this information to carry out our service for you
    and comply with the requirements of registries of domain names and to send
    you important information and notices regarding your account and our
    services. Any failure by you to provide or update such information or to
    respond to our request is a material breach of this Agreement.
  </p>
  <p>
    <strong>8. Forwarded Information</strong> You agree that{' '}
    <Metadata name="title" mdxType="Metadata" /> may review communications sent to the email
    address associated with your Privacy service enabled domain. For
    communications received via certified or traceable courier mail (such as UPS
    or FedEx), or postal mail which does not appear to be unsolicited commercial
    mail, <Metadata name="title" mdxType="Metadata" /> will make commercially reasonable efforts to
    either (a) forward such communication to you or (b) attempt to communicate
    to you a scanned copy of a page of the communication to ascertain whether
    you wish to receive the full communication. You specifically acknowledge
    that <Metadata name="title" mdxType="Metadata" /> may elect to not forward to you (nor to
    otherwise communicate with you) regarding postal mail or email, fax, postal
    mail or telephone communications which appear to be unsolicited
    communications (e.g., communications which offer or advertize the sale of
    goods or services or which solicit charitable contributions). You authorize{' '}
    <Metadata name="title" mdxType="Metadata" /> to either discard all such communications or
    return all such communications to sender unopened. You agree to waive any
    and all claims arising from your failure to receive communications directed
    to your domain name but not forwarded to you by <Metadata name="title" mdxType="Metadata" />,
    including failures which arise from <Metadata name="title" mdxType="Metadata" />
    &#39;s mistake in judging whether a communication appears to be an unsolicited
    communication. You agree that you will reimburse <Metadata name="title" mdxType="Metadata" /> for
    any reasonable fees for administrative tasks outside the scope of regular services
    incurred as a result of your use of the Privacy service. These may include, but
    are not limited to, Customer Support issues that require personal service and
    disputes that require legal services.
  </p>
  <p>
    <strong>9.</strong> In the event this Agreement or Schedule expires or
    terminates, Sections 4, 5, 6 and 8 of this Schedule shall survive such
    expiration or termination.
  </p>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulef">
    <a href="#schedulef" name="schedulef">
      Schedule F
    </a>
    : Terms and Conditions Applicable to SSL Certificate Services
  </h2>
  <p>
    The Secure Sockets Layer (SSL) services offered under these SSL Terms is an
    &#34;additional service&#34; as provided under Section 3 of this Agreement,
    &#34;VARIOUS SERVICES&#34;.
  </p>
  <p>
    SSL enterprise and certificate services provided by{' '}
    <Metadata name="title" mdxType="Metadata" /> to you include assisting you in acquiring a new
    SSL certificate(s) and its associated products and services (the &#34;SSL
    Service&#34;).{' '}
  </p>
  <p>The following additional terms apply to the SSL Service: </p>
  <blockquote>
    <p>
      a) You acknowledge and agree <Metadata name="title" mdxType="Metadata" /> cannot guarantee
      the issuance of an SSL certificate following your submission of an
      application thereof. Issuance of an SSL certificate is subject to
      verification and approval of the information you submitted. This
      verification may, in some instances, take several business days.
    </p>
    <p>
      b) <Metadata name="title" mdxType="Metadata" /> is an authorized reseller for GlobalSign. You
      hereby authorize <Metadata name="title" mdxType="Metadata" /> to remit your submitted SSL
      certificate application, including all the information included therein,
      and acquire an SSL certificate from GlobalSign on your behalf. You agree
      to GlobalSign&#39;s terms and conditions incorporated herein by reference,
      as found at{' '}
      <a href="https://www.globalsign.com/repository/globalsign-subscriber-agreement-digital-certificates-and-services.pdf">
        https://www.globalsign.com/repository/globalsign-subscriber-agreement-digital-certificates-and-services.pdf
      </a>
      . You understand and agree that you are entering into and agreeing to a separate
      contractual relationship between you and GlobalSign in addition to these SSL
      Terms and this Agreement. You understand and agree that the underwritten Liability
      Program is provided as a service by GlobalSign. In order to provide an enhanced
      customer experience and as a convenience to you, <Metadata name="title" mdxType="Metadata" />{' '}
      will pay the SSL certificate/renewal fees on your behalf as part of the SSL
      Service provided that (i) these SSL Terms have not been cancelled or otherwise
      terminated, (ii) you have paid any amounts due under these SSL Terms, (iii)
      you are not in breach of the Agreement or these SSL Terms, and (iv) that GlobalSign
      agrees to and accepts your SSL certificate application/renewal fees. Notwithstanding
      the immediately forgoing sentence, you expressly acknowledge and agree that
      you shall be responsible for all fees, liability and obligations with your
      relationship with GlobalSign.
    </p>
    <p>
      c) You authorize <Metadata name="title" mdxType="Metadata" /> to list itself as a contact in
      connection with the SSL certificate and to take any actions{' '}
      <Metadata name="title" mdxType="Metadata" /> deems necessary or appropriate in connection
      therewith. Upon termination of SSL Services, <Metadata name="title" mdxType="Metadata" /> may
      immediately cease acting in such capacity and reserves the right to
      transfer your account to GlobalSign to serve for all future communications
      in connection with your SSL certificate. You further authorize{' '}
      <Metadata name="title" mdxType="Metadata" /> to list you as the subscriber and certificate
      administrator in connection with SSL certificate. You may also specify
      another subscriber and certificate administrator; however, such person(s)
      may be required to enter into a separate agreement with GlobalSign for use
      of SSL certificate services and/or access for services in support of your
      SSL certificate. Upon termination of SSL Services,{' '}
      <Metadata name="title" mdxType="Metadata" /> will not be responsible for forwarding any
      notices (email or otherwise) to you or for taking any other actions in
      connection with your SSL certificate. You will be solely responsible for
      any ongoing fees, as well as taking all necessary or advisable actions in
      connection with your SSL certificate.
    </p>
  </blockquote>
  <p>
    <strong>1. Automatic Renewals</strong>
  </p>
  <p>
    If you purchased a new SSL certificate using the <Metadata name="title" mdxType="Metadata" />{' '}
    SSL Service, <Metadata name="title" mdxType="Metadata" /> will automatically renew and bill you
    for the SSL certificate registration in accordance with Section 2 (Fees)
    below and this Agreement. Automatic renewal will not occur if the option is
    disabled through the administrative module for your account with{' '}
    <Metadata name="title" mdxType="Metadata" />. Each new SSL certificate acquired by{' '}
    <Metadata name="title" mdxType="Metadata" /> from GlobalSign will be renewed prior to each
    annual anniversary. Failure to electronically approve the renewal or remit
    Fees in accordance with Section 2 and the Fees Policy, may risk the
    non-renewal of your SSL certificate. Your SSL certificate will be renewed
    with GlobalSign only after the annual or multi-year fee is successfully
    charged to your credit card or payment transmitter in a timely manner.
  </p>
  <p>
    <strong>2. Fees</strong>
  </p>
  <p>
    SSL Certificate Registration Fees will be charged yearly and in advance
    (with multi-year certificate subscriptions renewed prior to the expiration
    of the last year and for a period of equal length) in accordance with this
    Agreement.
  </p>
  <p>
    <strong>3. Verification of Information</strong>
  </p>
  <blockquote>
    <p>
      a) You are solely responsible for maintaining that all information
      relating to the use of your SSL certificate is up-to-date with GlobalSign.
      Further, in accordance with the terms and conditions of your agreement
      with GlobalSign and in order to maintain a safe ecommerce presence,{' '}
      <Metadata name="title" mdxType="Metadata" /> may from time to time request that you verify
      any information to be supplied to GlobalSign. In the event that you fail
      to respond to any such request or fail to verify any such information
      within 30 days of the request, GlobalSign and/or <Metadata name="title" mdxType="Metadata" />{' '}
      may, in its/our sole and absolute discretion, immediately terminate your
      SSL Services. This remedy is in addition to any other remedies available
      under law or this Agreement.
    </p>
    <p>
      b) You shall protect the confidentiality of any encryption keys used by
      you in connection with your SSL certificate. Further, you shall promptly
      request that GlobalSign revoke any SSL certificate upon any actual or
      suspected loss, disclosure, or other compromise of your encryption keys or
      breach of the SSL certificate.
    </p>
  </blockquote>
  <p>
    <strong>4. Terms and Termination</strong>
  </p>
  <blockquote>
    <p>
      a) Your SSL certificate may only be transferred, if allowed, under the
      terms and conditions of your agreement with GlobalSign.
    </p>
    <p>
      b) <Metadata name="title" mdxType="Metadata" /> may, but has no duty to, immediately suspend
      or terminate your use of the SSL Service and remove any of your materials
      (including without limitation your SSL certificate) from{' '}
      <Metadata name="title" mdxType="Metadata" /> servers in the event <Metadata name="title" mdxType="Metadata" />,
      in its sole discretion, concludes that (i) there is any change to the
      information on the SSL certificate or the certificate application,
      including but not limited to the change of the organization name or domain
      name registration, (ii) there is any actual, <Metadata name="title" mdxType="Metadata" />{' '}
      reasonably suspects, loss, disclosure, or other compromise of an
      encryption key for the SSL certificate, (iii) you have engaged in illegal
      activities, in activities or sales that may damage the rights of{' '}
      <Metadata name="title" mdxType="Metadata" /> or others, or (iv) you have violated or
      threatened to violate these SSL Terms, the terms of this Agreement or any
      other agreement you may have with <Metadata name="title" mdxType="Metadata" />. Any
      suspension or termination under this paragraph may take effect
      immediately. In the event that <Metadata name="title" mdxType="Metadata" /> terminates your
      SSL Service in connection with this paragraph, you will not be entitled to
      a refund or credit of any fees you have paid. Without limitation, you
      expressly acknowledge and agree that in addition to this Section (4), the
      terms and conditions of this Agreement also apply to your use of the SSL
      Services.
    </p>
  </blockquote>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduleg">
    <a href="#scheduleg" name="scheduleg">
      Schedule G
    </a>
    : Terms and Conditions Relating to Afternic Fast Transfer
  </h2>
  <p>
    <strong>1. DESCRIPTION OF SERVICE</strong>
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> is partnering with Afternic® to provide{' '}
    <Metadata name="title" mdxType="Metadata" /> customers with a means to sell their domain
    name(s) to interested buyers through a network of selected registrars. If
    you choose to list your domain name for sale through the Fast Transfer
    Service and enter into this Agreement, you expressly acknowledge, understand
    and agree that: (i) <Metadata name="title" mdxType="Metadata" /> shall not have any liability
    or obligations to you regarding the listing and sale of your domain name
    through the Fast Transfer Service or the transfer of the domain name from
    you to the buyer; (ii) <Metadata name="title" mdxType="Metadata" /> has no control over buyers
    or Afternic&#39;s network of selected registrars and makes no
    representations as to the reliability or capability of the listing service,
    or the qualifications of any potential buyer or the ability of any buyer to
    pay for a domain name; and (iii) <Metadata name="title" mdxType="Metadata" /> does not collect,
    retain or have access to any credit card information of buyers utilizing the
    Fast Transfer Service, nor do we process the payment of funds between you
    and a buyer and therefore cannot be held liable for any non-payment by the
    buyer or any unauthorized disclosure of any personal or credit card
    information concerning the buyer. All terms and conditions related to the
    transfer of funds between Afternic buyers and sellers are covered in the
    Afternic Membership Agreement and Terms of Service located at{' '}
    <a href="https://www.afternic.com/legal">https://www.afternic.com/legal</a>.
  </p>
  <p>
    When you register your domain name with <Metadata name="title" mdxType="Metadata" /> and list
    your domain for sale as part of the Fast Transfer Service, you expressly
    acknowledge and agree that we may instantly transfer any domain name
    successfully sold in the Fast Transfer Service away from your{' '}
    <Metadata name="title" mdxType="Metadata" /> account into the account of the successful buyer
    of the domain name. You acknowledge and agree to allow{' '}
    <Metadata name="title" mdxType="Metadata" /> to disable any transfer lock feature associated
    with a domain name enrolled in the Fast Transfer Service, including but not
    limited to the disabling of our domain name transfer validation service.
  </p>
  <p>
    You agree to release, indemnify, defend and hold harmless{' '}
    <Metadata name="title" mdxType="Metadata" /> and any of its contractors, agents, employees,
    officers, directors, shareholders, affiliates and assigns from all
    liabilities, claims, damages, costs and expenses, including reasonable
    attorneys&#39; fees and expenses, relating to or arising out of your use of
    the Fast Transfer Service, including, but not limited to, the instant
    transfer of the domain name from your <Metadata name="title" mdxType="Metadata" /> account to
    the account of the buyer.
  </p>
  <p>
    <strong>2. LIMITATIONS AND DISCONTINUATION OF SERVICE</strong>
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> does not and cannot guarantee the sale or purchase
    of any domain name through the Fast Transfer Service. Transfer of a domain
    name to a buyer is not instantaneous at the time of sale and may take
    several days to occur.
  </p>
  <p>
    You may remove a domain name from the Fast Transfer Service at any time. In
    the event that you remove a domain from the Service, please be aware that
    removal of the domain name from the Afternic network is not instantaneous,
    and may take several days to occur. <Metadata name="title" mdxType="Metadata" /> will complete
    the instant transfer process for any domain name enrolled in the Fast
    Transfer Service and sold through the Afternic network during this
    timeframe.
  </p>
  <p>
    You acknowledge and agree that <Metadata name="title" mdxType="Metadata" /> may remove your
    domain name from the Fast Transfer Service at any time for any reason,
    without prior notification, including, but not limited to: non-payment of
    fees, expiration of domain name, fraud, restrictions on transfer, the filing
    of a trademark or ownership dispute concerning the domain name, or in the
    event of a transfer of the domain name to another registrar.
  </p>
  <p>
    <strong>3. DESIGNATED AGENT AND CHANGE OF REGISTRANT INFORMATION</strong>
  </p>
  <p>
    “DESIGNATED AGENT” MEANS AN INDIVIDUAL OR ENTITY THAT THE PRIOR REGISTRANT
    OR NEW REGISTRANT EXPLICITLY AUTHORIZES TO APPROVE A CHANGE OF REGISTRANT
    REQUEST ON ITS BEHALF. FOR THE PURPOSE OF FACILITATING THE FAST TRANSFER
    PROCESS, AND IN ACCORDANCE WITH ICANN&#39;S{' '}
    <a href="https://www.icann.org/resources/pages/transfer-policy-2016-06-01-en">
      CHANGE OF REGISTRANT POLICY
    </a>
    , YOU AGREE TO APPOINT <Metadata name="title" mdxType="Metadata" /> AS YOUR DESIGNATED AGENT FOR
    THE SOLE PURPOSE OF EXPLICITLY CONSENTING TO MATERIAL CHANGES OF REGISTRATION
    CONTACT INFORMATION ON YOUR BEHALF.
  </p>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduleh">
    <a href="#scheduleh" name="scheduleh">
      Schedule H
    </a>
    : Terms and Conditions Relating to Expiry Protection and Ownership Protection Services
  </h2>
  <h4>Virtual Private Server (VPS) Acceptable Usage Policy (AUP)</h4>
  <p>
    <strong>Excessive Usage </strong>
  </p>
  <p>
    Customers are required to utilize the server&#39;s resources in an efficient
    and responsible manner. Excessive use of server CPU, bandwidth and memory
    resources by a customer can interfere with or prevent normal service
    performance for other customers. Resources are defined as bandwidth, memory
    and/or processor utilization. A VPS is considered using “Excessive amounts
    of resources” when it monopolizes the resources available using 10% or more
    of system resources for longer than 60 seconds. There are numerous problems
    that could cause such problems, this includes but is not limited to scripts,
    FTP connections, HTTP requests, Crypto currency miners, etc. A site that
    consumes over the account limit of bandwidth is also considered “excessive
    resources”. This policy is only implemented in extreme circumstances and is
    intended to prevent the misuse of our servers. A Customer who is using
    “excessive resources” will be asked to do one or more of the following:
    upgrade their plan, fix the issue causing &#34;excessive use&#34;, or cease
    the activity causing excessive use.
    <Metadata name="title" mdxType="Metadata" /> reserves the right to throttle or cancel any accounts
    that abuse our services or are deemed to be excessive users. <Metadata name="title" mdxType="Metadata" />{' '}
    will be the sole and final arbiter as to what constitutes a violation of this
    policy.
  </p>
  <p>
    <strong>Denial of Service </strong>
  </p> <p>
    <Metadata name="title" mdxType="Metadata" /> absolutely prohibits the use of services or
    network services for the origination or control of denial of service (“DoS”)
    attacks or distributed denial of service (“DDOS”) attacks. Any relation to
    DoS or DDoS type activity is a direct violation of <Metadata name="title" mdxType="Metadata" />
    &#39;s AUP.
  </p>
  <p>
    <strong>Server Abuse </strong>
  </p>{' '}
  <p>
    Any attempts to undermine or cause harm to a <Metadata name="title" mdxType="Metadata" />{' '}
    server or subscriber of <Metadata name="title" mdxType="Metadata" /> is strictly prohibited
    including, but not limited to:
  </p>
  <ul>
    <li>
      {' '}
      Logging into a server or account that you are not authorized to access;
    </li>
    <li>
      {' '}
      Accessing data or taking any action to obtain services or information not intended
      for you or your use without the consent of the owner;
    </li>
    <li>
      {' '}
      Tampering, hacking, modifying, or otherwise corrupting or breaching security
      or authentication measures without proper authorization;
    </li>
    <li>
      {' '}
      Transmitting material that contains viruses, Trojan horses, worms, time bombs,
      cancelbots or other computer programming routines or engines with the intent
      or effect of damaging, destroying, disrupting or otherwise impairing a computer&#39;s
      functionality or the operation of <Metadata name="title" mdxType="Metadata" />
      &#39;s systems;
    </li>
    <li>
      {' '}
      Monitoring data or traffic on any network or system without the express authorization
      of the owner of the system or network;
    </li>
    <li>
      {' '}
      Scanning of any type including but not limited to Port Scanning and Network
      scanning;
    </li>
    <li>
      {' '}
      Interfering with, intercepting or expropriating any system, data or information
      which you do not have the right to access; and
    </li>
    <li>
      {' '}
      Interfering with service to any user, host or network including, without limitation,
      by means of overloading, “flooding,” “mailbombing,” or “crashing” any computer
      system.
    </li>
  </ul>
  <p>
    You agree that we may quarantine or delete any data stored on the{' '}
    <Metadata name="title" mdxType="Metadata" /> network if the data is infected with a virus, or
    is otherwise corrupted, and has the potential to infect or corrupt the
    network or other customers&#39; data that is stored on the network.
  </p>
  <p>
    <strong>IP Address Usage</strong>
  </p>
  <p>
    You may only use IP addresses assigned to you by <Metadata name="title" mdxType="Metadata" />{' '}
    in connection with your <Metadata name="title" mdxType="Metadata" /> Services. You agree that
    if the <Metadata name="title" mdxType="Metadata" /> IP addresses assigned to your account are
    listed on an abuse database, you will be in violation of this AUP, and{' '}
    <Metadata name="title" mdxType="Metadata" /> may take reasonable action to protect its IP
    addresses, including suspension and/or termination of your Service,
    regardless of whether the IP addresses were listed as a result of your
    actions.
  </p>
  <p>
    <strong>Blacklisting/Retaliation</strong>
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> may terminate your Services if your email address
    or related IP number(s) is/are blacklisted by any third-party, or{' '}
    <Metadata name="title" mdxType="Metadata" /> is retaliated against as a result of your use of
    the mail system, regardless of whether you are in breach of this AUP or are
    otherwise at fault.
  </p>
  <p>
    <strong>Security</strong>
  </p>
  <p>
    You are responsible for any misuse of your account, even if the
    inappropriate activity was committed by a friend, family member, guest or
    employee. Therefore, you must take steps to ensure that others do not gain
    access to your account. In addition, you may not use your account to breach
    the security of another account or attempt to gain unauthorized access to
    another network or server. You must take reasonable security precautions.
    You must protect the confidentiality of your password, use complex
    passwords, and you should change your password periodically.{' '}
    <Metadata name="title" mdxType="Metadata" /> uses a shared responsibility model. Customers are
    responsible for securing the following: Customer Data, Applications,
    Platforms, Access management, and Firewalls. All software and scripts
    installed on your account must be free of vulnerabilities, viruses, and
    malware. <Metadata name="title" mdxType="Metadata" /> is responsible for the security of the
    following: Servers, Storage devices, and Networking.
  </p>
  <p>
    <strong>Plesk EULA</strong>
  </p>
  <p>
    Plesk comes pre-installed on all VPS packages, should you choose to use it
    on your server, you agree to be bound by the{' '}
    <a href="https://www.plesk.com/legal/">Plesk EULA </a>, which is hereby
    incorporated by reference.
  </p>
  <p>
    <strong>Service Uptime Guarantee</strong>
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> offers a Service uptime guarantee of 99.9%
    (“Service Uptime Guarantee”) of available time per month. Third party
    monitoring service reports may not be used for justification due to a
    variety of factors including the monitor&#39;s network capacity/transit
    availability. The uptime of the server is defined as the reported uptime
    from the operating system and the Apache Web Server which may differ from
    the uptime reported by other individual services. If we fail to maintain
    this Service Uptime Guarantee in a particular month (as solely determined by
    us), you will be eligible to receive a credit to apply to future services
    billing cycles based upon the Unavailability for that month. The credit may
    be used only for the purchase of further products and services from us, and
    is exclusive of any applicable taxes. The Service Uptime Guarantee does not
    apply to service interruptions caused by: (1) periodic scheduled maintenance
    or repairs we may undertake from time to time; (2) interruptions caused by
    you from custom scripting, coding or the installation of third-party
    applications; (3) outages that do not affect the appearance of your website
    but merely affect access to your website such as FTP and email; (4) causes
    beyond our control or that are not reasonably foreseeable; and (5) outages
    related to the reliability of certain programming environments.
  </p>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulei">
    <a href="#schedulei" name="schedulei">
      Schedule I
    </a>
    : Terms and Conditions Relating to Preferred Partner Program
  </h2>
  <p>
    When enrolled in the Preferred Partner Program, the default payment method
    will be set as account credit, unless <Metadata name="title" mdxType="Metadata" /> is notified
    otherwise. Other payment methods include PayPal, cheque, and ACH.
  </p>
  <p>
    When a customer has been referred to <Metadata name="title" mdxType="Metadata" /> by someone
    enrolled in the Preferred Partner Program, their account must be in good
    standing for three (3) months before a payment will be issued.
  </p>
  <p>
    Premium domain purchases are not included in the Preferred Partner Program
    payment structure.
  </p>
  <p>
    <Metadata name="title" mdxType="Metadata" /> reserves the right to deny entry or revoke status
    in the Preferred Partner Program at any time. The terms of this program may
    also be modified at any time and without prior notice.
  </p>
  <p>
    <a href="#top">Back to Top</a>
  </p>
  <h2 id="registrant">
    <a href="#registrant" name="registrant">
      Registrant Rights, Benefits & Responsibilities
    </a>
  </h2>
  <p>
    If you register a domain name, you become the Registered Name Holder (also
    known as Registrant) for that domain. The Internet Corporation for Assigned
    Names and Numbers (<a href="https://www.icann.org/">ICANN</a>) has set forth
    various rights and responsibilities of Registrants over the registration and
    use of a registered Internet domain name. Further information about
    ICANN&#39;s policies and materials for Registrants is available on the ICANN
    website:
  </p>
  <ul>
    <li>
      <a href="https://www.icann.org/resources/pages/educational-2012-02-25-en">
        Registrant Educational Materials
      </a>
    </li>
    <li>
      <a href="https://www.icann.org/resources/pages/responsibilities-2014-03-14-en">
        Registrant Rights &amp; Responsibilities
      </a>
    </li>
    <li>
      <a href="https://www.icann.org/resources/pages/benefits-2013-09-16-en">
        Registrant&#39;s Benefits &amp; Responsibilities
      </a>
    </li>
  </ul>
  <p>
    <a href="#top">Back to Top</a>
  </p>
    </Metadata>
    <Metadata name="resellerConditional" match="host" value="rebel.ca" mdxType="Metadata">
  <h1>Terms & Conditions</h1>
  <Box justifyContent="space-between" mb={4} mdxType="Box">
      <Stack mdxType="Stack">
          <p>
          <strong>
              <a href="#mainterms">Main Terms and Conditions</a>
          </strong>
          </p>
          <p>
          <strong>
              <a href="#schedulea">Schedule A</a>:
          </strong>{' '}
          Terms and Conditions Relating to Domain Name Registration
          </p>
          <p>
          <strong>
              <a href="#scheduleb">Schedule B</a>:
          </strong>{' '}
          Terms and Conditions Applicable to Email Services
          </p>
          <p>
          <strong>
              <a href="#schedulec">Schedule C</a>:
          </strong>{' '}
          Terms and Conditions Applicable to Web Hosting Services
          </p>
          <p>
          <strong>
              <a href="#scheduled">Schedule D</a>:
          </strong>{' '}
          Terms and Conditions Applicable to the High Security Service
          </p>
          <p>
          <strong>
              <a href="#schedulee">Schedule E</a>:
          </strong>{' '}
          Terms and Conditions Applicable to Privacy Services
          </p>
          <p>
          <strong>
              <a href="#schedulef">Schedule F</a>:
          </strong>{' '}
          Terms and Conditions Applicable to SSL Certificate Services
          </p>
          <p>
          <strong>
              <a href="#scheduleg">Schedule G</a>:
          </strong>{' '}
          Terms and Conditions Relating to Afternic Fast Transfer
          </p>
          <p>
          <strong>
              <a href="#scheduleh">Schedule H</a>:
          </strong>{' '}
          Terms and Conditions Relating to Expiry Protection and Ownership Protection Services
          </p>
          <p>
          <strong>
              <a href="#schedulei">Schedule I</a>:
          </strong>{' '}
          Terms and Conditions Relating to Preferred Partner Program
          </p>
          <p>
          <strong>
              <a href="#registrant">
              Registrant Rights, Benefits & Responsibilities
              </a>
          </strong>
          </p>
      </Stack>
      <Box border={2} p={3} mdxType="Box">
          <div>
              <h3>Additional Terms &amp; Conditions</h3>
              <div>
                <Stack mdxType="Stack">
                  <li className="unit size1of3">
                    <a href="/terms-conditions/asia">.ASIA </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/au">.AU </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/biz"> .BIZ </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/ca">.CA </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/cn">.CN </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/co">.CO </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/eu">.EU </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/info"> .INFO </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/mobi">.MOBI </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/name">.NAME </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/sucks">.SUCKS </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/us">.US </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/xxx"> .XXX </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/highly-regulated">
                      .LAWYER, .DENTIST & .ATTORNEY
                    </a>
                  </li>
                </Stack>
              </div>
          </div>
      </Box>
  </Box>
  <h1 id="mainterms">
  <a href="#mainterms" name="mainterms">
      Main Terms and Conditions
  </a>
  </h1>
  <p>
      <strong>1. INTRODUCTION</strong> In this Service Agreement
      (&#34;Agreement&#34;), &#34;Registrant&#34; &#34;you&#34; and
      &#34;your&#34; refer to each user, customer (collectively
      &#34;Customer&#34;) and its agents, and &#34;Registrar&#34;,
      &#34;we&#34;, &#34;us&#34; and &#34;our&#34; refer to{' '}
      <Metadata name="BlueSnapTitle" mdxType="Metadata" /> (or collectively “
      <Metadata name="title" mdxType="Metadata" />
      ”). This Agreement explains our obligations to you, and your obligations
      to us in relation to the service(s) that you purchase and use from us.
      By selecting <Metadata name="title" mdxType="Metadata" /> service(s) you have agreed to
      establish an account with us for such service(s). When you use your
      account or permit someone else to use your account to purchase or
      otherwise acquire access to additional <Metadata name="title" mdxType="Metadata" />{' '}
      service(s) or to modify or cancel your <Metadata name="title" mdxType="Metadata" />{' '}
      service(s) (even if we were not notified of such authorization), this
      Agreement covers any such service or actions. Any acceptance of your
      application(s) for our service(s) and the performance of our service(s)
      will occur at our offices in the location of our principal place of
      business. You agree that each person listed in your account information
      as being associated with your account for any service(s) provided to you
      is your agent with full authority to act on your behalf for such
      services in accordance with the permissions granted, including but not
      limited to the authorization to terminate, transfer (where permitted by
      this Agreement), or to modify or purchase additional service(s). You
      also agree that if you list, directly or by default,{' '}
      <Metadata name="title" mdxType="Metadata" /> as a contact for your account for any of the
      service(s), we have the right, without notice, to remove our name and/or
      information from any such service(s) and to replace the same with the
      name and/or information provided by you.
  </p>
  <p>
      You agree that <Metadata name="title" mdxType="Metadata" /> may, in its sole discretion,
      renew a domain using any registrar owned by a parent, subsidiary, entity
      under common control and/or entity owned by the same beneficial owner,
      at any time
      <Metadata name="BlueSnapSubsidiaryRef" mdxType="Metadata" />
      . In addition, you agree that <Metadata name="title" mdxType="Metadata" /> may, in its sole
      discretion, transfer or share your <Metadata name="title" mdxType="Metadata" /> account
      information, domains, hosting, additional products, billing history,
      payment information (including without limitation credit card
      information if applicable), payment profile, and/or all other products
      or services to or with a parent, subsidiary, entity under common control
      and/or entity owned by the same beneficial owner, at any time
      <Metadata name="BlueSnapSubsidiaryRef" mdxType="Metadata" />.
  </p>
  <p>
      <strong>Principal place of business & Mailing Address</strong>
  </p>
  <p>
      <Metadata name="BlueSnapTitle" mdxType="Metadata" />: <Metadata name="address" mdxType="Metadata" />
  </p>
  <p>
      IMPORTANT NOTICE - ARBITRATION AGREEMENT AND CLASS ACTION WAIVER: BY
      AGREEING TO BE BOUND BY THE TERMS OF SERVICE, YOU AGREE THAT ALL
      DISPUTES BETWEEN US WILL BE RESOLVED BY BINDING ARBITRATION, EXCEPT FOR
      CERTAIN LIMITED TYPES OF DISPUTES DESCRIBED IN SECTION 23 BELOW. YOUR
      AGREEMENT TO ARBITRATION MEANS YOU ARE GIVING UP THE RIGHT TO GO TO
      COURT AND THE RIGHT TO A TRIAL BY JURY, AND INSTEAD, DISPUTES WILL BE
      DECIDED BY A NEUTRAL ARBITRATOR. YOU ALSO AGREE THAT ALL DISPUTES
      BETWEEN US, WHETHER IN COURT OR IN ARBITRATION, WILL BE BROUGHT ONLY ON
      AN INDIVIDUAL BASIS AND YOU ARE WAIVING YOUR RIGHT TO BRING OR
      PARTICIPATE IN A CLASS ARBITRATION OR CLASS ACTION. PLEASE READ SECTION
      23 OF THIS AGREEMENT FOR FURTHER DETAILS.
  </p>
  <p>
      <strong>2. SECURITY</strong> When you register a domain name or
      subscribe to our service(s) with us, we provide you with a password or
      passphrase that can be used to modify your information. It is your
      responsibility to safeguard your password or passphrase. You accept full
      responsibility for modifications made to your service(s) using this
      password or passphrase.
  </p>
  <p>
      <strong>3. VARIOUS SERVICES</strong> Unless otherwise stated, all
      promotions and special offers are for the first year only and products
      and/or services will renew at regular price. The terms of this Agreement
      are applicable to any and all of the <Metadata name="title" mdxType="Metadata" />
      &#39;s service(s) you have chosen, including any additional services you
      may choose in the future which may be offered by{' '}
      <Metadata name="title" mdxType="Metadata" /> from time to time.{' '}
      <b>NOTICE REGARDING BUNDLED SERVICES:</b> If you purchase{' '}
      <Metadata name="title" mdxType="Metadata" /> services that are sold together as a “bundled”
      package (e.g., you select a web site package that includes both a domain
      name and hosting services, as opposed to your purchasing such services
      separately) (&#34;Bundled Services&#34;), termination of any part of the
      service will result in termination of all services provided as part of
      the bundled package.{' '}
  </p>
  <p>
      <strong>4. FEES AND PAYMENT</strong> As consideration for the services
      you have selected, you agree to pay <Metadata name="title" mdxType="Metadata" /> the
      applicable service(s) fees set forth on our Web site at the time of your
      selection. All fees are due immediately and are non-refundable.{' '}
      <Metadata name="title" mdxType="Metadata" /> may take all remedies available to collect
      fees owed and may recover from you all costs and expenses (including
      reasonable attorney fees) incurred by <Metadata name="title" mdxType="Metadata" /> to
      collect such fees. If you qualify, we may extend payment terms to you.
      You agree to recurring payments and a recurring billing schedule for
      your services. We reserve the right to change our prices and will post{' '}
      <a href="/Domain-Pricing.aspx">prices on our website</a>.{' '}
  </p>
  <p>
      <strong>5. TERM OF SERVICE</strong> Unless otherwise specified, each{' '}
      <Metadata name="title" mdxType="Metadata" /> service is for a one-year initial term and is
      automatically renewed thereafter for successive one-year terms. A domain
      registered by you will be billed annually, until you choose to cancel
      the domain. Domain renewals, recovery or other services with us are
      subject to our then current Terms and Conditions as well as payment of
      all applicable service fees at the time of the recurring charge. Domain
      name renewals and recovery are subject to the registry&#39;s acceptance
      of your domain name registration.
  </p>
  <p>
      Should you select to pay upfront for a multiple year term, each year on
      the anniversary of the registration <Metadata name="title" mdxType="Metadata" /> will pay
      on your behalf to the registry the required registry fees until the term
      you have purchased expires or we are no longer
      your registrar. Should the registry raise its fees,{' '}
      <Metadata name="title" mdxType="Metadata" /> will inform you and collect the difference for
      the term remaining.
  </p>
  <p>
      In addition to other termination provisions contained in this Agreement,
      if you purchase Bundled Services, any termination relating to such
      bundle will terminate all <Metadata name="title" mdxType="Metadata" /> services included in
      such bundle. For instance, any domain name registered with or maintained
      by <Metadata name="title" mdxType="Metadata" /> under this Agreement will be cancelled and
      may thereafter be available for registration by another party. Upon the
      effective date of termination, <Metadata name="title" mdxType="Metadata" /> will no longer
      provide the bundled services to you, any leases granted to you shall
      immediately terminate, and you will cease using such services
      immediately; provided, however, that <Metadata name="title" mdxType="Metadata" /> may, in
      its sole discretion and subject to your agreeing to be bound by the
      applicable agreement(s) and to pay the applicable fees for such
      services, allow you to convert certain services included in the bundled
      services to stand alone services.
  </p>
  <p>
      <strong>6. ACCURATE INFORMATION</strong> As further consideration for
      the <Metadata name="title" mdxType="Metadata" /> service(s), you agree to:{' '}
  </p>
  <blockquote>
      <p>
          6.1 provide certain current, complete and accurate information about
          you as required;{' '}
      </p>
      <p>
          6.2 maintain and update this information as needed to keep it current,
          complete and accurate; and{' '}
      </p>
      <p>
          6.3 respond within fifteen (15) calendar days to a request by us to
          update or confirm the accuracy of your information.{' '}
      </p>
  </blockquote>
  <p>
      We rely on this information to carry out our services for you and comply
      with the requirements of the registries of domain names and our service
      providers and to send you important information and notices regarding
      your account and our services. Any failure by you to provide or update
      such information or to respond to our request is a material breach of
      this Agreement.{' '}
  </p>
  <p>
      <strong>7. PRIVACY POLICY</strong> Our privacy policy, located on our
      Web site at <Metadata name="link" path="/privacy-policy" mdxType="Metadata" /> incorporated
      herein by reference, sets forth your and our rights and responsibilities
      with regard to your personal information. You agree to read the privacy
      policy. You agree that we, in our sole discretion, may modify our
      privacy policy. We will post such revised statement on our Web site at
      least thirty (30) calendar days before it becomes effective. You agree
      to periodically review our Web site to be aware of any such revisions.
      You agree that, by using our services after modifications to the privacy
      policy become effective, you have agreed to these modifications. You
      acknowledge that if you do not agree to any such modification, you may
      terminate this Agreement by providing us with notice in accordance with
      Section 25 below. We will not refund any fees paid by you if you
      terminate your Agreement with us. We will not process the personal
      information that we collect from you in a way incompatible with the
      purposes and other limitations described in our privacy policy, and we
      will take reasonable precautions to protect your personal information
      from loss, misuse and unauthorized access, disclosure, alteration or
      destruction.{' '}
  </p>
  <p>
      <strong>8. THIRD PARTY INFORMATION</strong> You represent and warrant
      that you have provided notice to, and obtained consent from, any third
      party individuals whose personal information you supply to us as part of
      our services with regard to:{' '}
  </p>
  <blockquote>
      <p>
          8.1 the purposes for which such third party&#39;s personal information
          has been collected;
      </p>
      <p>
          8.2 the intended recipients or categories of recipients of the third
          party&#39;s personal information;{' '}
      </p>
      <p>
          8.3 which parts of the third party&#39;s information are obligatory
          and which parts, if any, are voluntary; and{' '}
      </p>
      <p>
          8.4 how the third party can access and, if necessary, rectify the
          third party&#39;s personal information..{' '}
      </p>
  </blockquote>
  <p>
      You further agree to provide such notice and obtain such consent with
      regard to any third party personal information you supply to us in the
      future. We are not responsible for any consequences resulting from your
      failure to provide notice or receive consent from such individuals or
      for your providing outdated, incomplete or inaccurate information.{' '}
  </p>
  <p>
      <strong>9. MODIFICATIONS TO AGREEMENT</strong> Except as otherwise
      provided in this Agreement, you agree, during the term of this
      Agreement, that we may:{' '}
  </p>
  <blockquote>
      <p>
          9.1 revise the terms and conditions of this Agreement at any time;
          and/or{' '}
      </p>
      <p>
          9.2 change the services provided under this Agreement at any time.
      </p>
  </blockquote>
  <p>
      Any such revision or change will be binding and effective ten (10)
      calendar days after the revised Agreement or change to the service(s) is
      posted on <Metadata name="title" mdxType="Metadata" />
      &#39;s Web site, or upon notification to you in accordance with Section
      25 below. You agree to periodically review our Web site, including the
      current version of this Agreement available on our Web site, to be aware
      of any such revisions. If you do not agree with any revision to the
      Agreement or change to the services, you may terminate this Agreement at
      any time by providing us with notice in accordance with Section 25
      below. Notice of your termination will be effective on receipt and
      processing by us. Any fees paid by you prior to termination of your
      Agreement with us are nonrefundable, and you will not incur any
      additional fees. By continuing to use <Metadata name="title" mdxType="Metadata" />
      &#39;s services ten (10) calendar days after any revision to this
      Agreement or change in service(s) is posted on our Web site, you agree
      to abide by and be bound by any such revisions or changes. We are not
      bound by and you may not rely on any representation concerning this
      Agreement or our services made by:{' '}
  </p>
  <blockquote>
      <p>
          9.1.a any agent, representative or employee of any third party that
          you may use to apply for our services; and/or
      </p>
      <p>
          9.2.a information posted on our Web site of a general informational
          nature. No employee, contractor, agent or representative of{' '}
          <Metadata name="title" mdxType="Metadata" /> is authorized to alter or amend the terms
          and conditions of this Agreement.{' '}
      </p>
  </blockquote>
  <p>
      <strong>10. MODIFICATIONS TO YOUR ACCOUNT</strong> In order to change
      any of your account information with us, you must use the account number
      and the password or passphrase that was provided to you by{' '}
      <Metadata name="title" mdxType="Metadata" />. Please safeguard your account number and
      password or any security authentication option from any unauthorized
      use. In no event will we be liable for the unauthorized use or misuse of
      your account number and password or passphrase.{' '}
  </p>
  <p>
      <strong>11. AGENTS</strong> You agree that, if your agent purchased our
      service(s) on your behalf, you are nonetheless bound as a principal by
      all terms and conditions herein, including the ICANN UDRP, ICANN URS and
      the Dispute Policy, whether your agent was authorized by you or not. You
      certify that your agent is authorized to apply for our services on your
      behalf, that he or she is authorized to bind you to the terms and
      conditions of this Agreement and that he or she has apprised you of the
      terms and conditions of this Agreement. In addition, you are responsible
      for any errors made by your agent. We will not refund any fees paid by
      you or your agent on your behalf for any reason based on any act or
      omission of your agent.{' '}
  </p>
  <p>
      <strong>12. NOTICES AND ANNOUNCEMENTS</strong> You authorize us to
      notify you electronically, as our Customer, of information that we deem
      is of potential interest to you. Notices and announcements may include
      commercial emails and other notices describing changes, upgrades, new
      products and services or other information pertaining to domain names,
      Internet security or to enhance your identity on the Internet and/or
      other relevant matters. If you do not wish to receive bulk email
      solicitation notices or announcements please send us an email at{' '}
      <Metadata addr="service" name="mailLink" mdxType="Metadata" />.{' '}
  </p>
  <p>
      <strong>13. LIMITATION OF LIABILITY</strong> To the maximum extent
      permitted at law, <Metadata name="title" mdxType="Metadata" />, its parent, subsidiary,
      affiliated companies, and/or companies under common control, and/or
      their respective owners, beneficial owners, directors, officers,
      shareholders, employees, contractors, agents, partners, affiliates,
      successors and assigns shall not be liable for any direct, indirect,
      incidental, special or consequential damages resulting from your use or
      inability to use any of the <Metadata name="title" mdxType="Metadata" /> services or for
      the cost of procurement of substitute services. Moreover,{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s suppliers, service providers, and/or their respective owners,
      beneficial owners, directors, officers, shareholders, employees,
      contractors, agents, partners, affiliates, successors and assigns, shall
      not be liable for any direct, indirect, incidental, special or
      consequential damages resulting from your use or inability to use any of
      the <Metadata name="title" mdxType="Metadata" /> services or for the cost of procurement of substitute
      services. We collectively expressly disclaim any and all loss or
      liability resulting from, but not limited to:{' '}
  </p>
  <blockquote>
      <p>13.1 any failure or inability to register the domain name;</p>
      <p>
          13.2 any third party claims arising from or based on your domain name
          or use of our services;
      </p>
      <p>13.3 access delays or access interruptions;</p>
      <p>13.4 data non-delivery or data mis-delivery;</p>
      <p>13.5 acts of God;</p>
      <p>
          13.6 the unauthorized use or misuse of your account number or password
          or passphrase;
      </p>
      <p>
          13.7 errors, omissions, or misstatements in any and all information or
          service(s) provided under this Agreement;
      </p>
      <p>13.8 the deletion of or failure to store email messages;</p>
      <p>13.9 the development or interruption of your Web site;</p>
      <p>
          13.10 our processing of your application for our services, our
          processing of any authorized modification to your domain name record
          or your agents failure to pay any fees, including the initial
          registration fee or re-registration fee; or
      </p>
      <p>
          13.11 the application of the ICANN UDRP, ICANN URS or the Dispute
          Policy.{' '}
      </p>
  </blockquote>
  <p>
      You agree that our entire liability, and your exclusive remedy, with
      respect to any <Metadata name="title" mdxType="Metadata" /> service(s) provided under this
      Agreement and/or for any breach of this Agreement is solely limited to
      the amount you paid for such service(s).{' '}
  </p>
  <p>
      <strong>14. INDEMNITY</strong> You agree to release, indemnify, and
      hold <Metadata name="title" mdxType="Metadata" /> and its parent, subsidiary, affiliated
      companies, and/or companies under common control, and their respective
      owners, beneficial owners, directors, officers, shareholders, employees,
      contractors, agents, partners, affiliates, successors and assigns - as
      well as <Metadata name="title" mdxType="Metadata" />
      &#39;s suppliers or service providers, or their respective owners,
      beneficial owners, directors, officers, shareholders, employees,
      contractors, agents, partners, affiliates, successors and assigns
      harmless from all liabilities, claims, damages, costs and expenses,
      including reasonable attorneys&#39; fees and expenses, relating to or
      arising from your domain name registration or use of your domain name or
      the <Metadata name="title" mdxType="Metadata" /> services provided hereunder. When we are
      threatened with suit or sued by a third party, we may seek written
      assurances from you concerning your promise to indemnify us. Your
      failure to provide those assurances may be considered by us to be a
      material breach of this Agreement. In the event we are made a party to
      any claim, suit or action by you which is unsuccessful or by a third
      party in each case relating to or arising from your domain name
      registration or use of your domain name or the <Metadata name="title" mdxType="Metadata" />{' '}
      services provided hereunder, you will reimburse us, at a reasonable
      rate, for all personnel time and expenses expended by us in response to
      such claim, suit or action including without limitation, all attorney
      fees and expenses incurred by us with respect to such response.
  </p>
  <p>
      In addition, you agree to indemnify and hold harmless the applicable
      registry operator and its owners, beneficial owners, directors,
      officers, shareholders, employees and agents from and against any and
      all claims, damages, liabilities, costs and expenses (including
      reasonable legal fees and expenses) arising out of or related to your
      domain name registration.
  </p>
  <p>
      <strong>15. BREACH</strong> You agree that your failure to abide by any
      provision of this Agreement, any <Metadata name="title" mdxType="Metadata" /> operating
      rule or policy, the ICANN UDRP, ICANN URS or the Dispute Policy may be
      considered by us to be a material breach of this Agreement and that we
      may provide to you a written notice in accordance with Section 25 below,
      describing the breach, to you. If within ten (10) calendar days of the
      date of such notice, you fail to provide evidence, which is reasonably
      satisfactory to us, that you have not breached your obligations under
      the Agreement, then we may delete the registration or reservation of
      your domain name, transfer the domain name to <Metadata name="title" mdxType="Metadata" />{' '}
      and/or terminate the other <Metadata name="title" mdxType="Metadata" /> service(s) you are
      using without further notice. We will not refund any fees paid by you
      prior to the termination of your Agreement due to your breach. Any such
      breach by you shall not be deemed to be excused simply because we did
      not act earlier in response to that, or any other breach, by you.{' '}
  </p>
  <p>
      <strong>16. REPRESENTATIONS AND WARRANTIES</strong> You agree and
      warrant that:{' '}
  </p>
  <blockquote>
      <p>
          16.1 the information that you or your agent on your behalf provide to
          us during the application process to register your domain name or to
          apply for other <Metadata name="title" mdxType="Metadata" />
          &#39;s service(s) is, accurate and complete, and that any future
          changes to this information will be provided to us in a timely manner;
      </p>
      <p>
          16.2 to the best of your knowledge and belief that neither the
          registration of your domain name nor the manner in which you intend to
          use such domain name will directly or indirectly infringe the legal
          rights of any third party;
      </p>
      <p>
          16.3 you have all requisite power and authority to execute this
          Agreement and to perform your obligations hereunder;
      </p>
      <p>
          16.4 you have selected the necessary security option(s) for your
          domain name registration record; and
      </p>
      <p>
          16.5 you are of legal age of 18 years or over to enter into this
          Agreement.{' '}
      </p>
  </blockquote>
  <p>
      You agree that your use of our service(s) is solely at your own risk.
      You agree that all of our services are provided on an &#34;as is,&#34;
      and &#34;as available&#34; basis.{' '}
  </p>
  <p>
      <strong>17. DISCLAIMER</strong> WE EXPRESSLY DISCLAIM ALL CONDITIONS,
      WARRANTIES AND REPRESENTATIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
      INCLUDING BUT NOT LIMITED TO THE IMPLIED CONDITIONS AND WARRANTIES OF
      MERCHANTABLE QUALITY, FITNESS FOR A PARTICULAR PURPOSE AND
      NON-INFRINGEMENT. WE MAKE NO WARRANTY OR REPRESENTATION THAT OUR
      SERVICE(S) WILL MEET YOUR REQUIREMENTS, OR THAT THE SERVICE(S) WILL BE
      UNINTERRUPTED, TIMELY, SECURE, OR ERROR FREE; NOR DO WE MAKE ANY
      WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE
      SERVICE(S) OR AS TO THE ACCURACY OR RELIABILITY OF ANY INFORMATION
      OBTAINED THROUGH OUR SERVICE. YOU UNDERSTAND AND AGREE THAT ANY MATERIAL
      AND/OR DATA DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF OUR
      SERVICE IS DONE AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL BE
      SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF
      DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL AND/OR DATA. WE
      MAKE NO WARRANTY OR REPRESENTATION REGARDING ANY GOODS OR SERVICES
      PURCHASED OR OBTAINED THROUGH ANY OF OUR SERVICES OR ANY TRANSACTIONS
      ENTERED INTO THROUGH SUCH SERVICES. NO ADVICE OR INFORMATION, WHETHER
      ORAL OR WRITTEN, OBTAINED BY YOU FROM US SHALL CREATE ANY CONDITION OR
      WARRANTY NOT EXPRESSLY MADE HEREIN. TO THE EXTENT JURISDICTIONS DO NOT
      ALLOW THE EXCLUSION OF CERTAIN WARRANTIES, SOME OF THE ABOVE EXCLUSIONS
      MAY NOT APPLY TO YOU.{' '}
  </p>
  <p>
      <strong>18. RIGHT OF REFUSAL</strong> We, in our sole discretion,
      reserve the right to:{' '}
  </p>
  <blockquote>
    <p>
      18.1 refuse to register or renew your chosen domain name or register or
      renew you for other <Metadata name="title" mdxType="Metadata" /> service(s); and/or
    </p>
    <p>
      18.2 cancel or terminate your domain name registration, domain name
      renewal and/or any other services provided by us, at any time and for any
      reason; in such event, we will refund any applicable fee(s) you have paid,
      less applicable administration fees.
    </p>
  </blockquote>
  <p>
      You agree that we shall not be liable to you for loss or damages that
      may result from our refusal to register your domain name, the deletion
      your domain name or our refusal to register you for other{' '}
      <Metadata name="title" mdxType="Metadata" /> service(s).{' '}
  </p>
  <p>
      <strong>19. SEVERABILITY</strong> You agree that the terms of this
      Agreement are severable. If any term or provision is declared invalid or
      unenforceable, that term or provision will be construed consistent with
      applicable law as nearly as possible to reflect the original intentions
      of the parties, and the remaining terms and provisions will remain in
      full force and effect.{' '}
  </p>
  <p>
      <strong>20. ENTIRETY</strong> You agree that this Agreement, the rules
      and policies published by us, the ICANN UDRP, ICANN URS, the Dispute
      Policy and the privacy statement are the complete and exclusive
      agreement between you and us regarding our services. This Agreement, our
      rules and policies, the ICANN UDRP, ICANN URS, the Dispute Policy and
      the privacy statement supersede all prior agreements, representations
      and understandings, whether established by custom, practice, policy or
      precedent.{' '}
  </p>
  <p>
      <strong>21. NON-ASSIGNMENT</strong> Your rights under this Agreement
      are not assignable. Any attempt by you to assign your rights shall
      render this Agreement voidable at our option. Any attempt by your
      creditors to obtain an interest in your rights under this Agreement,
      whether by attachment, garnishment or otherwise, shall render this
      Agreement voidable at our option.{' '}
  </p>
  <p>
      <strong>22. GOVERNING LAW</strong> You agree that this Agreement and
      any disputes hereunder shall be governed in all respects by and
      construed in accordance with the laws of the Province of Ontario,
      Canada, excluding its conflict of laws rules. You and we each submit to
      exclusive subject matter jurisdiction, personal jurisdiction and venue
      of the Province of Ontario, Canada.
  </p>
  <p>
      <strong>23. WAIVER OF CLASS ACTIONS; ARBITRATION</strong>
  </p>
  <p>
      23.1 Binding Arbitration. You and <Metadata name="title" mdxType="Metadata" />{' '}
      acknowledge that any statutory or common law claims related to
      intellectual property may require forms of equitable relief that are
      best administered by courts; accordingly, you and{' '}
      <Metadata name="title" mdxType="Metadata" /> agree that, except for i) statutory or
      common law claims related to intellectual property, and ii) any claims
      that may be brought in small claims court where the amount in
      controversy is properly within the jurisdiction of such court
      (collectively, “Excluded Claims”), any controversy or claim arising
      out of or relating to this Agreement, your relationship to{' '}
      <Metadata name="title" mdxType="Metadata" /> as a Customer, or your use of any of{' '}
      <Metadata name="title" mdxType="Metadata" /> services and/or services provided by its
      parent, subsidiary, entity under common control and/or entity owned by
      the same beneficial owner, whether based in contract, tort, statute,
      fraud, misrepresentation or any other legal theory (the “Covered
      Claims”), will be resolved by binding, individual arbitration. YOUR
      AGREEMENT TO ARBITRATION MEANS THAT FOR ALL COVERED CLAIMS, YOU ARE
      GIVING UP YOUR RIGHT TO FILE A LAWSUIT IN COURT AND THE RIGHT TO A
      TRIAL BY JURY. INSTEAD, YOU WILL HAVE A HEARING BEFORE A NEUTRAL
      ARBITRATOR.
  </p>
  <p>
      23.2 WAIVER OF CLASS ACTIONS. YOU AND{' '}
      <span style={{
          textTransform: 'uppercase'
        }}>
      <Metadata name="title" mdxType="Metadata" />
      </span>{' '}
      AGREE THAT EACH PARTY MAY BRING DISPUTES RELATING TO BOTH COVERED
      CLAIMS AND EXCLUDED CLAIMS AGAINST THE OTHER PARTY ONLY IN AN
      INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY
      PURPORTED CLASS OR REPRESENTATIVE PROCEEDING, INCLUDING, WITHOUT
      LIMITATION, A FEDERAL OR CLASS ACTION LAWSUIT OR A CLASS ARBITRATION.
  </p>
  <p>
      23.3 Conduct of Arbitration; Governing Rules. Any arbitration shall be
      submitted exclusively to final and binding arbitration in accordance
      with the Arbitration Act, 1991 (Ontario). The parties agree that three
      (3) arbitrators shall preside – each of us will select an arbitrator
      and those two arbitrators will select the third.
  </p>
  <p>
      The arbitrators shall have the power to decide any motions brought by
      either of us to the arbitration, including motions requesting that a
      judgment be awarded on any claims raised in arbitration. The
      arbitrators shall be empowered to award any appropriate relief,
      including remedies at law, in equity or injunctive relief (including a
      temporary restraining order). The arbitrators may award either of us
      any remedy to which that party is entitled under applicable law, but
      such remedies shall be limited to those that would be available to a
      party in a court of law for the claims presented to and decided by the
      arbitrators. The arbitrators will issue a decision or award in
      writing, stating the essential findings of fact and conclusions of
      law. A court of competent jurisdiction shall have the authority to
      enter a judgment upon the award made pursuant to the arbitration
      proceeding.
  </p>
  <p>
      All issues are for the arbitrator to decide, except those issues
      relating to the scope, application, and enforceability of the
      arbitration provision – including whether any claims are Covered
      Claims or Excluded Claims within the meaning of this provision – are
      for the court to decide. As stated in Section 22, Ontario Canadian law
      applies to any arbitration under this section.
  </p>
  <p>
      Prior to initiating arbitration for a Covered Claim, both parties
      agree that they will provide individualized written notice of the
      potential claim to the opposing party setting forth: (1) the factual
      and legal basis for the claim; (2) contact information for the
      potential claimant and their counsel, if any; and (3) the remedies
      sought, including the amount of claimed monetary damages (the
      “Notice”). Following receipt of the Notice by the opposing party, the
      parties agree to make a good faith effort for at least 30 days to
      resolve the claim before resorting to more formal means of resolution,
      including, without limitation, arbitration or any court action. To
      provide notice of a claim to us, write to legal@rebel.ca or to
      Rebel.ca Corp. Attn: Legal Department, 377 Dalhousie, Unit 202,
      Ottawa, Ontario, K1N 9N8.
  </p>
  <p>
      Unless you and <Metadata name="title" mdxType="Metadata" /> agree otherwise in writing,
      any hearings for the arbitration will take place in Ottawa. Payment of
      all filing, administration, and arbitrator fees will be governed by
      the AAA Rules, except that if the arbitrator finds at any time that a
      claim was filed frivolously, for purposes of harassment, or otherwise
      in bad faith, then the filing party will reimburse the other party for
      all costs and fees, including attorneys&#39; fees, associated with
      that claim.
  </p>
  <p>
      Judgment on the award rendered by the arbitrator may be entered in any
      federal or provincial court of competent jurisdiction located in
      Ontario, Canada. The arbitrator may award money or equitable relief in
      favor of only the individual party seeking relief and only to the
      extent necessary to provide relief warranted by that party&#39;s
      individual claim. To reduce the time and expense of the arbitration,
      the arbitrator will not provide a statement of reasons for his or her
      award unless requested to do so by both parties.
  </p>
  <p>
      23.4 For all litigation regarding Excluded Claims and any other
      controversy or claim for which arbitration is denied, the sole
      jurisdiction and venue for such litigation will be an appropriate
      court located in the Province of Ontario, Canada.
  </p>
  <p>
      23.5 All provisions of this Dispute Resolution – Arbitration and
      Waiver of Class Actions Section will survive termination of this
      Agreement, your relationship with us, and/or your account or profile.
  </p>
  <p>
      <strong>24. AGREEMENT TO BE BOUND</strong> By applying for the
      service(s) of <Metadata name="title" mdxType="Metadata" /> or an affiliated site or service on through
      our online application process or by applying for and registering a
      domain name using the service(s) provided by <Metadata name="title" mdxType="Metadata" />,
      its affiliates, entities under common control and/or entities owned by
      the same beneficial under this Agreement, you acknowledge that you have
      read and agree to be bound by all terms and conditions of this
      Agreement, the ICANN UDRP, ICANN URS the Dispute Policy and any
      pertinent rules or policies that are or may be published by{' '}
      <Metadata name="title" mdxType="Metadata" /> or ICANN. In addition, if you are registering
      other top level or country-code domain names (including, but not limited
      to .AU, .BIZ, .EU, .ORG, and/or other domain names) or any additional
      services, you have read and agree to the terms and conditions of those
      provisions.
  </p>
  <p>
      <strong>25. NOTICES</strong> All notices to be provided under this
      Agreement to the other shall be validly given if sent by email, personal
      or courier delivery or by ordinary mail as follows:{' '}
  </p>
  <blockquote>
      <p>
          25.1 to <Metadata name="title" mdxType="Metadata" />: via email sent to legal@ rebel.ca
          and in writing to sent to Rebel.ca Attn: Legal Department , 377
          Dalhousie, Unit 202, Ottawa, Ontario, K1N 9N8
      </p>
      <p>
          25.2 to Customer: via email to the e-mail address you provided us as
          the primary account contact. You agree that all notices, disclosures,
          and other communications we provide you electronically satisfy any
          legal requirement that such communications be in writing. You agree
          that you can store such electronic communications such that they
          remain accessible to you in an unchanged form.{' '}
      </p>
  </blockquote>
  <p>
      Confirmation of annual billing for domains will be received by email to
      the primary account contact. Around the time of cancellation due to user
      request, failed payment, or for any other reason a domain is cancelled,
      the owned customer will receive two notification emails (a month and a
      week prior to expiry date) to their primary email address. The customer
      will also receive another notification email after one week of the
      expiry date.
  </p>
  <p>
      <strong>26. TIME CALCULATIONS</strong> <Metadata name="title" mdxType="Metadata" />{' '}
      operates in accordance with Coordinated Universal Time (UTC). Any and all
      references to timing in this Agreement, and all schedules and appendices
      hereto, are to be interpreted in accordance with UTC.
  </p>
  <p>
      <strong>27. INCORPORATION BY REFERENCE</strong> EACH REGISTRY FOR
      DOMAIN NAMES AND CERTAIN OTHER SERVICE PROVIDERS WHO SUPPLY CERTAIN{' '}
      <span style={{
          textTransform: 'uppercase'
        }}>
      <Metadata name="title" mdxType="Metadata" />
      </span>{' '} CORP. SERVICES OFFERED BY{' '}
      <span style={{
          textTransform: 'uppercase'
        }}>
      <Metadata name="title" mdxType="Metadata" />
      </span>{' '} CORP. TO YOU, REQUIRE US TO INCORPORATE
      CERTAIN TERMS AND CONDITIONS INTO OUR AGREEMENT WITH YOU, AS SET FORTH
      BELOW.{' '}
  </p>
  <p>
      ALL SUCH TERMS, AND ALL OF THE OTHER SCHEDULES ATTACHED TO THESE MAIN
      TERMS AND CONDITIONS, ARE INCORPORATED BY REFERENCE INTO THIS AGREEMENT
      AND APPLY TO YOUR DOMAIN NAME(S) AND ANY APPLICABLE{' '}
      <span style={{
          textTransform: 'uppercase'
        }}>
      <Metadata name="title" mdxType="Metadata" />
      </span>{' '} CORP. SERVICES PURCHASED BY YOU, AND YOU AGREE
      TO BE BOUND BY THEM.
  </p>
  <p>
      <strong>28. TAXES</strong> All domain name registrations, email, hosting or any other services offered by <Metadata name="title" mdxType="Metadata" /> are subject to the Goods and Services Taxes unless you meet the following requirements:
  </p>
  <blockquote>
      <p>
          28.1 You certify that you are neither a Canadian resident nor reside in Canada or its territories; and
      </p>
      <p>
          28.2 You warrant that your billing address is located outside Canada
      </p>
  </blockquote>
  <p>
      <strong>29. SURVIVAL</strong> In the event this Agreement terminates as
      provided herein, Sections 1, 3, 4, 11, 13, 14, 17, 20, 21, 22, 23, 24,
      25, 27, 28 and 29 of this Agreement, and all releases, indemnities,
      waivers and disclaimers set forth in any Schedule annexed hereto, shall
      survive such expiration or termination.
  </p>
  <p>
      <strong>30. CANCELLED DOMAINS</strong> Domains can be cancelled
      following the user&#39;s cancellation request, or by us due to payment
      failure, a violation of our Terms of Use or a delinquent account.
  </p>
  <blockquote>
      <p>
          30.1 A recovery fee of USD$5.00 will be charged to recover domains in
          cancelled status (available for 30 days after a domain has been
          cancelled).{' '}
      </p>
      <p>
          30.2 To recover domains in a &#34;Redemption Grace Period&#34; status,
          there is an additional recovery fee of USD$50.00 for each .CA domain,
          and USD$100.00 for any other domains in other TLDs.{' '}
      </p>
  </blockquote>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulea">
      <a href="#schedulea" name="schedulea">
          Schedule A
      </a>
      : Terms and Conditions Relating to Domain Name Registration
  </h2>
  <p>
      <strong>1. NO GUARANTY</strong> You agree that, the registration of
      your chosen domain name does not confer immunity from objection to
      either the registration or use of your domain name.
  </p>
  <p>
      <strong>2 SECURITY</strong> <Metadata name="title" mdxType="Metadata" /> does not
      guarantee the security of your domain name registration records, and you
      assume all risks that the password and/or passphrase you select may be
      compromised as a result of fraudulent, unauthorized or illegal use.
  </p>
  <p>
      <strong>3. TRANSFERS</strong> You agree that you may not transfer your
      domain name registration to another domain name registrar during the
      first sixty (60) days from the effective date of your initial domain
      name registration with us (except for .au and .name domain names).{' '}
  </p>
  <p>
      <strong>4. LICENSING OF DOMAIN NAME</strong> You hereby acknowledge and
      agree that if you license use of your domain name to a third party you
      nonetheless remain the registrant of record and are responsible for
      providing your own full contact information and for providing and
      updating accurate technical and administrative contact information
      adequate to facilitate timely resolution of any problems that arise in
      connection with the domain name. If you are licensing use of a domain
      name you hereby accept liability for harm caused by wrongful use of the
      domain name, unless you disclose the identity of the licensee within
      seven (7) days to the party providing reasonable evidence of actionable
      harm.{' '}
  </p>
  <p>
      <strong>5. PROVISION OF REGISTRATION DATA</strong> As part of the
      registration process, you are required to provide us with certain
      information and to update this information and correct and update them
      within seven (7) days of any change during the term of the registration.
      This information includes: the full name, postal address, e-mail
      address, voice telephone number, and fax number if available of the
      Registered Name Holder; name of authorized person for contact purposes
      in the case of an Registered Name Holder that is an organization,
      association, or corporation; the names of the primary nameserver and
      secondary nameserver(s) of the registered name; The name, postal
      address, e-mail address, voice telephone number, and (where available)
      fax number of the technical contact for the registered name; and the
      name, postal address, e-mail address, voice telephone number, and (where
      available) fax number of the administrative contact for the registered
      name.{' '}
  </p>
  <p>
      Willful provision of inaccurate or unreliable information, its willful
      failure promptly to update information provided within seven (7) days of
      any change, or its failure to respond for over fifteen (15) calendar
      days to inquiries concerning the accuracy of contact details associated
      with the registration shall constitute a material breach and be a basis
      for suspension and/or cancellation of the registration.{' '}
  </p>
  <p>
      <strong>6. USE OF INFORMATION</strong>
  </p>
  <blockquote>
      <p>
          6.1 In accordance with our privacy statement, which can be found at{' '}
          <Metadata name="link" path="/privacy-policy" mdxType="Metadata" />, and in order for us
          to comply with the current rules and policies of the domain name
          system, you hereby grant <Metadata name="title" mdxType="Metadata" /> the right to
          disclose to the public the following mandatory information that you
          are required to provide when registering or reserving a domain name:{' '}
      </p>
      <blockquote>
          <p>6.1.1 the domain name(s) registered by you;</p>
          <p>6.1.2 your name and postal address; </p>
          <p>
          6.1.3 the name(s), postal address(es), email address(es), voice
          telephone number(s) and where available the fax number(s) of the
          technical and administrative contacts for your domain name(s);
          </p>
          <p>
          6.1.4 the Internet protocol numbers of the primary nameserver and
          secondary nameserver(s) for such domain name(s);
          </p>
          <p>6.1.5 the corresponding names of those nameserver(s);</p>
          <p>6.1.6 the original creation date of the registration; and</p>
          <p>6.1.7 the domain&#39;s expiry date</p>
      </blockquote>
      <p>
          6.2 In addition, we are required to make this information available in
          bulk form to third parties who agree not to use it to (a) allow,
          enable or otherwise support the transmission of mass unsolicited,
          commercial advertising or solicitations via email (spam) or (b) enable
          high volume, automated, electronic processes that apply to our systems
          to register domain names.{' '}
      </p>
  </blockquote>
  <p>
      <strong>7. DOMAIN NAME DISPUTE POLICY</strong> If you reserved or
      registered a domain name through us, you agree to be bound by
      ICANN&#39;s Uniform Domain-Name Dispute-Resolution Policy (the
      &#34;ICANN UDRP&#34; and others as applicable), ICANN&#39;s Uniform
      Rapid Suspension Policy (the “ICANN URS”) and others as applicable) that
      are incorporated herein and made a part of this Agreement by reference.
      The current version of the ICANN UDRP may be found at ICANN&#39;s Web
      site:{' '}
      <a href="http://www.icann.org/udrp/udrp.htm" rel="noreferrer" target="_blank">
          http://www.icann.org/udrp/udrp.htm
      </a>
      . The current version of the ICANN URS may be found at ICANN&#39;s Web
      site:{' '}
      <a href="https://www.icann.org/urs-en" rel="noreferrer" target="_blank">
          https://www.icann.org/urs-en
      </a>
      . Please take the time to familiarize yourself with those policies.{' '}
  </p>
  <p>
      <strong>8. DOMAIN NAME DISPUTES</strong> You agree that, if your use of
      our domain name registration services is challenged by a third party,
      you will be subject to the provisions specified in the{' '}
      <Metadata name="title" mdxType="Metadata" /> dispute policy (the &#34;Dispute Policy&#34;)
      in effect at the time of the dispute.{' '}
  </p>{' '}
  <p>The Dispute Policy is currently as follows:</p>
  <p>
      Notwithstanding anything in this Agreement to the contrary, you agree
      that in the event a domain name dispute arises with any third party, (i)
      you will submit, without prejudice to other potentially applicable
      jurisdictions, to the jurisdiction of the courts of your domicile and
      the Turks & Caicos Islands and (ii) you will indemnify and hold us
      harmless pursuant to the terms and conditions set forth below in this
      Agreement. If we are notified that a complaint has been filed with a
      judicial or administrative body regarding your domain name registration
      or your use of our domain name registration services, you will not be
      permitted to make any changes to your domain name record without our
      prior approval. We will not allow you to make changes to such domain
      name record until:
  </p>{' '}
  <blockquote>
      <p>
          8.1 we are directed to do so by the judicial or administrative body,
          or
      </p>
      <p>
          8.2 we receive written notification by you and the other party
          contesting your registration or use of our domain name registration
          services that the dispute has been settled.{' '}
      </p>
  </blockquote>
  <p>
      Furthermore, you agree that if we and/or you are subject to litigation
      regarding your registration or use of our domain name registration
      services, we may deposit control of your domain name record into the
      registry of the judicial or administrative body by supplying a party
      with a registrar certificate from us.{' '}
  </p>
  <p>
      <strong>9. DOMAIN NAME DISPUTE POLICY MODIFICATIONS</strong> You agree
      that we, in our sole discretion, may modify our Dispute Policy. We will
      post any such revised policy on our Web site at least thirty (30)
      calendar days before it becomes effective. You agree to periodically
      review our Web Site to be aware of such revisions. You agree that, by
      maintaining the reservation or registration of your domain name after
      modifications to the Dispute Policy become effective, you have agreed to
      these modifications. You acknowledge that if you do not agree to any
      such modification, you may terminate this Agreement by providing written
      notice to us in accordance with Section 25 under the Main Terms and
      Conditions. We will not refund any fees paid by you if you terminate
      your Agreement with us.{' '}
  </p>
  <p>
      <strong>10. CANCELLED DOMAINS</strong> You agree that we may, but are
      not obligated to, bill you annually for a domain that you have
      registered until you cancel the domain. You agree to cancel a domain
      when you no longer wish to have that domain registered. You agree that
      no refunds will be issued for domains cancelled prior to their annual
      billing date. A domain will be cancelled immediately following your
      cancellation request. Should you cancel your domain name, you agree that
      you have 30 days to recover your cancelled domain, after which time we
      will, in our sole discretion, delete the domain registration, renew the
      registration or transfer the domain name to a third party on your behalf
      (the &#34;Transfer&#34;). A domain name can be deleted in our sole
      discretion at any time if it violates our Terms or Use or after it is
      cancelled by the user. When possible we will offer a 30 day user
      recovery period. An additional 30 day Recovery Grace Period (RGP) may be
      available for some domains. In To recovery a domain in RGP period, you
      agree to contact customer service and to pay the RGP Recovery Fee in
      addition to the annual domain fee. In the event we are able to identify
      a third party (&#34;Third Party&#34;) and Transfer a cancelled domain,
      we will notify you via email after the transaction is completed
      (&#34;Transfer Notification&#34;). You acknowledge and agree that the
      Transfer may be facilitated through a single Third Party, or through an
      auction involving one or more parties interested in your domain name.
      You agree that we shall have no obligation to pay you, and you shall
      have no right to receive, any percentage of the proceeds of the
      Transfer. We cannot guarantee, and we make no representation or promise,
      that any Transfer will occur with respect to your domain name.
  </p>
  <p>
      <strong>
          11. NEW CUSTOMERS THROUGH AN AFTERMARKET SERVICE PROVIDER:
      </strong>{' '}
      If you are registering a domain name through an aftermarket service
      provider and that domain was registered with, and not yet deleted by,{' '}
      <Metadata name="title" mdxType="Metadata" /> at the time of your purchase, you acknowledge
      and agree that the term of your registration will be for a period of one
      year from the original expiration date for the domain name immediately
      prior to your purchase, as the registration is the result of a Transfer
      (as defined in section 9). If you are registering a domain name through
      an aftermarket service provider and the domain name was not registered
      with <Metadata name="title" mdxType="Metadata" /> at the time of your purchase but was
      deleted by the applicable top-level domain registry at the time of your
      purchase, you acknowledge and agree that the term of your registration
      will be for a period of one year from the date it is initially
      registered with <Metadata name="title" mdxType="Metadata" /> by the provider of the
      backorder service.
  </p>
  <p>
      <strong>12. PARKED AND COMING SOON PAGES FOR ACTIVE DOMAINS</strong>{' '}
      You acknowledge and agree that any and all domain names that are (i)
      registered with <Metadata name="title" mdxType="Metadata" />, (ii) hosted by a third party
      through <Metadata name="title" mdxType="Metadata" /> as part of a Subscription Service, and
      (iii) do not otherwise resolve to an active website, may resolve to a
      &#34;coming soon&#34; or similar temporary web page (&#34;Coming Soon
      Page&#34;), and that <Metadata name="title" mdxType="Metadata" /> may place on any such
      Coming Soon Page promotions, advertisements and other information for,
      and links to, <Metadata name="title" mdxType="Metadata" />
      &#39;s website, <Metadata name="title" mdxType="Metadata" />
      &#39;s product and service offerings, third party websites, third party
      product and service offerings and/or Internet search engines. You agree
      that <Metadata name="title" mdxType="Metadata" /> may change the content and/or appearance
      of, or disable, any Coming Soon Page at any time, in its sole
      discretion, and without prior notice. You agree that any and all revenue
      generated from such a Coming Soon Page enures to the benefit of{' '}
      <Metadata name="title" mdxType="Metadata" />. You may discontinue use of the Coming Soon
      Page for your registered domain at any time by logging into your account
      and making such changes.
  </p>
  <p>
      <strong>13. PARKED AND RESTORATION PAGES FOR DELETED DOMAINS</strong>{' '}
      You agree that after you have cancelled a domain we may direct your
      domain name to an IP address designated by us, including, without
      limitation, an IP address which hosts a Restore domain landing page, or
      a temporary page (&#34;Coming Soon Page&#34;) that may include
      promotions, advertisements and other information for, and links to,{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s website, <Metadata name="title" mdxType="Metadata" />
      &#39;s product and service offerings, third party websites, third party
      product and service offerings and/or Internet search engines, and you
      agree that we may place our contact information in the WHOIS or RDAP output for
      the cancelled domain. You agree that <Metadata name="title" mdxType="Metadata" /> may
      change the content and/or appearance of, or disable, any Domain
      Restoration or Coming Soon Page at any time, in its sole discretion, and
      without prior notice. You agree that any and all revenue generated from
      a temporary page belongs to <Metadata name="title" mdxType="Metadata" /> or such third
      party as designated by <Metadata name="title" mdxType="Metadata" />.
  </p>
  <p>
      In the case of a canceled or deleted CA domain we will not modify the
      domain&#39;s contact information and your domain&#39;s nameservers will
      not be changed.{' '}
  </p>
  <p>
      <strong>14. REVOCATION</strong> You agree that we may cancel or delete
      your domain name if the information that you provide to us or
      subsequently modify contains false or misleading information, or
      conceals or omits any information we would likely consider material to
      our decision to register your domain name or to continue to provide you
      domain name registration services. You agree that we may terminate
      immediately and without notice our service(s), including our domain name
      registration services, in the event that you use such service(s) for any
      improper purpose, as determined in our sole discretion. Furthermore, you
      agree that we may suspend, delete, cancel or transfer your domain name
      in order to:
  </p>
  <blockquote>
      <p>
          14.1 comply with any Specification or Policy, or any{' '}
          <Metadata name="title" mdxType="Metadata" /> or registry operator procedure not
          inconsistent with any Specification or Policy; or
      </p>
      <p>
          14.2 correct mistakes made by us or the registry in registering your
          chosen domain name; or{' '}
      </p>
      <p>
          14.3 resolve a dispute under the ICANN UDRP or the Dispute Policy. We
          will not refund any fees paid by you prior to termination of our
          services.{' '}
      </p>
  </blockquote>
  <p>
      <strong>15. SURVIVAL</strong> In the event this Agreement or Schedule
      terminates, Sections 3, 4, 5, 6, 7, 8, 9, 10 and 14 of this Schedule
      shall survive such expiration or termination.
  </p>
  <h2 id="scheduleb">
  <a href="#scheduleb" name="scheduleb">
      Schedule B
  </a>
  : Terms and Conditions applicable to <Metadata name="title" mdxType="Metadata" /> Corp.
  Email Services
  </h2>
  <p>
      The following terms and conditions of use and any amendments thereto
      (the &#34;Email Terms&#34;) apply to your access to, and use of, the
      email and related services offered by <Metadata name="title" mdxType="Metadata" /> (the
      &#34;Email Service&#34;). These Email Terms may be changed in the future
      without further notice, and your continued use of the Email Service
      following any such changes constitutes your acceptance of the new terms.
      These Email Terms do not alter in any way the non-conflicting terms or
      conditions of this Agreement or any other agreement you may have with{' '}
      <Metadata name="title" mdxType="Metadata" /> for products, services or otherwise. To the
      extent any of the Email Terms are in conflict or inconsistent with any
      other term or condition of the Agreement, these Email Terms shall govern
      to the extent of the conflict or inconsistency.
  </p>
  <p>
      <strong>1. Privacy Policy</strong>
  </p>
  <p>
      In addition to the terms of the <Metadata name="title" mdxType="Metadata" /> privacy
      statement, you agree that <Metadata name="title" mdxType="Metadata" /> may access and
      disclose information about you or your use of the Email Service when{' '}
      <Metadata name="title" mdxType="Metadata" /> deems necessary or appropriate to comply with
      the law or legal process, to protect <Metadata name="title" mdxType="Metadata" />
      &#39;s systems and customers, or to ensure the integrity and operation
      of <Metadata name="title" mdxType="Metadata" />
      &#39;s business and systems. Such disclosure may include, without
      limitation, user profile information (e.g., name, email address, etc.),
      IP address and traffic information, usage history, and posted content.{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s right to disclose any such information shall govern over any
      terms of <Metadata name="title" mdxType="Metadata" />
      &#39;s privacy statement.
  </p>
  <p>
      <strong>2. Access Restriction &amp; Password Security</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> reserves the right to deny in its sole
      discretion any user access to the Email Service or any portion thereof
      without notice. You are responsible for safeguarding the confidentiality
      of your password(s) and user name(s) issued to you by{' '}
      <Metadata name="title" mdxType="Metadata" />, and for any use or misuse of your account or
      the Email Service resulting from any third party using a password or
      user name issued to you.
  </p>
  <p>
      <strong>3. No &#34;Spamming&#34;</strong>
  </p>
  <p>
      You shall not use the Email Service for chain letters, junk mail,
      &#34;spamming&#34; or any use of distribution lists to any person who
      has not given specific permission to be included in such a process. An
      email advertisement which is (a) addressed to a recipient with whom the
      initiator does not have an existing business or personal relationship
      and (b) is not sent at the request of or with the express consent of the
      recipient to receive such communications from you (&#34;spam&#34; or
      &#34;spamming&#34;) is strictly prohibited by <Metadata name="title" mdxType="Metadata" />.
      If any user uses the Email Service for spamming,{' '}
      <Metadata name="title" mdxType="Metadata" /> reserves the right to immediately terminate
      that user&#39;s access to the Email Service and to seek appropriate
      legal recourse as necessary. If any user believes that others are using
      the Email Service for spam, please contact <Metadata name="title" mdxType="Metadata" /> at{' '}
      <Metadata addr="service" name="mailLink" mdxType="Metadata" />.
  </p>
  <p>
      <strong>4. User Conduct</strong>
  </p>
  <blockquote>
      <p>
          4.1 <Metadata name="title" mdxType="Metadata" /> reserves the right, but does not assume
          the responsibility, to monitor or review user conduct on the Email
          Service. Use of the Email Service is subject to all applicable local,
          state, provincial, federal and international laws and regulations. You
          agree: (1) to comply with applicable law regarding the transmission of
          technical data exported from the United States or Canada through the
          Email Service; (2) not to use the Email Service for illegal purposes;
          and (3) not to interfere or disrupt networks connected to the Email
          Service.
      </p>
      <p>4.2 In using the service, you agree not to:</p>
      <blockquote>
          <p>
              4.2.1. Harvest or otherwise collect information about others,
              including without limitation names and email addresses, without
              their consent;
          </p>
          <p>
              4.2.2. Transmit through the Email Service any unlawful, harassing,
              defamatory, abusive, threatening, harmful, vulgar, obscene, sexually
              explicit, or otherwise objectionable material of any kind or nature;
          </p>
          <p>
              4.2.3. Invade another&#39;s privacy or violate rights of publicity
              or intellectual property rights (including but not limited to
              copyright, trademark and patent rights) while using the Email
              Service;
          </p>
          <p>
              4.3.3. Transmit any material that encourages conduct that could
              constitute a criminal offense, give rise to civil liability or
              otherwise violate any applicable local, state, provincial, federal
              or international law or regulation;
          </p>
          <p>
              4.3.4. Interfere with another User&#39;s use and enjoyment of the
              Email Service or another entity&#39;s use and enjoyment of similar
              services;
          </p>
          <p>
              4.3.5. Advertise or offer to sell or buy any goods or services for
              any non-personal purpose;
          </p>
          <p>
              4.3.6. Transmit or upload any material that contains viruses, trojan
              horses, worms, time bombs, cancelbots, or any other harmful or
              deleterious programs;
          </p>
          <p>
              4.3.7. Interfere with or disrupt networks connected to the Email
              Service or violate the regulations, policies or procedures of such
              networks;
          </p>
          <p>
              4.3.8. Attempt to gain unauthorized access to the Email Service,
              other accounts, computer systems or networks connected to the Email
              Service, through password mining or any other means;
          </p>
          <p>
              4.3.9. Use or attempt to use another&#39;s account, service or
              system without authorization from <Metadata name="title" mdxType="Metadata" />, or
              create or use a false identity on this Email Service; or
          </p>
          <p>
              4.3.10. Engage in any other conduct which, in{' '}
              <Metadata name="title" mdxType="Metadata" />
              &#39;s sole discretion, is considered unauthorized or objectionable.
          </p>
      </blockquote>
  </blockquote>
  <p>
      <strong>5. Proprietary Rights</strong>
  </p>
  <blockquote>
      <p>
          5.1 You acknowledge and agree that any material, including but not
          limited to text, compilations, graphics, software, music, sound,
          photographs, video, or other material contained or distributed on or
          through the Email Service, by <Metadata name="title" mdxType="Metadata" />, its
          advertisers or other third parties (&#34;Content&#34;), is protected
          by copyrights, trademarks, service marks, patents or other proprietary
          rights and laws. You may not use or distribute any Content received
          through the Email Service without the authorization of the content
          owner, except for your personal, non-exclusive use. You agree not to
          modify, copy, reproduce, republish, upload, post, transmit, sell or
          distribute Content available through the Email Service, including code
          and software, in violation of applicable copyright and other
          intellectual property laws.
      </p>
      <p>
          5.2 WITHOUT LIMITING THE FOREGOING, COPYING OR REPRODUCTION OF THE{' '}
          <span style={{
            textTransform: 'uppercase'
          }}><Metadata name="title" mdxType="Metadata" /></span>{' '}
          SOFTWARE TO ANY OTHER SERVER OR LOCATION FOR
          FURTHER REPRODUCTION OR REDISTRIBUTION IS EXPRESSLY PROHIBITED. YOU
          MAY NOT DECOMPILE, DISASSEMBLE, REVERSE ENGINEER OR OTHERWISE ATTEMPT
          TO DISCOVER ANY TRADE SECRET CONTAINED IN ANY SOFTWARE PROVIDED
          HEREUNDER.
      </p>
      <p>
          5.3 You acknowledge that the Software, and any accompanying
          documentation and/or technical information, is subject to applicable
          export control laws and regulations of the United States and Canada.
          You agree not to export or re-export the Software, directly or
          indirectly, to any countries that are subject to U.S. or Canadian
          export restrictions.
      </p>
  </blockquote>
  <p>
      <strong>6. Trademarks</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> and the <Metadata name="title" mdxType="Metadata" /> logo are
      trademarks of <Metadata name="title" mdxType="Metadata" />, and may not be copied, imitated
      or used, in whole or in part, without the prior written permission of{' '}
      <Metadata name="title" mdxType="Metadata" />. In addition, all page headers, custom
      graphics, button icons, and scripts are service marks, trademarks,
      and/or trade dress of <Metadata name="title" mdxType="Metadata" /> or its contractors or
      suppliers, and may not be copied, imitated, or used, in whole or in
      part, without the prior written permission of <Metadata name="title" mdxType="Metadata" />.
      All other trademarks, registered trademarks, product names and company
      names or logos mentioned herein are the property of their respective
      owners.
  </p>
  <p>
      <strong>7. Submissions</strong>
  </p>
  <p>
      You agree that any materials, including but not limited to questions,
      comments, suggestions, ideas, plans, notes, drawings, original or
      creative materials or other information, provided by you in the form of
      email or submissions to <Metadata name="title" mdxType="Metadata" />, or postings on this
      Email Service, are non-confidential and shall become the sole property
      of <Metadata name="title" mdxType="Metadata" />. <Metadata name="title" mdxType="Metadata" /> shall own
      exclusive rights, including all intellectual property rights, and shall
      be entitled to the unrestricted use of these materials for any purpose,
      commercial or otherwise, without acknowledgment or compensation to you.
      The submission of any materials to <Metadata name="title" mdxType="Metadata" />, including
      the posting of materials to any forum or interactive area, irrevocably
      waives any and all &#34;moral rights&#34; in such materials, including
      the rights of paternity and integrity.
  </p>
  <p>
      <strong>8. Linking</strong>
  </p>
  <blockquote>
      <p>
          8.1 You may not use, frame or utilize framing techniques to enclose
          any <Metadata name="title" mdxType="Metadata" /> trademark, logo or other proprietary
          information, including the images found at this Email Service, the
          content of any text, or the layout/design of any page or form
          contained on a page, without <Metadata name="title" mdxType="Metadata" />
          &#39;s express written consent. Further, you may not use any meta tags
          or any other &#34;hidden text&#34; utilizing any{' '}
          <Metadata name="title" mdxType="Metadata" /> name, trademark, or product name without{' '}
          <Metadata name="title" mdxType="Metadata" />
          &#39;s express written consent. Except as noted above, you are not
          conveyed any right or license by implication, estoppel, or otherwise
          in or under any patent, trademark, copyright, or proprietary right of{' '}
          <Metadata name="title" mdxType="Metadata" /> or any third party.
      </p>
      <p>
          8.2 <Metadata name="title" mdxType="Metadata" /> makes no claim or representation
          regarding, and accepts no responsibility for, the quality, content,
          nature or reliability of Web sites accessible by hyperlink from this
          Email Service, or Web sites linking to this Email Service. The linked
          sites are not under the control of <Metadata name="title" mdxType="Metadata" />, and{' '}
          <Metadata name="title" mdxType="Metadata" /> is not responsible for the contents of any
          linked site or any link contained in a linked site, or any review,
          changes or updates to such sites. <Metadata name="title" mdxType="Metadata" /> is
          providing these links to you only as a convenience, and the inclusion
          of any link does not imply affiliation, endorsement, or adoption by or
          between <Metadata name="title" mdxType="Metadata" /> and any third party.
      </p>
  </blockquote>
  <p>
      <strong>9. Third Party Content &amp; Email Services</strong>
  </p>
  <blockquote>
      <p>
          9.1 <Metadata name="title" mdxType="Metadata" /> may provide links to Web pages and
          content of third parties (&#34;Third Party Content&#34;) as a service
          to those interested in this information. <Metadata name="title" mdxType="Metadata" />{' '}
          does not monitor, and has no control over, any Third Party Content or
          third party Web sites. <Metadata name="title" mdxType="Metadata" /> does not endorse or
          adopt any Third Party Content and can make no guarantee as to its
          accuracy or completeness. <Metadata name="title" mdxType="Metadata" /> does not represent
          or warrant the accuracy of any information contained therein, and
          undertakes no responsibility to update or review any Third Party
          Content.
      </p>
      <p>
          9.2 When leaving the <Metadata name="title" mdxType="Metadata" /> site, you should be
          aware that <Metadata name="title" mdxType="Metadata" />
          &#39;s terms and policies no longer govern, and, therefore, you should
          review the applicable terms and policies, including privacy and data
          gathering practices, of that site. Your use of these links and Third
          Party Content contained therein is at your sole risk.
      </p>
  </blockquote>
  <p>
      <strong>10. Copyright Policy &amp; Copyright Agent</strong>
  </p>
  <blockquote>
      <p>
          10.1 <Metadata name="title" mdxType="Metadata" /> may remove content that appears to
          infringe the copyright or other intellectual property rights of
          others. In addition, <Metadata name="title" mdxType="Metadata" /> may terminate the
          accounts of users who appear to infringe the copyright or other
          intellectual property rights of others.
      </p>
      <p>
          10.2 If you believe that <Metadata name="title" mdxType="Metadata" /> or any user of our
          site has infringed your copyright in any material way, please notify{' '}
          <Metadata name="title" mdxType="Metadata" />, and provide the following information (the
          &#34;Notice&#34;):
      </p>
      <blockquote>
          <p>
          10.2.1. A physical or electronic signature of the person authorized
          to act on behalf of the owner of the copyright interest.
          </p>
          <p>
          10.2.2. An identification of the copyrighted work claimed to have
          been infringed.
          </p>
          <p>
          10.2.3. An identification of the material that you claim is
          infringing so that we may locate it on the Email Service.
          </p>
          <p>10.2.4. Your address, telephone number, and email address.</p>
          <p>
          10.2.5. A statement by you that you have a good faith belief that
          the disputed use is not authorized by the copyright owner, its
          agent, or the law.
          </p>
          <p>
          10.2.6. A statement by you that the above information in your Notice
          is accurate, made under penalty of perjury, and that you are
          authorized to act on behalf of the owner of the copyright interest
          involved.
          </p>
      </blockquote>
  </blockquote>
  <p>
      However, unless ordered by a court of a competent jurisdiction or an
      administrative body, <Metadata name="title" mdxType="Metadata" /> does not have to take any
      action against an alleged infringement.
  </p>
  <p>
      <strong>11. No Resale</strong>
  </p>
  <p>
      You agree not to resell or make any commercial use of the Email Service
      without <Metadata name="title" mdxType="Metadata" />
      &#39;s express written consent.
  </p>
  <p>
      <strong>12. Termination</strong>
  </p>
  <p>
      Notwithstanding any of these terms and conditions of use,{' '}
      <Metadata name="title" mdxType="Metadata" /> reserves the right, without notice and in its
      sole discretion, to terminate your use of this Email Service, to change
      or eliminate any of the services we provide, and to block or prevent
      future access to and use of this Email Service. If your account is
      terminated for violation of these Email Terms, you will not be entitled
      to any refunds. Should you object to these Email Terms or become
      dissatisfied with the Email Service in any way, your only recourse is to
      immediately discontinue your use of the Email Service and terminate your
      account.
  </p>
  <p>
      <strong>13. Severability</strong>
  </p>
  <p>
      If any provision of these terms and conditions shall be deemed unlawful,
      void, or for any reason unenforceable, then that provision shall be
      deemed severable from these terms and conditions and shall not affect
      the validity and enforceability of any remaining provisions. The terms of
      this section survive any termination of the Email Terms.
  </p>
  <p>
      <strong>14. Modification &amp; Amendments</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> reserves the right to amend at any time any
      policies governing this Email Service, including these Email Terms, by
      posting the amended terms and providing notice of such amendments. The
      amended terms shall be effective upon posting. If you do not accept the
      amended terms, you should cease using this Email Service.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulec">
  <a href="#schedulec" name="schedulec">
      Schedule C
  </a>
  : Terms and Conditions Applicable to all Web Site and Hosting Services
  </h2>
  <p>
      <strong>1. Definitions</strong>
  </p>
  <p>
      For purposes of this Schedule, the following capitalized terms shall
      have the meanings ascribed to them below:
  </p>
  <blockquote>
      <p>
          1.1. &#34;
          <Metadata name="title" mdxType="Metadata" /> Corp. Web Site&#34; means any pre-designed,
          customizable <Metadata name="title" mdxType="Metadata" /> Corp. Web site template
          including websites provisioned from Weebly Inc. licensed by{' '}
          <Metadata name="title" mdxType="Metadata" /> Corp. to end users. By using these services,
          end users also agree to Weebly Inc&#39;s{' '}
          <a href="https://www.weebly.com/terms-of-service">
          terms and conditions{' '}
          </a>
            .
      </p>
      <p>
          1.2. &#34;Subscription Service&#34; means any of the{' '}
          <Metadata name="title" mdxType="Metadata" /> Corp. subscription service packages that are
          available for purchase by end users on a monthly basis, for a monthly
          fee, that combine the <Metadata name="title" mdxType="Metadata" /> Corp. Web Site
          license, the Web Site Manager Service and the Web Hosting Service, all
          as described on the <Metadata name="title" mdxType="Metadata" /> Corp. Web site located
          at the URL <Metadata name="link" mdxType="Metadata" />.{' '}
      </p>
      <p>
          1.3. &#34;Web Site Manager Service&#34; means the{' '}
          <Metadata name="title" mdxType="Metadata" /> Corp. on-line tool that allows customers to
          access their <Metadata name="title" mdxType="Metadata" /> Corp. Web Site, add/modify
          content, upload images and make generic changes to their{' '}
          <Metadata name="title" mdxType="Metadata" /> Corp. Web Site.{' '}
      </p>
      <p>
          1.4. &#34;Web Hosting Service&#34; means the Web hosting services
          provided by a third party through <Metadata name="title" mdxType="Metadata" /> Corp. as
          part of a Subscription Service.
      </p>
  </blockquote>
  <p>
      <strong>2. Payment </strong>
  </p>
  <p>
      In addition to the payment terms u Section 4 under the Main Terms and
      Conditions of the Agreement, the following provisions shall also apply
      solely with respect to the Subscription Service:{' '}
  </p>
  <blockquote>
      <p>
          2.1. <Metadata name="title" mdxType="Metadata" /> in its sole discretion, shall determine
          the prices it will charge for the Subscription Service, and the terms
          and conditions applicable to the same, and <Metadata name="title" mdxType="Metadata" />{' '}
          Corp. may, upon providing thirty (30) days&#39; notice to you, amend
          such pricing and/or terms and conditions. If you do not agree to the
          change(s), you may terminate your Subscription Service as provided in
          Section 5 of this Schedule within that thirty (30) days; otherwise all
          such changes shall thereafter be effective with respect to your
          account, and you agree that we are authorized to charge your credit
          card for the new monthly Subscription Service fee.{' '}
      </p>
      <p>
          2.2 Billing for the Subscription Service will be by valid credit card
          (acceptable to <Metadata name="title" mdxType="Metadata" /> Corp) at the time of
          purchase. If you elect to subscribe to a service that requires a
          monthly payment, your monthly payments for the same will be
          automatically charged to the credit card provided by you (and
          acceptable to <Metadata name="title" mdxType="Metadata" /> Corp) at the time of your
          purchase (with such payments being charged in advance on a monthly
          basis), and you hereby agree that <Metadata name="title" mdxType="Metadata" /> Corp. is
          authorized to so charge your credit card.{' '}
      </p>
  </blockquote>
  <p>
      <strong>3. Conduct </strong>
  </p>
  <p>
      You agree to abide by the terms and conditions set forth herein and be
      bound by the applicable provisions of any applicable{' '}
      <Metadata name="title" mdxType="Metadata" /> Corp. Acceptable Use Policy and other
      applicable <Metadata name="title" mdxType="Metadata" /> policies and procedures,
      incorporated herein and made part of this Agreement by reference, in
      connection with your use of the services described in this Schedule. You
      are responsible for ensuring that your web site conforms to all local,
      state, federal and international laws. You are also responsible for
      ensuring that you have obtained authorization to use any copyright
      images, audio files, text or other web site elements that are not
      provided by <Metadata name="title" mdxType="Metadata" />. You warrant that the web site
      being hosted by <Metadata name="title" mdxType="Metadata" /> Corp. will not be used in
      connection with any illegal activity and that it will not conflict with
      the legal rights of a third party or a third party&#39;s trademarks or
      trade name.
  </p>
  <p>
      <strong>
          4. <Metadata name="title" mdxType="Metadata" />
          &#39;s Rights.
      </strong>
  </p>
  <blockquote>
      <p>
          4.1 <Metadata name="title" mdxType="Metadata" /> explicitly reserves the right and sole
          discretion to{' '}
      </p>
      <blockquote>
          <p>
              4.1.1 suspend any web site (including indefinite suspension) without
              notice for non-payment of fees due hereunder;{' '}
          </p>
          <p>
              4.1.2 censor any web site hosted that, in <Metadata name="title" mdxType="Metadata" />{' '}
              Corp&#39;s sole discretion, is deemed inappropriate;{' '}
          </p>
          <p>
              4.1.3 review every Web Hosting account for excessive space and
              bandwidth utilization and to terminate or apply additional fees to
              those accounts that exceed allowed levels;{' '}
          </p>
          <p>4.1.4 modify its pricing through email notification; </p>
          <p>
              4.1.5 terminate your Subscription Service for unsolicited,
              commercial emailing (i.e., SPAM); illegal access to other computers
              or networks (i.e., hacking); distribution of Internet viruses or
              similar destructive activities; non-payment of Web Hosting fees; and
              other activities whether lawful or unlawful that{' '}
              <Metadata name="title" mdxType="Metadata" /> Corp. determines to be harmful to its
              other customers, operations, or reputation;{' '}
          </p>
          <p>
              4.1.6 terminate Your Subscription Service if the contents of your
              web site result in, or are the subject of, legal action or
              threatened legal action, against <Metadata name="title" mdxType="Metadata" /> Corp. or
              any of its affiliates or partners, without consideration for whether
              such legal action or threatened legal action is eventually
              determined to be with or without merit.
          </p>
      </blockquote>
      <p>
          4.2 You agree you will not be entitled to a refund of any fees paid to{' '}
          <Metadata name="title" mdxType="Metadata" /> if, for any reason,{' '}
          <Metadata name="title" mdxType="Metadata" /> takes corrective action with respect to your
          improper or illegal use of the Subscription Service.{' '}
      </p>
  </blockquote>
  <p>
      <strong>5. Cancellation</strong>{' '}
  </p>
  <p>
      You may cancel your Subscription Service at any time. To cancel your
      Subscription Service you must submit your written notice of cancellation
      to <Metadata name="title" mdxType="Metadata" /> (as provided herein) and include the
      following information: (i) Your <Metadata name="title" mdxType="Metadata" /> customer
      identification number and username; (ii) your <Metadata name="title" mdxType="Metadata" />{' '}
      Web Site Web address; and (iii) your reason for requesting cancellation.
      Unless terminated earlier as provided herein, your Subscription Service
      will be canceled as of the expiration of the monthly billing cycle in
      which your notice was received. In the absence of such written notice of
      cancellation, <Metadata name="title" mdxType="Metadata" /> will automatically renew the
      Subscription Service indefinitely and will charge the credit card you
      have on file with <Metadata name="title" mdxType="Metadata" /> , at{' '}
      <Metadata name="title" mdxType="Metadata" /> then current rates.
  </p>
  <p>
      <strong>6. Term and Termination </strong>
  </p>
  <blockquote>
      <p>
          6.1 Term: Your Subscription Service shall be on a month-to-month basis
          for successive monthly periods, unless either party notifies the other
          of termination in accordance with this Agreement.{' '}
      </p>
      <p>
          6.2 Notice of Service Cancellation by You. Any termination of your
          Subscription Service must be in accordance with our cancellation
          policy. Unless terminated earlier as provided herein, this Schedule,
          and the Agreement (if you have no other services with{' '}
          <Metadata name="title" mdxType="Metadata" /> Corp) will be terminated as of the
          expiration of the monthly billing cycle in which your cancellation
          notice was received and processed by <Metadata name="title" mdxType="Metadata" />{' '}
      </p>
  </blockquote>
  <p>
      <strong>7. Service Uptime Guarantee</strong>{' '}
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> offers a Service uptime guarantee of 99.9%
      (“Service Uptime Guarantee”) of available time per month. The uptime of
      the server is defined as the reported uptime from the operating system
      and the Apache Web Server which may differ from the uptime reported by
      other individual services. If we fail to maintain this Service Uptime
      Guarantee in a particular month (as solely determined by us), you will
      be eligible upon request to receive a credit to apply to future services
      billing cycles based upon the Unavailability for that month. The credit
      may be used only for the purchase of further products and services from
      us, and is exclusive of any applicable taxes. Third party monitoring
      service reports may not be used for justification due to a variety of
      factors including the monitor&#39;s network capacity/transit
      availability. The Service Uptime Guarantee does not apply to service
      interruptions caused by: (1) periodic scheduled maintenance or repairs
      we may undertake from time to time; (2) interruptions caused by you from
      custom scripting, coding or the installation of third-party
      applications; (3) outages that do not affect the appearance of your
      website but merely affect access to your website such as FTP and email;
      (4) causes beyond our control or that are not reasonably foreseeable;
      and (5) outages related to the reliability of certain programming
      environments.
  </p>
  <p>
      <strong>8. Hosting Migrations </strong>
  </p>
  <blockquote>
      <p>
          8.1 If your web hosting is provided by a third-party, we may, at your
          request and in our sole discretion, attempt to assist you to move the
          web hosting and the domain name to us. Hosting Migrations are provided
          as a courtesy service, and we do not make any guarantee regarding the
          availability, possibility, or time required to complete a Hosting
          Migration. Each hosting company is configured differently, and some
          hosting platforms save data in an incompatible or proprietary format,
          which may make us unable to assist you in the transfer of data from a
          third-party host.{' '}
      </p>
      <p>
          8.2 The free Hosting Migration service is available for thirty (30)
          days from your sign up date. Transfers outside of the thirty (30) day
          period will incur a charge; please contact a member of our Hosting
          Migration department to receive a price quote.{' '}
      </p>
      <p>
          8.3 You are solely responsible for reviewing the functionality and
          accuracy of migrated content in its new location following a Hosting
          Migration. We will not perform website backups or archives in
          connection with a Hosting Migration, and we recommend that you back up
          your third-party hosted website before migration to ensure that no
          data is lost. You agree not to make any changes or revisions to your
          website during the migration process.{' '}
      </p>
      <p>
          8.4 You agree that we are not liable for any delay in website
          resolution or loss of data related to your Hosting Migration.{' '}
      </p>
      <p>
          8.5 We may install a plugin on your external WordPress site for the
          purpose of facilitating your WordPress migration into our own Managed
          WordPress hosting environment. This plugin will not change anything on
          your source site. Its purpose is to facilitate the Hosting Migration
          of your WordPress files. You are welcome to disable the plugin on your
          source site after the Hosting Migration has been completed.{' '}
      </p>
  </blockquote>
  <p>
      <strong>9. Backups and Security </strong>
  </p>
  <blockquote>
      <p>
          9.1 You shall be solely responsible for undertaking measures to: (1)
          prevent any loss or damage to your website or server content; (2)
          maintain independent archival and backup copies of your website or
          server content; and (3) ensure the security, confidentiality and
          integrity of all your website or server content transmitted through or
          stored on our servers.{' '}
      </p>
      <p>
          9.2 <Metadata name="title" mdxType="Metadata" />
          &#39;s backup service runs once a day and overwrites any of our
          previous backups. Only four weeks of backups are stored in the remote
          server. This service is provided only to shared and reseller accounts
          as a courtesy and may be modified at any time at{' '}
          <Metadata name="title" mdxType="Metadata" />
          &#39;s sole discretion. <Metadata name="title" mdxType="Metadata" /> is not responsible
          for files and/or data residing on your account. You agree to take full
          responsibility for all files and data transferred and to maintain all
          appropriate backup of files and data stored on{' '}
          <Metadata name="title" mdxType="Metadata" /> &#39;s servers.{' '}
      </p>
      <p>
          9.3 Our servers are not an archive and we shall have no liability to
          you or any other person for loss, damage or destruction of any of your
          content. The Hosting Services are not intended to provide a PCI
          (Payment Card Industry) or HIPAA (Health Insurance Portability and
          Accountability Act) compliant environment and therefore should not be
          used or considered as one. You shall not use the Service in any way,
          in our sole discretion, that shall impair the functioning or operation
          of our services or equipment. Specifically by way of example and not
          as a limitation, you shall not use the Hosting Services as: (1) a
          repository or instrument for placing or storing archived files; and/or
          (2) placing or storing material that can be downloaded through other
          websites. You acknowledge and agree that we have the right to carry
          out a forensic examination in the event of a compromise to your server
          or account.{' '}
      </p>
  </blockquote>
  <p>
      <strong>10. Website/Server Content</strong>{' '}
  </p>
  <p>
      Your website may not include any of the following content: (1) image
      hosting scripts that allow an anonymous user to upload an image for
      display on another website (similar to Photobucket or Tinypic); (2)
      banner ad services for display on other websites or devices (commercial
      banner ad rotation); (3) file dump/mirror scripts that allow an
      anonymous user to upload a file for other to download (similar to
      rapidshare); (4) commercial audio streaming (more than one or two
      streams); (5) push button mail scripts that allow the user to specify
      recipient email addresses; (6) anonymous or bulk SMS gateways; (7)
      backups of content from another computer or website; (8) Bittorrent
      trackers; or (9) any script that causes a degradation in the performance
      of our server or network environment.
  </p>
  <p>
      <strong>11. Disk Space/Bandwidth/Website Plans</strong>{' '}
  </p>
  <p>
    Your use of our Service is subject to your current Plan or package. In the event your Service usage, or the content you host, exceeds your plan or package, presents a risk to the stability, performance or uptime of our servers, data storage, networking or other infrastructure, you may be required to reduce usage, upgrade your current Plan or package, or we may take action to restrict the resources your website is utilizing.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduled">
      <a href="#scheduled" name="scheduled">
          Schedule D
      </a>
  : Terms and Conditions Applicable to the High Security Service
  </h2>
  <p>
      <strong>1</strong> <Metadata name="title" mdxType="Metadata" /> has introduced a &#34;High
      Security&#34; service to address issues of domain name security. The
      High Security service is provided to you as a courtesy and helps to
      prevent domains you have registered from being unintentionally
      transferred, deleted, or expired. Unless you inform{' '}
      <Metadata name="title" mdxType="Metadata" /> that you do not want this service, you will be
      automatically enrolled for <Metadata name="title" mdxType="Metadata" />
      &#39;s High Security service. The High Security service includes
      &#34;Registrar Lock&#34; and &#34;Auto-renewal&#34;, described below.{' '}
      <Metadata name="title" mdxType="Metadata" /> may introduce additional security features in
      the future.
  </p>
  <p>
      <strong>2. Registrar Lock</strong>
  </p>
  <p>
      When High Security is enabled for a domain name, you are preventing
      registrars, other than <Metadata name="title" mdxType="Metadata" />, to transfer or modify
      your domain name. If you choose to transfer a domain to another
      registrar, you must log into your account and remove the lock prior to
      our receipt of the transfer request from the gaining registrar. This
      service is being provided as a convenience to you but in no way
      guarantees that a domain name will not be maliciously transferred to
      another registrar or registrant, due to technical and policy weaknesses
      in the worldwide domain name system or by <Metadata name="title" mdxType="Metadata" />
      &#39;s error. <Metadata name="title" mdxType="Metadata" /> will, however, use commercially
      reasonable efforts in stopping any such transfer without your express
      consent. Please note that not all registries support the concept of a
      Registrar Lock in which case, High Security will not include a Registrar
      Lock.
  </p>
  <p>
      <strong>3. Auto-renewal</strong>
  </p>
  <blockquote>
      <p>
          3.1 When High Security is enabled for a domain,{' '}
          <Metadata name="title" mdxType="Metadata" /> will attempt to renew the registration of a
          domain approximately 75 days prior to its expiry date. The renewal is
          for a one-year term and extends the existing registration period. For
          example, if the expiry date for your domain name is September 1, 2003,
          the new expiry date will be September 1, 2004. When High Security is
          enabled, you have authorized and consented to{' '}
          <Metadata name="title" mdxType="Metadata" /> to automatically charge your credit card the
          then-current retail price for such one-year renewal. The automatic
          renewal service is provided as a convenience for you but in no way
          guarantees a desired renewal. It is your obligation to affirmatively
          renew any desired domain. In addition, <Metadata name="title" mdxType="Metadata" /> has
          no obligation to attempt to renew your domain if your most recent
          credit card on file with us for your account is not accepted according
          to <Metadata name="title" mdxType="Metadata" />
          &#39;s payment processing systems. After your domains have been
          successfully renewed, you will receive a confirmation email. Note: The
          Auto-renewal process requires a valid credit card to be kept on file
          in your account. You will be notified if the Auto-renewal transaction
          is declined for any reason.{' '}
      </p>
      <p>
          3.2 If you do not choose to have the High Security service as part of
          your Subscription Service, you must contact Customer Support by
          logging into your <Metadata name="title" mdxType="Metadata" /> account at{' '}
          <Metadata name="link" mdxType="Metadata" /> and disabling the High Security feature on
          those domains you choose not to protect. Your failure to expressly opt
          out of the High Security service constitutes your authorization and
          consent for <Metadata name="title" mdxType="Metadata" /> to enable Registrar-Lock and
          Auto-renewal, and attempt to automatically charge your credit card the
          then-current retail price for such renewal.
      </p>
      <p>
          3.3 You are solely responsible for the credit card and billing contact
          information you provide to <Metadata name="title" mdxType="Metadata" /> and you
          acknowledge and agree that you will promptly inform{' '}
          <Metadata name="title" mdxType="Metadata" /> of any changes thereto (e.g., change of
          expiration date or account number).{' '}
      </p>
      <p>
          3.4 You are solely responsible for ensuring the security of your
          domains. <Metadata name="title" mdxType="Metadata" /> CORP. WILL HAVE NO LIABILITY TO YOU
          OR ANY THIRD PARTY IN CONNECTION WITH THE HIGH SECURITY FEATURES,
          INCLUDING ATTEMPTED OR SUCCESSFUL TRANSFERS OF DOMAINS EVEN THOUGH THE
          HIGH SECURITY SERVICE IN ENABLED, OR RENEWAL OR ANY ATTEMPT TO RENEW
          DOMAINS AS DESCRIBED HEREIN, INCLUDING, BUT NOT LIMITED TO, ANY
          FAILURE OR ERRORS IN TRANSFERS, RENEWING OR ATTEMPTING TO RENEW THE
          DOMAINS. The foregoing limitation of liability is in addition to any
          other limitations of liability set forth in this Agreement.{' '}
      </p>
      <p>
          3.5 You understand and agree that the release, indemnity and other
          obligations in favour of <Metadata name="title" mdxType="Metadata" /> and certain other
          persons in Section 14 of the Main Terms and Conditions apply to your
          use of the High Security feature.
      </p>
  </blockquote>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulee">
      <a href="#schedulee" name="schedulee">
          Schedule E
      </a>
      : Terms and Conditions Applicable to <Metadata name="title" mdxType="Metadata" /> Privacy
      Service
  </h2>
  <p>
      <strong>1</strong> <Metadata name="title" mdxType="Metadata" /> has introduced a
      &#34;Privacy&#34; service to address issues of domain name privacy
      through the services of Privacy Hero Ltd. By using the Services and/or
      website of Privacy Hero Inc., a Turks and Caicos company (&#34;Privacy
      Hero&#34;), You agree to all the terms and conditions set forth both
      herein and in the Privacy Hero Terms and Conditions, which is
      incorporated by reference and can be found by clicking&nbsp;
      <a href="https://www.privacyhero.company/en/terms" rel="noreferrer" target="_blank">
          here
      </a>
      .&nbsp; You acknowledge that Privacy Hero may amend this Agreement at
      any time upon posting the amended terms on its website, and that any
      new, different or additional features changing the services provided by
      Privacy Hero will automatically be subject to this Agreement. If You do
      not agree to be bound by, or if You object to, the terms and conditions
      of this Agreement and any amendments hereto, do not use or access
      Privacy Hero&#39;s services. Continued use of Privacy Hero&#39;s
      services and its website after any such changes to this Agreement have
      been posted, constitutes Your acceptance of those changes.
  </p>
  <p>
      <strong>2. Good Faith</strong> By enabling the Privacy service, you
      agree to use the domain name and associated websites in good faith.
      Without limiting the generality of the foregoing, you will not use the
      Privacy services for purposes of engaging in, participating in,
      sponsoring or hiding your involvement in illegal or morally
      objectionable activities, including but not limited to, activities which
      are designed, intended to or otherwise: (a) appeal primarily to prurient
      interests; (b) defame, embarrass, harm, abuse, threaten, or harass; (c)
      violate state or federal local laws and/or foreign territories; (d)
      involve hate crimes, terrorism or child pornography; (e) are tortious,
      vulgar, obscene, invasive of a third party&#39;s privacy, race,
      ethnicity, or are otherwise objectionable; (f) impersonate the identity
      of a third party; (g) harm minors in any way; or (h) relate to or
      transmit viruses, Trojan Horses, access codes, backdoors, worms,
      timebombs or any other code, routine, mechanism, device or item that
      corrupts, damages, impairs, interferes with, intercepts or
      misappropriates any software, hardware, firmware, network, system, data
      or personally identifiable information. Any alleged misconduct in
      connection with your use of the domain name and/or the associated
      website in contravention of this Section 2 will be cause for termination
      of the Privacy service in accordance with Section 4 below.
  </p>
  <p>
      <strong>3. Term of Service</strong> Unless otherwise specified, and
      subject to earlier termination as contemplated by Section 2 and Section
      4, the Privacy service will initially be activated for a one-year term.
      At the end of such one-year term, and at the end of each subsequent
      one-year term thereafter, the Privacy service will automatically renew
      for consecutive one-year terms at then current rates, unless you request
      cancellation of the Privacy service by notifying{' '}
      <Metadata name="title" mdxType="Metadata" /> at least thirty (30) days before the end of
      the then-current term. You acknowledge and agree that in connection with
      any automatic renewal <Metadata name="title" mdxType="Metadata" /> will attempt to charge
      the credit card you have on file at the then current rates, and you
      waive any requirement to obtain your ongoing affirmative consent to any
      such automatic renewal. It is your responsibility to keep your credit
      card information current and accurate, including the expiration date. If{' '}
      <Metadata name="title" mdxType="Metadata" /> is unable to collect renewal or other fees,
      you agree that <Metadata name="title" mdxType="Metadata" /> may contact you, but is not
      obliged to do so, and you agree that <Metadata name="title" mdxType="Metadata" /> may
      suspend or terminate the Privacy service as a result of inability to
      obtain payment. FEES WILL NOT BE PRO RATED OR OTHERWISE REFUNDED IF THE
      PRIVACY SERVICE IS CANCELLED OR OTHERWISE TERMINATED BEFORE THE END OF
      THE THEN-CURRENT TERM. Without limiting the generality of the foregoing,
      you understand that the Privacy services term may be different than the
      registration term of a domain which is associated with the Privacy
      services. If a domain expires and is deleted before the end of the term
      of the associated Privacy services, then the Privacy services associated
      with the domain will end when the domain is deleted and you understand
      that there will be no refund for any resulting unused portion of a
      Privacy services term.
  </p>
  <p>
      <strong>4. Disclosure and Termination</strong> You agree that in the
      event:
  </p>
  <blockquote>
      <p>
          (a) <Metadata name="title" mdxType="Metadata" /> or its parent, subsidiary, entity under
          common control and/or entity owned by the same beneficial owner, or
          their respective owners, beneficial owners, directors, officers,
          shareholders, employees, contractors, agents, partners, affiliates,
          successors or assigns is threatened, receives a complaint, notice of
          action or any demand from a third party with respect to a domain name
          and/or associated websites for which the Privacy service is activated,
          or
      </p>
      <p>
          (b) there is alleged infringement, abuse or misuse of, or activity of
          any nature that could result in loss or legal liability (civil or
          criminal) to <Metadata name="title" mdxType="Metadata" /> or its parent, subsidiary, entity under common control and/or entity owned by the same beneficial owner, or their respective owners, directors, officers,
          shareholders, employees, contractors, agents, partners, affiliates,
          successors or assigns with respect to a domain name and/or associated
          websites for which the Privacy service is activated, or
      </p>
      <p>
          (c) you are not, in <Metadata name="title" mdxType="Metadata" />
          &#39;s opinion, using the Privacy service in good faith as required by
          Section 2,
      </p>
      <p>
          you have provided us with your prior consent to disable the Privacy
          service and to disclose your technical and administrative contact
          information to any complainant or third party requesting such
          information and to make such information publicly available for a
          WHOIS query. You agree that no further prior authorization or approval
          from you or your agent is necessary for such disclosure. You
          understand and agree that <Metadata name="title" mdxType="Metadata" /> is under no
          obligation to provide the Privacy service to you, and that{' '}
          <Metadata name="title" mdxType="Metadata" /> may, in its sole discretion, for any reason
          or no reason, disable the Privacy service without notice or warning,
          either with respect to a specific domain name(s) or with respect to
          all domain names in your account (even if “customer” level Privacy
          service has been selected). YOU WILL NOT BE ENTITLED TO ANY FEE REFUND
          AS A RESULT OF DISCLOSURE OF YOUR ADMINISTRATIVE OR TECHNICAL CONTACT
          INFORMATION AND/OR TERMINATION OF THE PRIVACY SERVICE AS CONTEMPLATED
          BY SECTION 3 OR 4 HEREOF.
      </p>
      <p>
          Without limiting the generality of the foregoing,{' '}
          <Metadata name="title" mdxType="Metadata" /> shall be entitled to suspend access or
          service to your account in order to disable the Privacy service.
      </p>
  </blockquote>
  <p>
      <strong>5. Limitation of Liability</strong> TO THE EXTENT PERMITTED BY
      LAW, NEITHER{' '}
      <span style={{
          textTransform: 'uppercase'
        }}>
          <Metadata name="title" mdxType="Metadata" />
      </span>{' '}
      NOR, ITS PARENT, SUBSIDIARY, ENTITY UNDER COMMON CONTROL AND/OR ENTITY
      OWNED BY THE SAME BENEFICIAL OWNER, AND AFFILIATED COMPANIES, AND/OR
      THEIR RESPECTIVE OWNERS, DIRECTORS, OFFICERS, SHAREHOLDERS, EMPLOYEES,
      CONTRACTORS, AGENTS, PARTNERS, AFFILIATES, SUCCESSORS AND ASSIGNS SHALL
      NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL OR
      CONSEQUENTIAL DAMAGES RESULTING FROM YOUR USE OF THE PRIVACY SERVICE, OR
      THE DISCLOSURE OF YOUR ADMINISTRATIVE OR TECHNICAL CONTACT INFORMATION
      AND/OR TERMINATION OF THE PRIVACY SERVICE AS CONTEMPLATED BY SECTION 3
      OR 4 HEREOF. The foregoing limitation of liability is in addition to any
      other limitations of liability set forth in this Agreement.
  </p>
  <p>
      <strong>6. Indemnity, etc.</strong> You understand and agree that the
      release, indemnity and other obligations in favour of{' '}
      <Metadata name="title" mdxType="Metadata" /> and certain other persons in Section 14 of the
      Main Terms and Conditions apply to your use of the Privacy service.
  </p>
  <p>
      <strong>7. Accurate Information</strong> As a condition of your use of
      the Privacy service, you agree to: (a) provide current, complete and
      accurate information about you as required by the domain name
      application and registration process; (b) maintain and update such
      information as needed to keep it current, complete and accurate; and (b)
      respond within five (5) calendar days to a request by us to update or
      confirm the accuracy of your information. We rely on this information to
      carry out our service for you and comply with the requirements of
      registries of domain names and to send you important information and
      notices regarding your account and our services. Any failure by you to
      provide or update such information or to respond to our request is a
      material breach of this Agreement.
  </p>
  <p>
      <strong>8. Forwarded Information</strong> You agree that{' '}
      <Metadata name="title" mdxType="Metadata" /> may review communications sent to the email
      address associated with your Privacy service enabled domain. For
      communications received via certified or traceable courier mail (such as
      UPS or FedEx), or postal mail which does not appear to be unsolicited
      commercial mail, <Metadata name="title" mdxType="Metadata" /> will make commercially
      reasonable efforts to either (a) forward such communication to you or
      (b) attempt to communicate to you a scanned copy of a page of the
      communication to ascertain whether you wish to receive the full
      communication. You specifically acknowledge that{' '}
      <Metadata name="title" mdxType="Metadata" /> may elect to not forward to you (nor to
      otherwise communicate with you) regarding postal mail or email, fax,
      postal mail or telephone communications which appear to be unsolicited
      communications (e.g., communications which offer or advertize the sale
      of goods or services or which solicit charitable contributions). You
      authorize <Metadata name="title" mdxType="Metadata" /> to either discard all such
      communications or return all such communications to sender unopened. You
      agree to waive any and all claims arising from your failure to receive
      communications directed to your domain name but not forwarded to you by{' '}
      <Metadata name="title" mdxType="Metadata" />, including failures which arise from{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s mistake in judging whether a communication appears to be an
      unsolicited communication. You agree that you will reimburse{' '}
      <Metadata name="title" mdxType="Metadata" /> for any reasonable fees for administrative
      tasks outside the scope of regular services incurred as a result of your
      use of the Privacy service. These may include, but are not limited to,
      Customer Support issues that require personal service and disputes that
      require legal services.
  </p>
  <p>
      <strong>9.</strong> In the event this Agreement or Schedule expires or
      terminates, Sections 4, 5, 6 and 8 of this Schedule shall survive such
      expiration or termination.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulef">
      <a href="#schedulef" name="schedulef">
          Schedule F
      </a>
      : Terms and Conditions Applicable to SSL Certificate Services
  </h2>
  <p>
      The Secure Sockets Layer (SSL) services offered under these SSL Terms is
      an &#34;additional service&#34; as provided under Section 3 of this
      Agreement, &#34;VARIOUS SERVICES&#34;.
  </p>
  <p>
      SSL enterprise and certificate services provided by{' '}
      <Metadata name="title" mdxType="Metadata" /> to you include assisting you in acquiring a
      new SSL certificate(s) and its associated products and services (the
      &#34;SSL Service&#34;).{' '}
  </p>
  <p>The following additional terms apply to the SSL Service: </p>
  <blockquote>
      <p>
          a) You acknowledge and agree <Metadata name="title" mdxType="Metadata" /> cannot
          guarantee the issuance of an SSL certificate following your submission
          of an application thereof. Issuance of an SSL certificate is subject
          to verification and approval of the information you submitted. This
          verification may, in some instances, take several business days.
      </p>
      <p>
          b) <Metadata name="title" mdxType="Metadata" /> is an authorized reseller for GlobalSign.
          You hereby authorize <Metadata name="title" mdxType="Metadata" /> to remit your submitted
          SSL certificate application, including all the information included
          therein, and acquire an SSL certificate from GlobalSign on your
          behalf. You agree to GlobalSign&#39;s terms and conditions
          incorporated herein by reference, as found at{' '}
          <a href="https://www.globalsign.com/repository/globalsign-subscriber-agreement-digital-certificates-and-services.pdf">
          https://www.globalsign.com/repository/globalsign-subscriber-agreement-digital-certificates-and-services.pdf
          </a>
          . You understand and agree that you are entering into and agreeing to
          a separate contractual relationship between you and GlobalSign in
          addition to these SSL Terms and this Agreement. You understand and
          agree that the underwritten Liability Program is provided as a service
          by GlobalSign. In order to provide an enhanced customer experience and
          as a convenience to you, <Metadata name="title" mdxType="Metadata" /> will pay the SSL
          certificate/renewal fees on your behalf as part of the SSL Service
          provided that (i) these SSL Terms have not been cancelled or otherwise
          terminated, (ii) you have paid any amounts due under these SSL Terms,
          (iii) you are not in breach of the Agreement or these SSL Terms, and
          (iv) that GlobalSign agrees to and accepts your SSL certificate
          application/renewal fees. Notwithstanding the immediately forgoing
          sentence, you expressly acknowledge and agree that you shall be
          responsible for all fees, liability and obligations with your
          relationship with GlobalSign.
      </p>
      <p>
          c) You authorize <Metadata name="title" mdxType="Metadata" /> to list itself as a contact
          in connection with the SSL certificate and to take any actions{' '}
          <Metadata name="title" mdxType="Metadata" /> deems necessary or appropriate in connection
          therewith. Upon termination of SSL Services, <Metadata name="title" mdxType="Metadata" />{' '}
          may immediately cease acting in such capacity and reserves the right
          to transfer your account to GlobalSign to serve for all future
          communications in connection with your SSL certificate. You further
          authorize <Metadata name="title" mdxType="Metadata" /> to list you as the subscriber and
          certificate administrator in connection with SSL certificate. You may
          also specify another subscriber and certificate administrator;
          however, such person(s) may be required to enter into a separate
          agreement with GlobalSign for use of SSL certificate services and/or
          access for services in support of your SSL certificate. Upon
          termination of SSL Services, <Metadata name="title" mdxType="Metadata" /> will not be
          responsible for forwarding any notices (email or otherwise) to you or
          for taking any other actions in connection with your SSL certificate.
          You will be solely responsible for any ongoing fees, as well as taking
          all necessary or advisable actions in connection with your SSL
          certificate.
      </p>
  </blockquote>
  <p>
      <strong>1. Automatic Renewals</strong>
  </p>
  <p>
      If you purchased a new SSL certificate using the{' '}
      <Metadata name="title" mdxType="Metadata" /> SSL Service, <Metadata name="title" mdxType="Metadata" /> will
      automatically renew and bill you for the SSL certificate registration in
      accordance with Section 2 (Fees) below and this Agreement. Automatic
      renewal will not occur if the option is disabled through the
      administrative module for your account with <Metadata name="title" mdxType="Metadata" />.
      Each new SSL certificate acquired by <Metadata name="title" mdxType="Metadata" /> from
      GlobalSign will be renewed prior to each annual anniversary. Failure to
      electronically approve the renewal or remit Fees in accordance with
      Section 2 and the Fees Policy, may risk the non-renewal of your SSL
      certificate. Your SSL certificate will be renewed with GlobalSign only
      after the annual or multi-year fee is successfully charged to your
      credit card or payment transmitter in a timely manner.
  </p>
  <p>
      <strong>2. Fees</strong>
  </p>
  <p>
      SSL Certificate Registration Fees will be charged yearly and in advance
      (with multi-year certificate subscriptions renewed prior to the
      expiration of the last year and for a period of equal length) in
      accordance with this Agreement.
  </p>
  <p>
      <strong>3. Verification of Information</strong>
  </p>
  <blockquote>
      <p>
          a) You are solely responsible for maintaining that all information
          relating to the use of your SSL certificate is up-to-date with
          GlobalSign. Further, in accordance with the terms and conditions of
          your agreement with GlobalSign and in order to maintain a safe
          ecommerce presence, <Metadata name="title" mdxType="Metadata" /> may from time to time
          request that you verify any information to be supplied to GlobalSign.
          In the event that you fail to respond to any such request or fail to
          verify any such information within 30 days of the request, GlobalSign
          and/or <Metadata name="title" mdxType="Metadata" /> may, in its/our sole and absolute
          discretion, immediately terminate your SSL Services. This remedy is in
          addition to any other remedies available under law or this Agreement.
      </p>
      <p>
          b) You shall protect the confidentiality of any encryption keys used
          by you in connection with your SSL certificate. Further, you shall
          promptly request that GlobalSign revoke any SSL certificate upon any
          actual or suspected loss, disclosure, or other compromise of your
          encryption keys or breach of the SSL certificate.
      </p>
  </blockquote>
  <p>
      <strong>4. Terms and Termination</strong>
  </p>
  <blockquote>
      <p>
          a) Your SSL certificate may only be transferred, if allowed, under the
          terms and conditions of your agreement with GlobalSign.
      </p>
      <p>
          b) <Metadata name="title" mdxType="Metadata" /> may, but has no duty to, immediately
          suspend or terminate your use of the SSL Service and remove any of
          your materials (including without limitation your SSL certificate)
          from <Metadata name="title" mdxType="Metadata" /> servers in the event{' '}
          <Metadata name="title" mdxType="Metadata" />, in its sole discretion, concludes that (i)
          there is any change to the information on the SSL certificate or the
          certificate application, including but not limited to the change of
          the organization name or domain name registration, (ii) there is any
          actual, <Metadata name="title" mdxType="Metadata" /> reasonably suspects, loss,
          disclosure, or other compromise of an encryption key for the SSL
          certificate, (iii) you have engaged in illegal activities, in
          activities or sales that may damage the rights of{' '}
          <Metadata name="title" mdxType="Metadata" /> or others, or (iv) you have violated or
          threatened to violate these SSL Terms, the terms of this Agreement or
          any other agreement you may have with <Metadata name="title" mdxType="Metadata" />. Any
          suspension or termination under this paragraph may take effect
          immediately. In the event that <Metadata name="title" mdxType="Metadata" /> terminates
          your SSL Service in connection with this paragraph, you will not be
          entitled to a refund or credit of any fees you have paid. Without
          limitation, you expressly acknowledge and agree that in addition to
          this Section (4), the terms and conditions of this Agreement also
          apply to your use of the SSL Services.
      </p>
  </blockquote>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduleg">
      <a href="#scheduleg" name="scheduleg">
          Schedule G
      </a>
      : Terms and Conditions Relating to Afternic Fast Transfer
  </h2>
  <p>
      <strong>1. DESCRIPTION OF SERVICE</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> is partnering with Afternic® to provide{' '}
      <Metadata name="title" mdxType="Metadata" /> customers with a means to sell their domain
      name(s) to interested buyers through a network of selected registrars.
      If you choose to list your domain name for sale through the Fast
      Transfer Service and enter into this Agreement, you expressly
      acknowledge, understand and agree that: (i) <Metadata name="title" mdxType="Metadata" />{' '}
      shall not have any liability or obligations to you regarding the listing
      and sale of your domain name through the Fast Transfer Service or the
      transfer of the domain name from you to the buyer; (ii){' '}
      <Metadata name="title" mdxType="Metadata" /> has no control over buyers or Afternic&#39;s
      network of selected registrars and makes no representations as to the
      reliability or capability of the listing service, or the qualifications
      of any potential buyer or the ability of any buyer to pay for a domain
      name; and (iii) <Metadata name="title" mdxType="Metadata" /> does not collect, retain or
      have access to any credit card information of buyers utilizing the Fast
      Transfer Service, nor do we process the payment of funds between you and
      a buyer and therefore cannot be held liable for any non-payment by the
      buyer or any unauthorized disclosure of any personal or credit card
      information concerning the buyer. All terms and conditions related to
      the transfer of funds between Afternic buyers and sellers are covered in
      the Afternic Membership Agreement and Terms of Service located at{' '}
      <a href="https://www.afternic.com/legal">
          https://www.afternic.com/legal
      </a>
      .
  </p>
  <p>
      When you register your domain name with <Metadata name="title" mdxType="Metadata" /> and
      list your domain for sale as part of the Fast Transfer Service, you
      expressly acknowledge and agree that we may instantly transfer any
      domain name successfully sold in the Fast Transfer Service away from
      your <Metadata name="title" mdxType="Metadata" /> account into the account of the
      successful buyer of the domain name. You acknowledge and agree to allow{' '}
      <Metadata name="title" mdxType="Metadata" /> to disable any transfer lock feature
      associated with a domain name enrolled in the Fast Transfer Service,
      including but not limited to the disabling of our domain name transfer
      validation service.
  </p>
  <p>
      You agree to release, indemnify, defend and hold harmless{' '}
      <Metadata name="title" mdxType="Metadata" /> and any of its contractors, agents, employees,
      officers, directors, shareholders, affiliates and assigns from all
      liabilities, claims, damages, costs and expenses, including reasonable
      attorneys&#39; fees and expenses, relating to or arising out of your use
      of the Fast Transfer Service, including, but not limited to, the instant
      transfer of the domain name from your <Metadata name="title" mdxType="Metadata" /> account
      to the account of the buyer.
  </p>
  <p>
      <strong>2. LIMITATIONS AND DISCONTINUATION OF SERVICE</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> does not and cannot guarantee the sale or
      purchase of any domain name through the Fast Transfer Service. Transfer
      of a domain name to a buyer is not instantaneous at the time of sale and
      may take several days to occur.
  </p>
  <p>
      You may remove a domain name from the Fast Transfer Service at any time.
      In the event that you remove a domain from the Service, please be aware
      that removal of the domain name from the Afternic network is not
      instantaneous, and may take several days to occur.{' '}
      <Metadata name="title" mdxType="Metadata" /> will complete the instant transfer process for
      any domain name enrolled in the Fast Transfer Service and sold through
      the Afternic network during this timeframe.
  </p>
  <p>
      You acknowledge and agree that <Metadata name="title" mdxType="Metadata" /> may remove your
      domain name from the Fast Transfer Service at any time for any reason,
      without prior notification, including, but not limited to: non-payment
      of fees, expiration of domain name, fraud, restrictions on transfer, the
      filing of a trademark or ownership dispute concerning the domain name,
      or in the event of a transfer of the domain name to another registrar.
  </p>
  <p>
      <strong>
          3. DESIGNATED AGENT AND CHANGE OF REGISTRANT INFORMATION
      </strong>
  </p>
  <p>
      “DESIGNATED AGENT” MEANS AN INDIVIDUAL OR ENTITY THAT THE PRIOR
      REGISTRANT OR NEW REGISTRANT EXPLICITLY AUTHORIZES TO APPROVE A CHANGE
      OF REGISTRANT REQUEST ON ITS BEHALF. FOR THE PURPOSE OF FACILITATING THE
      FAST TRANSFER PROCESS, AND IN ACCORDANCE WITH ICANN&#39;S{' '}
      <a href="https://www.icann.org/resources/pages/transfer-policy-2016-06-01-en">
          CHANGE OF REGISTRANT POLICY
      </a>
      , YOU AGREE TO APPOINT <Metadata name="title" mdxType="Metadata" /> AS YOUR DESIGNATED
      AGENT FOR THE SOLE PURPOSE OF EXPLICITLY CONSENTING TO MATERIAL CHANGES
      OF REGISTRATION CONTACT INFORMATION ON YOUR BEHALF.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduleh">
      <a href="#scheduleh" name="scheduleh">
          Schedule H
      </a>
      : Terms and Conditions Relating to Expiry Protection and Ownership Protection Services
  </h2>
  <h4>Virtual Private Server (VPS) Acceptable Usage Policy (AUP)</h4>
  <p>
      <strong>Excessive Usage </strong>
  </p>
  <p>
      Customers are required to utilize the server&#39;s resources in an
      efficient and responsible manner. Excessive use of server CPU, bandwidth
      and memory resources by a customer can interfere with or prevent normal
      service performance for other customers. Resources are defined as
      bandwidth, memory and/or processor utilization. A VPS is considered
      using “Excessive amounts of resources” when it monopolizes the resources
      available using 10% or more of system resources for longer than 60
      seconds. There are numerous problems that could cause such problems,
      this includes but is not limited to scripts, FTP connections, HTTP
      requests, Crypto currency miners, etc. A site that consumes over the
      account limit of bandwidth is also considered “excessive resources”.
      This policy is only implemented in extreme circumstances and is intended
      to prevent the misuse of our servers. A Customer who is using “excessive
      resources” will be asked to do one or more of the following: upgrade
      their plan, fix the issue causing &#34;excessive use&#34;, or cease the
      activity causing excessive use.
      <Metadata name="title" mdxType="Metadata" /> reserves the right to throttle or cancel any
      accounts that abuse our services or are deemed to be excessive users.{' '}
      <Metadata name="title" mdxType="Metadata" /> will be the sole and final arbiter as to what
      constitutes a violation of this policy.
  </p>
  <p>
      <strong>Denial of Service </strong>
  </p>{' '}
  <p>
      <Metadata name="title" mdxType="Metadata" /> absolutely prohibits the use of services or
      network services for the origination or control of denial of service
      (“DoS”) attacks or distributed denial of service (“DDOS”) attacks. Any
      relation to DoS or DDoS type activity is a direct violation of{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s AUP.
  </p>
  <p>
      <strong>Server Abuse </strong>
  </p>{' '}
  <p>
      Any attempts to undermine or cause harm to a <Metadata name="title" mdxType="Metadata" />{' '}
      server or subscriber of <Metadata name="title" mdxType="Metadata" /> is strictly prohibited
      including, but not limited to:
  </p>
  <ul>
      <li>
          {' '}
          Logging into a server or account that you are not authorized to
          access;
      </li>
      <li>
          {' '}
          Accessing data or taking any action to obtain services or information
          not intended for you or your use without the consent of the owner;
      </li>
      <li>
          {' '}
          Tampering, hacking, modifying, or otherwise corrupting or breaching
          security or authentication measures without proper authorization;
      </li>
      <li>
          {' '}
          Transmitting material that contains viruses, Trojan horses, worms,
          time bombs, cancelbots or other computer programming routines or
          engines with the intent or effect of damaging, destroying, disrupting
          or otherwise impairing a computer&#39;s functionality or the operation
          of <Metadata name="title" mdxType="Metadata" />
          &#39;s systems;
      </li>
      <li>
          {' '}
          Monitoring data or traffic on any network or system without the
          express authorization of the owner of the system or network;
      </li>
      <li>
          {' '}
          Scanning of any type including but not limited to Port Scanning and
          Network scanning;
      </li>
      <li>
          {' '}
          Interfering with, intercepting or expropriating any system, data or
          information which you do not have the right to access; and
      </li>
      <li>
          {' '}
          Interfering with service to any user, host or network including,
          without limitation, by means of overloading, “flooding,”
          “mailbombing,” or “crashing” any computer system.
      </li>
  </ul>
  <p>
      You agree that we may quarantine or delete any data stored on the{' '}
      <Metadata name="title" mdxType="Metadata" /> network if the data is infected with a virus,
      or is otherwise corrupted, and has the potential to infect or corrupt
      the network or other customers&#39; data that is stored on the network.
  </p>
  <p>
      <strong>IP Address Usage</strong>
  </p>
  <p>
      You may only use IP addresses assigned to you by{' '}
      <Metadata name="title" mdxType="Metadata" /> in connection with your{' '}
      <Metadata name="title" mdxType="Metadata" /> Services. You agree that if the{' '}
      <Metadata name="title" mdxType="Metadata" /> IP addresses assigned to your account are
      listed on an abuse database, you will be in violation of this AUP, and{' '}
      <Metadata name="title" mdxType="Metadata" /> may take reasonable action to protect its IP
      addresses, including suspension and/or termination of your Service,
      regardless of whether the IP addresses were listed as a result of your
      actions.
  </p>
  <p>
      <strong>Blacklisting/Retaliation</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> may terminate your Services if your email
      address or related IP number(s) is/are blacklisted by any third-party,
      or <Metadata name="title" mdxType="Metadata" /> is retaliated against as a result of your
      use of the mail system, regardless of whether you are in breach of this
      AUP or are otherwise at fault.
  </p>
  <p>
      <strong>Security</strong>
  </p>
  <p>
      You are responsible for any misuse of your account, even if the
      inappropriate activity was committed by a friend, family member, guest
      or employee. Therefore, you must take steps to ensure that others do not
      gain access to your account. In addition, you may not use your account
      to breach the security of another account or attempt to gain
      unauthorized access to another network or server. You must take
      reasonable security precautions. You must protect the confidentiality of
      your password, use complex passwords, and you should change your
      password periodically. <Metadata name="title" mdxType="Metadata" /> uses a shared
      responsibility model. Customers are responsible for securing the
      following: Customer Data, Applications, Platforms, Access management,
      and Firewalls. All software and scripts installed on your account must
      be free of vulnerabilities, viruses, and malware.{' '}
      <Metadata name="title" mdxType="Metadata" /> is responsible for the security of the
      following: Servers, Storage devices, and Networking.
  </p>
  <p>
      <strong>Plesk EULA</strong>
  </p>
  <p>
      Plesk comes pre-installed on all VPS packages, should you choose to use
      it on your server, you agree to be bound by the{' '}
      <a href="https://www.plesk.com/legal/">Plesk EULA </a>, which is hereby
      incorporated by reference.
  </p>
  <p>
      <strong>Service Uptime Guarantee</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> offers a Service uptime guarantee of 99.9%
      (“Service Uptime Guarantee”) of available time per month. Third party
      monitoring service reports may not be used for justification due to a
      variety of factors including the monitor&#39;s network capacity/transit
      availability. The uptime of the server is defined as the reported uptime
      from the operating system and the Apache Web Server which may differ
      from the uptime reported by other individual services. If we fail to
      maintain this Service Uptime Guarantee in a particular month (as solely
      determined by us), you will be eligible to receive a credit to apply to
      future services billing cycles based upon the Unavailability for that
      month. The credit may be used only for the purchase of further products
      and services from us, and is exclusive of any applicable taxes. The
      Service Uptime Guarantee does not apply to service interruptions caused
      by: (1) periodic scheduled maintenance or repairs we may undertake from
      time to time; (2) interruptions caused by you from custom scripting,
      coding or the installation of third-party applications; (3) outages that
      do not affect the appearance of your website but merely affect access to
      your website such as FTP and email; (4) causes beyond our control or
      that are not reasonably foreseeable; and (5) outages related to the
      reliability of certain programming environments.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulei">
      <a href="#schedulei" name="schedulei">
          Schedule I
      </a>
      : Terms and Conditions Relating to Preferred Partner Program
  </h2>
  <p>
      When enrolled in the Preferred Partner Program, the default payment
      method will be set as account credit, unless <Metadata name="title" mdxType="Metadata" />{' '}
      is notified otherwise. Other payment methods include PayPal, cheque, and
      ACH.
  </p>
  <p>
      When a customer has been referred to <Metadata name="title" mdxType="Metadata" /> by
      someone enrolled in the Preferred Partner Program, their account must be
      in good standing for three (3) months before a payment will be issued.
  </p>
  <p>
      Premium domain purchases are not included in the Preferred Partner
      Program payment structure.
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> reserves the right to deny entry or revoke
      status in the Preferred Partner Program at any time. The terms of this
      program may also be modified at any time and without prior notice.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="registrant">
      <a href="#registrant" name="registrant">
          Registrant Rights, Benefits & Responsibilities
      </a>
  </h2>
  <p>
      If you register a domain name, you become the Registered Name Holder
      (also known as Registrant) for that domain. The Internet Corporation for
      Assigned Names and Numbers (<a href="https://www.icann.org/">ICANN</a>)
      has set forth various rights and responsibilities of Registrants over
      the registration and use of a registered Internet domain name. Further
      information about ICANN&#39;s policies and materials for Registrants is
      available on the ICANN website:
  </p>
  <ul>
      <li>
          <a href="https://www.icann.org/resources/pages/educational-2012-02-25-en">
          Registrant Educational Materials
          </a>
      </li>
      <li>
          <a href="https://www.icann.org/resources/pages/responsibilities-2014-03-14-en">
          Registrant Rights &amp; Responsibilities
          </a>
      </li>
      <li>
          <a href="https://www.icann.org/resources/pages/benefits-2013-09-16-en">
          Registrant&#39;s Benefits &amp; Responsibilities
          </a>
      </li>
  </ul>
  <p>
      <a href="#top">Back to Top</a>
  </p>
    </Metadata>
    <Metadata name="resellerConditional" match="host" value="internic.ca" mdxType="Metadata">
  <h1>Terms & Conditions</h1>
  <Box justifyContent="space-between" mb={4} mdxType="Box">
      <Stack mdxType="Stack">
          <p>
          <strong>
              <a href="#mainterms">Main Terms and Conditions</a>
          </strong>
          </p>
          <p>
          <strong>
              <a href="#schedulea">Schedule A</a>:
          </strong>{' '}
          Terms and Conditions Relating to Domain Name Registration
          </p>
          <p>
          <strong>
              <a href="#scheduleb">Schedule B</a>:
          </strong>{' '}
          Terms and Conditions Applicable to Email Services
          </p>
          <p>
          <strong>
              <a href="#schedulec">Schedule C</a>:
          </strong>{' '}
          Terms and Conditions Applicable to Web Hosting Services
          </p>
          <p>
          <strong>
              <a href="#scheduled">Schedule D</a>:
          </strong>{' '}
          Terms and Conditions Applicable to the High Security Service
          </p>
          <p>
          <strong>
              <a href="#schedulee">Schedule E</a>:
          </strong>{' '}
          Terms and Conditions Applicable to Privacy Services
          </p>
          <p>
          <strong>
              <a href="#schedulef">Schedule F</a>:
          </strong>{' '}
          Terms and Conditions Applicable to SSL Certificate Services
          </p>
          <p>
          <strong>
              <a href="#scheduleg">Schedule G</a>:
          </strong>{' '}
          Terms and Conditions Relating to Afternic Fast Transfer
          </p>
          <p>
          <strong>
              <a href="#scheduleh">Schedule H</a>:
          </strong>{' '}
          Terms and Conditions Relating to Expiry Protection and Ownership Protection Services
          </p>
          <p>
          <strong>
              <a href="#schedulei">Schedule I</a>:
          </strong>{' '}
          Terms and Conditions Relating to Preferred Partner Program
          </p>
          <p>
          <strong>
              <a href="#registrant">
              Registrant Rights, Benefits & Responsibilities
              </a>
          </strong>
          </p>
      </Stack>
      <Box border={2} p={3} mdxType="Box">
          <div>
              <h3>Additional Terms &amp; Conditions</h3>
              <div>
                <Stack mdxType="Stack">
                  <li className="unit size1of3">
                    <a href="/terms-conditions/asia">.ASIA </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/au">.AU </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/biz"> .BIZ </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/ca">.CA </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/cn">.CN </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/co">.CO </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/eu">.EU </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/info"> .INFO </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/mobi">.MOBI </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/name">.NAME </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/sucks">.SUCKS </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/us">.US </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/xxx"> .XXX </a>
                  </li>
                  <li className="unit size1of3">
                    <a href="/terms-conditions/highly-regulated">
                      .LAWYER, .DENTIST & .ATTORNEY
                    </a>
                  </li>
                </Stack>
              </div>
          </div>
      </Box>
  </Box>
  <h1 id="mainterms">
  <a href="#mainterms" name="mainterms">
      Main Terms and Conditions
  </a>
  </h1>
  <p>
      <strong>1. INTRODUCTION</strong> In this Service Agreement
      (&#34;Agreement&#34;), &#34;Registrant&#34; &#34;you&#34; and
      &#34;your&#34; refer to each user, customer (collectively
      &#34;Customer&#34;) and its agents, and &#34;Registrar&#34;,
      &#34;we&#34;, &#34;us&#34; and &#34;our&#34; refer to{' '}
      <Metadata name="BlueSnapTitle" mdxType="Metadata" /> and/or its affiliated entities. (or collectively “
      <Metadata name="title" mdxType="Metadata" />
      ”). This Agreement explains our obligations to you, and your obligations
      to us in relation to the service(s) that you purchase and use from us.
      By selecting <Metadata name="title" mdxType="Metadata" /> service(s) you have agreed to
      establish an account with us for such service(s). When you use your
      account or permit someone else to use your account to purchase or
      otherwise acquire access to additional <Metadata name="title" mdxType="Metadata" />{' '}
      service(s) or to modify or cancel your <Metadata name="title" mdxType="Metadata" />{' '}
      service(s) (even if we were not notified of such authorization), this
      Agreement covers any such service or actions. Any acceptance of your
      application(s) for our service(s) and the performance of our service(s)
      will occur at our offices in the location of our principal place of
      business. You agree that each person listed in your account information
      as being associated with your account for any service(s) provided to you
      is your agent with full authority to act on your behalf for such
      services in accordance with the permissions granted, including but not
      limited to the authorization to terminate, transfer (where permitted by
      this Agreement), or to modify or purchase additional service(s). You
      also agree that if you list, directly or by default,{' '}
      <Metadata name="title" mdxType="Metadata" /> as a contact for your account for any of the
      service(s), we have the right, without notice, to remove our name and/or
      information from any such service(s) and to replace the same with the
      name and/or information provided by you.
  </p>
  <p>
      You agree that <Metadata name="title" mdxType="Metadata" /> may, in its sole discretion,
      renew a domain using any registrar owned by a parent, subsidiary, entity
      under common control and/or entity owned by the same beneficial owner,
      at any time
      <Metadata name="BlueSnapSubsidiaryRef" mdxType="Metadata" />
      . In addition, you agree that <Metadata name="title" mdxType="Metadata" /> may, in its sole
      discretion, transfer or share your <Metadata name="title" mdxType="Metadata" /> account
      information, domains, hosting, additional products, billing history,
      payment information (including without limitation credit card
      information if applicable), payment profile, and/or all other products
      or services to or with a parent, subsidiary, entity under common control
      and/or entity owned by the same beneficial owner, at any time
      <Metadata name="BlueSnapSubsidiaryRef" mdxType="Metadata" />.
  </p>
  <p>
      <strong>Principal place of business & Mailing Address</strong>
  </p>
  <p>
      <Metadata name="BlueSnapTitle" mdxType="Metadata" />: <Metadata name="address" mdxType="Metadata" />
  </p>
  <p>
      IMPORTANT NOTICE - ARBITRATION AGREEMENT AND CLASS ACTION WAIVER: BY
      AGREEING TO BE BOUND BY THE TERMS OF SERVICE, YOU AGREE THAT ALL
      DISPUTES BETWEEN US WILL BE RESOLVED BY BINDING ARBITRATION, EXCEPT FOR
      CERTAIN LIMITED TYPES OF DISPUTES DESCRIBED IN SECTION 23 BELOW. YOUR
      AGREEMENT TO ARBITRATION MEANS YOU ARE GIVING UP THE RIGHT TO GO TO
      COURT AND THE RIGHT TO A TRIAL BY JURY, AND INSTEAD, DISPUTES WILL BE
      DECIDED BY A NEUTRAL ARBITRATOR. YOU ALSO AGREE THAT ALL DISPUTES
      BETWEEN US, WHETHER IN COURT OR IN ARBITRATION, WILL BE BROUGHT ONLY ON
      AN INDIVIDUAL BASIS AND YOU ARE WAIVING YOUR RIGHT TO BRING OR
      PARTICIPATE IN A CLASS ARBITRATION OR CLASS ACTION. PLEASE READ SECTION
      23 OF THIS AGREEMENT FOR FURTHER DETAILS.
  </p>
  <p>
      <strong>2. SECURITY</strong> When you register a domain name or
      subscribe to our service(s) with us, you provide us with a password or
      passphrase that can be used to modify your information. It is your
      responsibility to safeguard your password or passphrase. You accept full
      responsibility for modifications made to your service(s) using this
      password or passphrase.
  </p>
  <p>
      <strong>3. VARIOUS SERVICES</strong> Unless otherwise stated, all
      promotions and special offers are for the first term only and products
      and/or services will renew at regular price. The terms of this Agreement
      are applicable to any and all of the <Metadata name="title" mdxType="Metadata" />
      &#39;s service(s) you have chosen, including any additional services you
      may choose in the future which may be offered by{' '}
      <Metadata name="title" mdxType="Metadata" /> from time to time.{' '}
      <b>NOTICE REGARDING BUNDLED SERVICES:</b> If you purchase{' '}
      <Metadata name="title" mdxType="Metadata" /> services that are sold together as a “bundled”
      package (e.g., you select a web site package that includes both a domain
      name and hosting services, as opposed to your purchasing such services
      separately) (&#34;Bundled Services&#34;), termination of any part of the
      service, may, in our sole discretion, result in termination of all services provided as part of
      the bundled package.{' '}
  </p>
  <p>
      <strong>4. FEES AND PAYMENT</strong> As consideration for the services
      you have selected, you agree to pay <Metadata name="title" mdxType="Metadata" /> the
      applicable service(s) fees either set forth on our Web site at the time of your
      selection or otherwise communicated to you by us. All fees are due immediately and are non-refundable.{' '}
      <Metadata name="title" mdxType="Metadata" /> may take all remedies available to collect
      fees owed and may recover from you all costs and expenses (including
      reasonable attorney fees) incurred by <Metadata name="title" mdxType="Metadata" /> to
      collect such fees. If you qualify, we may extend payment terms to you.
      You agree to recurring payments and a recurring billing schedule for
      your services. We reserve the right to change our prices and will post{' '}
      <a href="/domains/pricing">prices on our website</a>{' '}
      and/or otherwise communicate them to you directly.{' '}
  </p>
  <p>
      <strong>5. TERM OF SERVICE</strong> Unless otherwise specified, each{' '}
      <Metadata name="title" mdxType="Metadata" /> service is for a one-year initial term and is
      automatically renewed thereafter for successive one-year terms. A domain
      registered by you will be billed annually, until you choose to cancel
      the domain. Domain renewals, recovery or other services with us are
      subject to our then current Terms and Conditions as well as payment of
      all applicable service fees at the time of the recurring charge. Domain
      name renewals and recovery are subject to the registry&#39;s acceptance
      of your domain name registration. Registered domain name(s) will expire
      on the expiration date specified in the registration term. Unless the
      registry prohibits it, if you fail to renew a domain name by the
      expiration date we may assume the registration of that domain name and
      may hold it in its own account, delete it, or sell it to a third party.
      During the period following the expiration of a domain name, the domain
      name will cease to resolve, the WHOIS and/or RDAP registration records
      may be revised, and visitors to your website on that domain name may be
      directed to a default web page. This default web page may feature
      advertisements posted by us. You hereby acknowledge and agree that your
      right and interest in a domain name ceases upon its expiration. You are
      solely responsible for renewing its registration in a timely manner. If
      we, in our sole discretion, elect to renew the registration, you will
      have a grace period of thirty (30) days during which you may re-register
      the domain name. Additional costs for the redemption and
      re-registration will apply.
  </p>
  <p>
      Should you select to pay upfront for a multiple year term, each year on
      the anniversary of the registration <Metadata name="title" mdxType="Metadata" /> will pay
      on your behalf to the registry the required registry fees until the term
      you have purchased expires or we are no longer
      your registrar. Should the registry raise its fees,{' '}
      <Metadata name="title" mdxType="Metadata" /> will inform you and collect the difference for
      the term remaining.
  </p>
  <p>
      In addition to other termination provisions contained in this Agreement,
      if you purchase Bundled Services, any termination relating to such
      bundle, may, in our sole discretion, terminate all <Metadata name="title" mdxType="Metadata" /> services included in
      such bundle. For instance, any domain name registered with or maintained
      by <Metadata name="title" mdxType="Metadata" /> under this Agreement may, in our sole
      discretion, be cancelled and may thereafter become available for registration by another party. Upon the
      effective date of termination, <Metadata name="title" mdxType="Metadata" /> will no longer
      provide the bundled services to you, any leases granted to you shall
      immediately terminate, and you will cease using such services
      immediately; provided, however, that <Metadata name="title" mdxType="Metadata" /> may, in
      its sole discretion and subject to your agreeing to be bound by the
      applicable agreement(s) and to pay the applicable fees for such
      services, allow you to convert certain services included in the bundled
      services to stand alone services.
  </p>
  <p>
      In addition to any other remedies we have, we may, in our sole
      discretion, suspend or cancel your domain name registration (and/or
      corresponding website, if applicable) in any of the following
      circumstances:
  </p>
  <ul>
      <li>if you breach this Agreement;</li>
      <li>if you fail to provide timely payment for any services we provide;</li>
      <li>if you fail to provide accurate contact or billing information;</li>
      <li>in the event there was an error in the registration process for such domain name as required by ICANN or a registry;</li>
      <li>to protect our integrity and stability as well as that of any applicable registry;</li>
      <li>to comply with any applicable laws, government rules, requests of law enforcement and court orders;</li>
      <li>in compliance with any dispute resolution process;</li>
      <li>to combat DNS Abuse; or</li>
      <li>to avoid any liability, civil or criminal.</li>
  </ul>
  <p>
      <strong>6. ACCURATE INFORMATION</strong> As further consideration for
      the <Metadata name="title" mdxType="Metadata" /> service(s), you agree to:{' '}
  </p>
  <blockquote>
      <p>
          6.1 provide certain current, complete and accurate information about
          you as required;{' '}
      </p>
      <p>
          6.2 maintain and update this information as needed to keep it current,
          complete and accurate; and{' '}
      </p>
      <p>
          6.3 respond within fifteen (15) calendar days to a request by us to
          update or confirm the accuracy of your information.{' '}
      </p>
  </blockquote>
  <p>
      We rely on this information to carry out our services for you and comply
      with the requirements of the registries of domain names and our service
      providers and to send you important information and notices regarding
      your account and our services. Any failure by you to provide or update
      such information or to respond to our request is a material breach of
      this Agreement.{' '}
  </p>
  <p>
      <strong>7. PRIVACY POLICY</strong> Our privacy policy, located on our
      Web site at <a href="/privacy-policy">internic.ca/privacy-policy</a> incorporated
      herein by reference, sets forth your and our rights and responsibilities
      with regard to your personal information. You agree to read the privacy
      policy. You agree that we, in our sole discretion, may modify our
      privacy policy. We will post such revised statement on our Web site at
      least thirty (30) calendar days before it becomes effective. You agree
      to periodically review our Web site to be aware of any such revisions.
      You agree that, by using our services after modifications to the privacy
      policy become effective, you have agreed to these modifications. You
      acknowledge that if you do not agree to any such modification, you may
      terminate this Agreement by providing us with notice in accordance with
      Section 25 below. We will not refund any fees paid by you if you
      terminate your Agreement with us. We will not process the personal
      information that we collect from you in a way incompatible with the
      purposes and other limitations described in our privacy policy, and we
      will take reasonable precautions to protect your personal information
      from loss, misuse and unauthorized access, disclosure, alteration or
      destruction.{' '}
  </p>
  <p>
      <strong>8. THIRD PARTY INFORMATION</strong> You represent and warrant
      that you have provided notice to, and obtained consent from, any third
      party individuals whose personal information you supply to us as part of
      our services with regard to:{' '}
  </p>
  <blockquote>
      <p>
          8.1 the purposes for which such third party&#39;s personal information
          has been collected;
      </p>
      <p>
          8.2 the intended recipients or categories of recipients of the third
          party&#39;s personal information;{' '}
      </p>
      <p>
          8.3 which parts of the third party&#39;s information are obligatory
          and which parts, if any, are voluntary; and{' '}
      </p>
      <p>
          8.4 how the third party can access and, if necessary, rectify the
          third party&#39;s personal information..{' '}
      </p>
  </blockquote>
  <p>
      You further agree to provide such notice and obtain such consent with
      regard to any third party personal information you supply to us in the
      future. We are not responsible for any consequences resulting from your
      failure to provide notice or receive consent from such individuals or
      for your providing outdated, incomplete or inaccurate information.{' '}
  </p>
  <p>
      <strong>9. MODIFICATIONS TO AGREEMENT</strong> Except as otherwise
      provided in this Agreement, you agree, during the term of this
      Agreement, that we may:{' '}
  </p>
  <blockquote>
      <p>
          9.1 revise the terms and conditions of this Agreement at any time;
          and/or{' '}
      </p>
      <p>
          9.2 change the services provided under this Agreement at any time.
      </p>
  </blockquote>
  <p>
      Any such revision or change will be binding and effective ten (10)
      calendar days after the revised Agreement or change to the service(s) is
      posted on <Metadata name="title" mdxType="Metadata" />
      &#39;s Web site, or upon notification to you in accordance with Section
      25 below. You agree to periodically review our Web site, including the
      current version of this Agreement available on our Web site, to be aware
      of any such revisions. If you do not agree with any revision to the
      Agreement or change to the services, you may terminate this Agreement at
      any time by providing us with notice in accordance with Section 25
      below. Notice of your termination will be effective on receipt and
      processing by us. Any fees paid by you prior to termination of your
      Agreement with us are nonrefundable, and you will not incur any
      additional fees. By continuing to use <Metadata name="title" mdxType="Metadata" />
      &#39;s services ten (10) calendar days after any revision to this
      Agreement or change in service(s) is posted on our Web site, you agree
      to abide by and be bound by any such revisions or changes. We are not
      bound by and you may not rely on any representation concerning this
      Agreement or our services made by:{' '}
  </p>
  <blockquote>
      <p>
          9.1.a any agent, representative or employee of any third party that
          you may use to apply for our services; and/or
      </p>
      <p>
          9.2.a information posted on our Web site of a general informational
          nature. No employee, contractor, agent or representative of{' '}
          <Metadata name="title" mdxType="Metadata" /> is authorized to alter or amend the terms
          and conditions of this Agreement.{' '}
      </p>
  </blockquote>
  <p>
      <strong>10. MODIFICATIONS TO YOUR ACCOUNT</strong> In order to change
      any of your account information with us, you must use the account information
      and the password or passphrase that was provided to you by{' '}
      <Metadata name="title" mdxType="Metadata" />. Please safeguard your account number and
      password or any security authentication option from any unauthorized
      use. In no event will we be liable for the unauthorized use or misuse of
      your account number and password or passphrase.{' '}
  </p>
  <p>
      <strong>11. AGENTS</strong> You agree that, if your agent purchased our
      service(s) on your behalf, you are nonetheless bound as a principal by
      all terms and conditions herein, including, if applicable, the ICANN UDRP, ICANN URS and
      the Dispute Policy, whether your agent was authorized by you or not. You
      certify that your agent is authorized to apply for our services on your
      behalf, that he or she is authorized to bind you to the terms and
      conditions of this Agreement and that he or she has apprised you of the
      terms and conditions of this Agreement. In addition, you are responsible
      for any errors made by your agent. We will not refund any fees paid by
      you or your agent on your behalf for any reason based on any act or
      omission of your agent.{' '}
  </p>
  <p>
      <strong>12. NOTICES AND ANNOUNCEMENTS</strong> You authorize us to
      notify you electronically, as our Customer, of information that we deem
      is of potential interest to you. Notices and announcements may include
      commercial emails and other notices describing changes, upgrades, new
      products and services or other information pertaining to domain names,
      Internet security or to enhance your identity on the Internet and/or
      other relevant matters. If you do not wish to receive bulk email
      solicitation notices or announcements please send us an email at{' '}
      <Metadata addr="service" name="mailLink" mdxType="Metadata" />.{' '}
  </p>
  <p>
      <strong>13. LIMITATION OF LIABILITY</strong> To the maximum extent
      permitted at law, <Metadata name="title" mdxType="Metadata" />, its parent, subsidiary,
      affiliated companies, and/or companies under common control, and/or
      their respective owners, beneficial owners, directors, officers,
      shareholders, employees, contractors, agents, partners, affiliates,
      successors and assigns shall not be liable for any direct, indirect,
      incidental, special or consequential damages resulting from your use or
      inability to use any of the <Metadata name="title" mdxType="Metadata" /> services or for
      the cost of procurement of substitute services. Moreover,{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s suppliers, service providers, and/or their respective owners,
      beneficial owners, directors, officers, shareholders, employees,
      contractors, agents, partners, affiliates, successors and assigns, shall
      not be liable for any direct, indirect, incidental, special or
      consequential damages resulting from your use or inability to use any of
      the <Metadata name="title" mdxType="Metadata" /> services or for the cost of procurement of substitute
      services. We collectively expressly disclaim any and all loss or
      liability resulting from, but not limited to:{' '}
  </p>
  <blockquote>
      <p>13.1 any failure or inability to register the domain name;</p>
      <p>
          13.2 any third party claims arising from or based on your domain name
          or use of our services;
      </p>
      <p>13.3 access delays or access interruptions;</p>
      <p>13.4 data non-delivery or data mis-delivery;</p>
      <p>13.5 acts of God;</p>
      <p>
          13.6 the unauthorized use or misuse of your account number or password
          or passphrase;
      </p>
      <p>
          13.7 errors, omissions, or misstatements in any and all information or
          service(s) provided under this Agreement;
      </p>
      <p>13.8 the deletion of or failure to store email messages;</p>
      <p>13.9 the development or interruption of your Web site;</p>
      <p>
          13.10 our processing of your application for our services, our
          processing of any authorized modification to your domain name record
          or your agents failure to pay any fees, including the initial
          registration fee or re-registration fee; or
      </p>
      <p>
          13.11 the application of the ICANN UDRP, ICANN URS or the Dispute
          Policy.{' '}
      </p>
  </blockquote>
  <p>
      You agree that our entire liability, and your exclusive remedy, with
      respect to any <Metadata name="title" mdxType="Metadata" /> service(s) provided under this
      Agreement and/or for any breach of this Agreement is solely limited to
      the amount you paid for such service(s).{' '}
  </p>
  <p>
      <strong>14. INDEMNITY</strong> You agree to release, indemnify, and
      hold <Metadata name="title" mdxType="Metadata" /> and its parent, subsidiary, affiliated
      companies, and/or companies under common control, and their respective
      owners, beneficial owners, directors, officers, shareholders, employees,
      contractors, agents, partners, affiliates, successors and assigns - as
      well as <Metadata name="title" mdxType="Metadata" />
      &#39;s suppliers or service providers, or their respective owners,
      beneficial owners, directors, officers, shareholders, employees,
      contractors, agents, partners, affiliates, successors and assigns
      harmless from all liabilities, claims, damages, costs and expenses,
      including reasonable attorneys&#39; fees and expenses, relating to or
      arising from your domain name registration or use of your domain name or
      the <Metadata name="title" mdxType="Metadata" /> services provided hereunder. When we are
      threatened with suit or sued by a third party, we may seek written
      assurances from you concerning your promise to indemnify us. Your
      failure to provide those assurances may be considered by us to be a
      material breach of this Agreement. In the event we are made a party to
      any claim, suit or action by you which is unsuccessful or by a third
      party in each case relating to or arising from your domain name
      registration or use of your domain name or the <Metadata name="title" mdxType="Metadata" />{' '}
      services provided hereunder, you will reimburse us, at a reasonable
      rate, for all personnel time and expenses expended by us in response to
      such claim, suit or action including without limitation, all attorney
      fees and expenses incurred by us with respect to such response.
  </p>
  <p>
      In addition, you agree to indemnify and hold harmless the applicable
      registry operator and its owners, beneficial owners, directors,
      officers, shareholders, employees and agents from and against any and
      all claims, damages, liabilities, costs and expenses (including
      reasonable legal fees and expenses) arising out of or related to your
      domain name registration.
  </p>
  <p>
      <strong>15. BREACH</strong> You agree that your failure to abide by any
      provision of this Agreement, any <Metadata name="title" mdxType="Metadata" /> operating
      rule or policy, the ICANN UDRP (if applicable), ICANN URS (if applicable) or the Dispute Policy may be
      considered by us to be a material breach of this Agreement and that we
      may provide to you a written notice in accordance with Section 25 below,
      describing the breach, to you. If within ten (10) calendar days of the
      date of such notice, you fail to provide evidence, which is reasonably
      satisfactory to us, that you have not breached your obligations under
      the Agreement, then we may delete the registration or reservation of
      your domain name, transfer the domain name to <Metadata name="title" mdxType="Metadata" />{' '}
      and/or terminate the other <Metadata name="title" mdxType="Metadata" /> service(s) you are
      using without further notice. We will not refund any fees paid by you
      prior to the termination of your Agreement due to your breach. Any such
      breach by you shall not be deemed to be excused simply because we did
      not act earlier in response to that, or any other breach, by you.{' '}
  </p>
  <p>
      <strong>16. REPRESENTATIONS AND WARRANTIES</strong> You agree and
      warrant that:{' '}
  </p>
  <blockquote>
      <p>
          16.1 the information that you or your agent on your behalf provide to
          us during the application process to register your domain name or to
          apply for other <Metadata name="title" mdxType="Metadata" />
          &#39;s service(s) is, accurate and complete, and that any future
          changes to this information will be provided to us in a timely manner;
      </p>
      <p>
          16.2 to the best of your knowledge and belief that neither the
          registration of your domain name nor the manner in which you intend to
          use such domain name will directly or indirectly infringe the legal
          rights of any third party;
      </p>
      <p>
          16.3 you have all requisite power and authority to execute this
          Agreement and to perform your obligations hereunder;
      </p>
      <p>
          16.4 you have selected the necessary security option(s) for your
          domain name registration record; and
      </p>
      <p>
          16.5 you are of legal age of 18 years or over to enter into this
          Agreement.{' '}
      </p>
  </blockquote>
  <p>
      You agree that your use of our service(s) is solely at your own risk.
      You agree that all of our services are provided on an &#34;as is,&#34;
      and &#34;as available&#34; basis.{' '}
  </p>
  <p>
      <strong>17. DISCLAIMER</strong> WE EXPRESSLY DISCLAIM ALL CONDITIONS,
      WARRANTIES AND REPRESENTATIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
      INCLUDING BUT NOT LIMITED TO THE IMPLIED CONDITIONS AND WARRANTIES OF
      MERCHANTABLE QUALITY, FITNESS FOR A PARTICULAR PURPOSE AND
      NON-INFRINGEMENT. WE MAKE NO WARRANTY OR REPRESENTATION THAT OUR
      SERVICE(S) WILL MEET YOUR REQUIREMENTS, OR THAT THE SERVICE(S) WILL BE
      UNINTERRUPTED, TIMELY, SECURE, OR ERROR FREE; NOR DO WE MAKE ANY
      WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE
      SERVICE(S) OR AS TO THE ACCURACY OR RELIABILITY OF ANY INFORMATION
      OBTAINED THROUGH OUR SERVICE. YOU UNDERSTAND AND AGREE THAT ANY MATERIAL
      AND/OR DATA DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF OUR
      SERVICE IS DONE AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL BE
      SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF
      DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL AND/OR DATA. WE
      MAKE NO WARRANTY OR REPRESENTATION REGARDING ANY GOODS OR SERVICES
      PURCHASED OR OBTAINED THROUGH ANY OF OUR SERVICES OR ANY TRANSACTIONS
      ENTERED INTO THROUGH SUCH SERVICES. NO ADVICE OR INFORMATION, WHETHER
      ORAL OR WRITTEN, OBTAINED BY YOU FROM US SHALL CREATE ANY CONDITION OR
      WARRANTY NOT EXPRESSLY MADE HEREIN. TO THE EXTENT JURISDICTIONS DO NOT
      ALLOW THE EXCLUSION OF CERTAIN WARRANTIES, SOME OF THE ABOVE EXCLUSIONS
      MAY NOT APPLY TO YOU.{' '}
  </p>
  <p>
      <strong>18. RIGHT OF REFUSAL</strong> We, in our sole discretion,
      reserve the right to:{' '}
  </p>
  <blockquote>
    <p>
      18.1 refuse to register or renew your chosen domain name or register or
      renew you for other <Metadata name="title" mdxType="Metadata" /> service(s); and/or
    </p>
    <p>
      18.2 cancel or terminate your domain name registration, domain name
      renewal and/or any other services provided by us, at any time and for any
      reason; in such event, we will refund any applicable fee(s) you have paid,
      less applicable administration fees.
    </p>
  </blockquote>
  <p>
      You agree that we shall not be liable to you for loss or damages that
      may result from our refusal to register your domain name, the deletion
      your domain name or our refusal to register you for other{' '}
      <Metadata name="title" mdxType="Metadata" /> service(s).{' '}
  </p>
  <p>
      <strong>19. SEVERABILITY</strong> You agree that the terms of this
      Agreement are severable. If any term or provision is declared invalid or
      unenforceable, that term or provision will be construed consistent with
      applicable law as nearly as possible to reflect the original intentions
      of the parties, and the remaining terms and provisions will remain in
      full force and effect.{' '}
  </p>
  <p>
      <strong>20. ENTIRETY</strong> You agree that this Agreement, the rules
      and policies published by us, the ICANN UDRP, ICANN URS, the Dispute
      Policy and the privacy statement are the complete and exclusive
      agreement between you and us regarding our services. This Agreement, our
      rules and policies, the ICANN UDRP (if applicable), ICANN URS (if applicable), the Dispute Policy and
      the privacy statement supersede all prior agreements, representations
      and understandings, whether established by custom, practice, policy or
      precedent.{' '}
  </p>
  <p>
      <strong>21. NON-ASSIGNMENT</strong> Your rights under this Agreement
      are not assignable. Any attempt by you to assign your rights shall
      render this Agreement voidable at our option. Any attempt by your
      creditors to obtain an interest in your rights under this Agreement,
      whether by attachment, garnishment or otherwise, shall render this
      Agreement voidable at our option.{' '}
  </p>
  <p>
      <strong>22. GOVERNING LAW</strong> You agree that this Agreement and
      any disputes hereunder shall be governed in all respects by and
      construed in accordance with the laws of the Province of Ontario,
      Canada, excluding its conflict of laws rules. You and we each submit to
      exclusive subject matter jurisdiction, personal jurisdiction and venue
      of the Province of Ontario, Canada.
  </p>
  <p>
      <strong>23. WAIVER OF CLASS ACTIONS; ARBITRATION</strong>
  </p>
  <p>
      23.1 Binding Arbitration. You and <Metadata name="title" mdxType="Metadata" />{' '}
      acknowledge that any statutory or common law claims related to
      intellectual property may require forms of equitable relief that are
      best administered by courts; accordingly, you and{' '}
      <Metadata name="title" mdxType="Metadata" /> agree that, except for i) statutory or
      common law claims related to intellectual property, and ii) any claims
      that may be brought in small claims court where the amount in
      controversy is properly within the jurisdiction of such court
      (collectively, “Excluded Claims”), any controversy or claim arising
      out of or relating to this Agreement, your relationship to{' '}
      <Metadata name="title" mdxType="Metadata" /> as a Customer, or your use of any of{' '}
      <Metadata name="title" mdxType="Metadata" /> services and/or services provided by its
      parent, subsidiary, entity under common control and/or entity owned by
      the same beneficial owner, whether based in contract, tort, statute,
      fraud, misrepresentation or any other legal theory (the “Covered
      Claims”), will be resolved by binding, individual arbitration. YOUR
      AGREEMENT TO ARBITRATION MEANS THAT FOR ALL COVERED CLAIMS, YOU ARE
      GIVING UP YOUR RIGHT TO FILE A LAWSUIT IN COURT AND THE RIGHT TO A
      TRIAL BY JURY. INSTEAD, YOU WILL HAVE A HEARING BEFORE A NEUTRAL
      ARBITRATOR.
  </p>
  <p>
      23.2 WAIVER OF CLASS ACTIONS. YOU AND{' '}
      <span style={{
          textTransform: 'uppercase'
        }}>
      <Metadata name="title" mdxType="Metadata" />
      </span>{' '}
      AGREE THAT EACH PARTY MAY BRING DISPUTES RELATING TO BOTH COVERED
      CLAIMS AND EXCLUDED CLAIMS AGAINST THE OTHER PARTY ONLY IN AN
      INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY
      PURPORTED CLASS OR REPRESENTATIVE PROCEEDING, INCLUDING, WITHOUT
      LIMITATION, A FEDERAL OR CLASS ACTION LAWSUIT OR A CLASS ARBITRATION.
  </p>
  <p>
      23.3 Conduct of Arbitration; Governing Rules. Any arbitration shall be
      submitted exclusively to final and binding arbitration in accordance
      with the Arbitration Act, 1991 (Ontario). The parties agree that three
      (3) arbitrators shall preside – each of us will select an arbitrator
      and those two arbitrators will select the third.
  </p>
  <p>
      The arbitrators shall have the power to decide any motions brought by
      either of us to the arbitration, including motions requesting that a
      judgment be awarded on any claims raised in arbitration. The
      arbitrators shall be empowered to award any appropriate relief,
      including remedies at law, in equity or injunctive relief (including a
      temporary restraining order). The arbitrators may award either of us
      any remedy to which that party is entitled under applicable law, but
      such remedies shall be limited to those that would be available to a
      party in a court of law for the claims presented to and decided by the
      arbitrators. The arbitrators will issue a decision or award in
      writing, stating the essential findings of fact and conclusions of
      law. A court of competent jurisdiction shall have the authority to
      enter a judgment upon the award made pursuant to the arbitration
      proceeding.
  </p>
  <p>
      All issues are for the arbitrator to decide, except those issues
      relating to the scope, application, and enforceability of the
      arbitration provision – including whether any claims are Covered
      Claims or Excluded Claims within the meaning of this provision – are
      for the court to decide. As stated in Section 22, Ontario Canadian law
      applies to any arbitration under this section.
  </p>
  <p>
      Prior to initiating arbitration for a Covered Claim, both parties
      agree that they will provide individualized written notice of the
      potential claim to the opposing party setting forth: (1) the factual
      and legal basis for the claim; (2) contact information for the
      potential claimant and their counsel, if any; and (3) the remedies
      sought, including the amount of claimed monetary damages (the
      “Notice”). Following receipt of the Notice by the opposing party, the
      parties agree to make a good faith effort for at least 30 days to
      resolve the claim before resorting to more formal means of resolution,
      including, without limitation, arbitration or any court action. To
      provide notice of a claim to us, write to legal@internic.ca or to
      Internic.ca Inc. Attn: Legal Department, 377 Dalhousie St, Unit 300,
      Ottawa, Ontario, K1N 9N8.
  </p>
  <p>
      Unless you and <Metadata name="title" mdxType="Metadata" /> agree otherwise in writing,
      any hearings for the arbitration will take place in Ottawa. Payment of
      all filing, administration, and arbitrator fees will be governed by
      the AAA Rules, except that if the arbitrator finds at any time that a
      claim was filed frivolously, for purposes of harassment, or otherwise
      in bad faith, then the filing party will reimburse the other party for
      all costs and fees, including attorneys&#39; fees, associated with
      that claim.
  </p>
  <p>
      Judgment on the award rendered by the arbitrator may be entered in any
      federal or provincial court of competent jurisdiction located in
      Ontario, Canada. The arbitrator may award money or equitable relief in
      favor of only the individual party seeking relief and only to the
      extent necessary to provide relief warranted by that party&#39;s
      individual claim. To reduce the time and expense of the arbitration,
      the arbitrator will not provide a statement of reasons for his or her
      award unless requested to do so by both parties.
  </p>
  <p>
      23.4 For all litigation regarding Excluded Claims and any other
      controversy or claim for which arbitration is denied, the sole
      jurisdiction and venue for such litigation will be an appropriate
      court located in the Province of Ontario, Canada.
  </p>
  <p>
      23.5 All provisions of this Dispute Resolution – Arbitration and
      Waiver of Class Actions Section will survive termination of this
      Agreement, your relationship with us, and/or your account or profile.
  </p>
  <p>
      <strong>24. AGREEMENT TO BE BOUND</strong> By applying for the
      service(s) of <Metadata name="title" mdxType="Metadata" /> or an affiliated site or service on through
      our online application process or by applying for and registering a
      domain name using the service(s) provided by <Metadata name="title" mdxType="Metadata" />,
      its affiliates, entities under common control and/or entities owned by
      the same beneficial under this Agreement, you acknowledge that you have
      read and agree to be bound by all terms and conditions of this
      Agreement, the ICANN UDRP (if applicable), ICANN URS (if applicable), the Dispute Policy and any
      pertinent rules or policies that are or may be published by{' '}
      <Metadata name="title" mdxType="Metadata" /> or ICANN. In addition, if you are registering
      other top level or country-code domain names (including, but not limited
      to .AU, .BIZ, .EU, .ORG, and/or other domain names) or any additional
      services, you have read and agree to the terms and conditions of those
      provisions.
  </p>
  <p>
      <strong>25. NOTICES</strong> All notices to be provided under this
      Agreement to the other shall be validly given if sent by email, personal
      or courier delivery or by ordinary mail as follows:{' '}
  </p>
  <blockquote>
      <p>
          25.1 to <Metadata name="title" mdxType="Metadata" />: via email sent to legal@internic.ca
          and in writing to sent to Internic.ca Inc. Attn: Legal Department, 377
          Dalhousie St, Unit 300, Ottawa, Ontario, K1N 9N8
      </p>
      <p>
          25.2 to Customer: via email to the e-mail address you provided us as
          the primary account contact. You agree that all notices, disclosures,
          and other communications we provide you electronically satisfy any
          legal requirement that such communications be in writing. You agree
          that you can store such electronic communications such that they
          remain accessible to you in an unchanged form.{' '}
      </p>
  </blockquote>
  <p>
      Confirmation of annual billing for domains will be received by email to
      the primary account contact. Prior to the time of cancellation due to user
      request, failed payment, or for any other reason a domain is cancelled,
      the owned customer will receive two notification emails (a month and a
      week prior to expiry date) to their primary email address. The customer
      will also receive another notification email after one week of the
      expiry date.
  </p>
  <p>
      <strong>26. TIME CALCULATIONS</strong> <Metadata name="title" mdxType="Metadata" />{' '}
      operates in accordance with Coordinated Universal Time (UTC). Any and all
      references to timing in this Agreement, and all schedules and appendices
      hereto, are to be interpreted in accordance with UTC.
  </p>
  <p>
      <strong>27. INCORPORATION BY REFERENCE</strong> EACH REGISTRY FOR
      DOMAIN NAMES AND CERTAIN OTHER SERVICE PROVIDERS WHO SUPPLY CERTAIN
      INTERNIC.CA SERVICES OFFERED BY INTERNIC.CA CORP. TO YOU, REQUIRE US TO
      INCORPORATE CERTAIN TERMS AND CONDITIONS INTO OUR AGREEMENT WITH YOU, AS
      SET FORTH BELOW.
  </p>
  <p>
      ALL SUCH TERMS, AND ALL OF THE OTHER SCHEDULES ATTACHED TO THESE MAIN
      TERMS AND CONDITIONS, ARE INCORPORATED BY REFERENCE INTO THIS AGREEMENT
      AND APPLY TO YOUR DOMAIN NAME(S) AND ANY APPLICABLE INTERNIC.CA
      SERVICES PURCHASED BY YOU, AND YOU AGREE TO BE BOUND BY THEM.
  </p>
  <p>
      <strong>28. TAXES</strong> All domain name registrations, email, hosting or any other services offered by <Metadata name="title" mdxType="Metadata" /> are subject to the Goods and Services Taxes unless you meet the following requirements:
  </p>
  <blockquote>
      <p>
          28.1 You certify that you are neither a Canadian resident nor reside in Canada or its territories; and
      </p>
      <p>
          28.2 You warrant that your billing address is located outside Canada
      </p>
  </blockquote>
  <p>
      <strong>29. SURVIVAL</strong> In the event this Agreement terminates as
      provided herein, Sections 1, 3, 4, 11, 13, 14, 17, 20, 21, 22, 23, 24,
      25, 27, 28 and 29 of this Agreement, and all releases, indemnities,
      waivers and disclaimers set forth in any Schedule annexed hereto, shall
      survive such expiration or termination.
  </p>
  <p>
      <strong>30. CANCELLED DOMAINS</strong> Domains can be cancelled
      following the user&#39;s cancellation request, or by us due to payment
      failure, a violation of our Terms of Use or a delinquent account.
  </p>
  <blockquote>
      <p>
          30.1 A recovery fee of USD$5.00 will be charged to recover domains in
          cancelled status (available for 30 days after a domain has been
          cancelled).{' '}
      </p>
      <p>
          30.2 To recover domains in a &#34;Redemption Grace Period&#34; status,
          there is an additional recovery fee of USD$50.00 for each .CA domain,
          and USD$100.00 for any other domains in other TLDs.{' '}
      </p>
  </blockquote>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulea">
      <a href="#schedulea" name="schedulea">
          Schedule A
      </a>
      : Terms and Conditions Relating to Domain Name Registration
  </h2>
  <p>
      <strong>1. NO GUARANTY</strong> You agree that, the registration of
      your chosen domain name does not confer immunity from objection to
      either the registration or use of your domain name.
  </p>
  <p>
      <strong>2 SECURITY</strong> <Metadata name="title" mdxType="Metadata" /> does not
      guarantee the security of your domain name registration records, and you
      assume all risks that the password and/or passphrase you select may be
      compromised as a result of fraudulent, unauthorized or illegal use.
  </p>
  <p>
      <strong>3. TRANSFERS</strong> You agree that you may not transfer your
      domain name registration to another domain name registrar during the
      first sixty (60) days from the effective date of your initial domain
      name registration with us (except for .au and .name domain names).{' '}
  </p>
  <p>
      <strong>4. LICENSING OF DOMAIN NAME</strong> You hereby acknowledge and
      agree that if you license use of your domain name to a third party you
      nonetheless remain the registrant of record and are responsible for
      providing your own full contact information and for providing and
      updating accurate technical and administrative contact information
      adequate to facilitate timely resolution of any problems that arise in
      connection with the domain name. If you are licensing use of a domain
      name you hereby accept liability for harm caused by wrongful use of the
      domain name, unless you disclose the identity of the licensee within
      seven (7) days to the party providing reasonable evidence of actionable
      harm.{' '}
  </p>
  <p>
      <strong>5. PROVISION OF REGISTRATION DATA</strong> As part of the
      registration process, you are required to provide us with certain
      information and to update this information and correct and update them
      within seven (7) days of any change during the term of the registration.
      This information includes: the full name, postal address, e-mail
      address, voice telephone number, and fax number if available of the
      Registered Name Holder; name of authorized person for contact purposes
      in the case of an Registered Name Holder that is an organization,
      association, or corporation; the names of the primary nameserver and
      secondary nameserver(s) of the registered name; The name, postal
      address, e-mail address, voice telephone number, and (where available)
      fax number of the technical contact for the registered name; and the
      name, postal address, e-mail address, voice telephone number, and (where
      available) fax number of the administrative contact for the registered
      name.{' '}
  </p>
  <p>
      Willful provision of inaccurate or unreliable information, its willful
      failure promptly to update information provided within seven (7) days of
      any change, or its failure to respond for over fifteen (15) calendar
      days to inquiries concerning the accuracy of contact details associated
      with the registration shall constitute a material breach and be a basis
      for suspension and/or cancellation of the registration.{' '}
  </p>
  <p>
      <strong>6. USE OF INFORMATION</strong>
  </p>
  <blockquote>
      <p>
          6.1 In accordance with our privacy statement, which can be found at{' '}
          <Metadata name="link" path="/privacy-policy" mdxType="Metadata" />, and in order for us
          to comply with the current rules and policies of the domain name
          system, you hereby grant <Metadata name="title" mdxType="Metadata" /> the right to disclose to the public the following mandatory information that you
          are required to provide when registering or reserving a domain name:{' '}
      </p>
      <blockquote>
          <p>6.1.1 the domain name(s) registered by you;</p>
          <p>6.1.2 your name and postal address; </p>
          <p>
          6.1.3 the name(s), postal address(es), email address(es), voice
          telephone number(s) and where available the fax number(s) of the
          technical and administrative contacts for your domain name(s);
          </p>
          <p>
          6.1.4 the Internet protocol numbers of the primary nameserver and
          secondary nameserver(s) for such domain name(s);
          </p>
          <p>6.1.5 the corresponding names of those nameserver(s);</p>
          <p>6.1.6 the original creation date of the registration; and</p>
          <p>6.1.7 the domain&#39;s expiry date</p>
      </blockquote>
      <p>
          6.2 In addition, we are required to make this information available in
          bulk form to third parties who agree not to use it to (a) allow,
          enable or otherwise support the transmission of mass unsolicited,
          commercial advertising or solicitations via email (spam) or (b) enable
          high volume, automated, electronic processes that apply to our systems
          to register domain names.{' '}
      </p>
  </blockquote>
  <p>
      <strong>7. DOMAIN NAME DISPUTE POLICY</strong> If you reserved or
      registered a domain name through us, you agree to be bound by
      ICANN&#39;s Uniform Domain-Name Dispute-Resolution Policy (the
      &#34;ICANN UDRP&#34; and others if and as applicable), ICANN&#39;s Uniform
      Rapid Suspension Policy (the “ICANN URS”) and others if and as applicable) that
      are incorporated herein and made a part of this Agreement by reference.
      The current version of the ICANN UDRP may be found at ICANN&#39;s Web
      site:{' '}
      <a href="http://www.icann.org/udrp/udrp.htm" rel="noreferrer" target="_blank">
          http://www.icann.org/udrp/udrp.htm
      </a>
      . The current version of the ICANN URS may be found at ICANN&#39;s Web
      site:{' '}
      <a href="https://www.icann.org/urs-en" rel="noreferrer" target="_blank">
          https://www.icann.org/urs-en
      </a>
      . Please take the time to familiarize yourself with those policies.{' '}
  </p>
  <p>
      <strong>8. DOMAIN NAME DISPUTES</strong> You agree that, if your use of
      our domain name registration services is challenged by a third party,
      you will be subject to the provisions specified in the{' '}
      <Metadata name="title" mdxType="Metadata" /> dispute policy (the &#34;Dispute Policy&#34;)
      in effect at the time of the dispute.{' '}
  </p>{' '}
  <p>The Dispute Policy is currently as follows:</p>
  <p>
      Notwithstanding anything in this Agreement to the contrary, you agree
      that in the event a domain name dispute arises with any third party, (i)
      you will submit, without prejudice to other potentially applicable
      jurisdictions, to the jurisdiction of the courts of your domicile and
      the Province of Ontario, Canada and (ii) you will indemnify and hold us
      harmless pursuant to the terms and conditions set forth below in this
      Agreement. If we are notified that a complaint has been filed with a
      judicial or administrative body regarding your domain name registration
      or your use of our domain name registration services, you will not be
      permitted to make any changes to your domain name record without our
      prior approval. We will not allow you to make changes to such domain
      name record until:
  </p>{' '}
  <blockquote>
      <p>
          8.1 we are directed to do so by the judicial or administrative body,
          or
      </p>
      <p>
          8.2 we receive written notification by you and the other party
          contesting your registration or use of our domain name registration
          services that the dispute has been settled.{' '}
      </p>
  </blockquote>
  <p>
      Furthermore, you agree that if we and/or you are subject to litigation
      regarding your registration or use of our domain name registration
      services, we may deposit control of your domain name record into the
      registry of the judicial or administrative body by supplying a party
      with a registrar certificate from us.{' '}
  </p>
  <p>
      <strong>9. DOMAIN NAME DISPUTE POLICY MODIFICATIONS</strong> You agree
      that we, in our sole discretion, may modify our Dispute Policy. We will
      post any such revised policy on our Web site at least thirty (30)
      calendar days before it becomes effective. You agree to periodically
      review our Web Site to be aware of such revisions. You agree that, by
      maintaining the reservation or registration of your domain name after
      modifications to the Dispute Policy become effective, you have agreed to
      these modifications. You acknowledge that if you do not agree to any
      such modification, you may terminate this Agreement by providing written
      notice to us in accordance with Section 25 under the Main Terms and
      Conditions. We will not refund any fees paid by you if you terminate
      your Agreement with us.{' '}
  </p>
  <p>
      <strong>10. CANCELLED DOMAINS</strong> You agree that we may, but are
      not obligated to, bill you annually for a domain that you have
      registered until you cancel the domain. You agree to cancel a domain
      when you no longer wish to have that domain registered. You agree that
      no refunds will be issued for domains cancelled prior to their annual
      billing date. A domain will be cancelled immediately following your
      cancellation request. Should you cancel your domain name, you agree that
      you have 30 days to recover your cancelled domain, after which time we
      will, in our sole discretion, delete the domain registration, renew the
      registration or transfer the domain name to a third party on your behalf
      (the &#34;Transfer&#34;). A domain name can be deleted in our sole
      discretion at any time if it violates our Terms or Use or after it is
      cancelled by the user. When possible we will offer a 30 day user
      recovery period. An additional 30 day Recovery Grace Period (RGP) may be
      available for some domains. In To recovery a domain in RGP period, you
      agree to contact customer service and to pay the RGP Recovery Fee in
      addition to the annual domain fee. In the event we are able to identify
      a third party (&#34;Third Party&#34;) and Transfer a cancelled domain,
      we will notify you via email after the transaction is completed
      (&#34;Transfer Notification&#34;). You acknowledge and agree that the
      Transfer may be facilitated through a single Third Party, or through an
      auction involving one or more parties interested in your domain name.
      You agree that we shall have no obligation to pay you, and you shall
      have no right to receive, any percentage of the proceeds of the
      Transfer. We cannot guarantee, and we make no representation or promise,
      that any Transfer will occur with respect to your domain name.
  </p>
  <p>
      <strong>
          11. NEW CUSTOMERS THROUGH AN AFTERMARKET SERVICE PROVIDER:
      </strong>{' '}
      If you are registering a domain name through an aftermarket service
      provider and that domain was registered with, and not yet deleted by,{' '}
      <Metadata name="title" mdxType="Metadata" /> at the time of your purchase, you acknowledge
      and agree that the term of your registration will be for a period of one
      year from the original expiration date for the domain name immediately
      prior to your purchase, as the registration is the result of a Transfer
      (as defined in section 9). If you are registering a domain name through
      an aftermarket service provider and the domain name was not registered
      with <Metadata name="title" mdxType="Metadata" /> at the time of your purchase but was
      deleted by the applicable top-level domain registry at the time of your
      purchase, you acknowledge and agree that the term of your registration
      will be for a period of one year from the date it is initially
      registered with <Metadata name="title" mdxType="Metadata" /> by the provider of the
      backorder service.
  </p>
  <p>
      <strong>12. PARKED AND COMING SOON PAGES FOR ACTIVE DOMAINS</strong>{' '}
      You acknowledge and agree that any and all domain names that are (i)
      registered with <Metadata name="title" mdxType="Metadata" />, (ii) hosted by a third party
      through <Metadata name="title" mdxType="Metadata" /> as part of a Subscription Service, and
      (iii) do not otherwise resolve to an active website, may resolve to a
      &#34;coming soon&#34; or similar temporary web page (&#34;Coming Soon
      Page&#34;), and that <Metadata name="title" mdxType="Metadata" /> may place on any such
      Coming Soon Page promotions, advertisements and other information for,
      and links to, <Metadata name="title" mdxType="Metadata" />
      &#39;s website, <Metadata name="title" mdxType="Metadata" />
      &#39;s product and service offerings, third party websites, third party
      product and service offerings and/or Internet search engines. You agree
      that <Metadata name="title" mdxType="Metadata" /> may change the content and/or appearance
      of, or disable, any Coming Soon Page at any time, in its sole
      discretion, and without prior notice. You agree that any and all revenue
      generated from such a Coming Soon Page enures to the benefit of{' '}
      <Metadata name="title" mdxType="Metadata" />. You may discontinue use of the Coming Soon
      Page for your registered domain at any time by logging into your account
      and making such changes.
  </p>
  <p>
      <strong>13. PARKED AND RESTORATION PAGES FOR DELETED DOMAINS</strong>{' '}
      You agree that after you have cancelled a domain we may direct your
      domain name to an IP address designated by us, including, without
      limitation, an IP address which hosts a Restore domain landing page, or
      a temporary page (&#34;Coming Soon Page&#34;) that may include
      promotions, advertisements and other information for, and links to,{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s website, <Metadata name="title" mdxType="Metadata" />
      &#39;s product and service offerings, third party websites, third party
      product and service offerings and/or Internet search engines, and you
      agree that we may place our contact information in the WHOIS or RDAP output for
      the cancelled domain. You agree that <Metadata name="title" mdxType="Metadata" /> may
      change the content and/or appearance of, or disable, any Domain
      Restoration or Coming Soon Page at any time, in its sole discretion, and
      without prior notice. You agree that any and all revenue generated from
      a temporary page belongs to <Metadata name="title" mdxType="Metadata" /> or such third
      party as designated by <Metadata name="title" mdxType="Metadata" />.
  </p>
  <p>
      In the case of a canceled or deleted CA domain we will not modify the
      domain&#39;s contact information and your domain&#39;s nameservers will
      not be changed.{' '}
  </p>
  <p>
      <strong>14. REVOCATION</strong> You agree that we may cancel or delete
      your domain name if the information that you provide to us or
      subsequently modify contains false or misleading information, or
      conceals or omits any information we would likely consider material to
      our decision to register your domain name or to continue to provide you
      domain name registration services. You agree that we may terminate
      immediately and without notice our service(s), including our domain name
      registration services, in the event that you use such service(s) for any
      improper purpose, as determined in our sole discretion. Furthermore, you
      agree that we may suspend, delete, cancel or transfer your domain name
      in order to:
  </p>
  <blockquote>
      <p>
          14.1 comply with any Specification or Policy, or any{' '}
          <Metadata name="title" mdxType="Metadata" /> or registry operator procedure not
          inconsistent with any Specification or Policy; or
      </p>
      <p>
          14.2 correct mistakes made by us or the registry in registering your
          chosen domain name; or{' '}
      </p>
      <p>
          14.3 resolve a dispute under the ICANN UDRP or the Dispute Policy. We
          will not refund any fees paid by you prior to termination of our
          services.{' '}
      </p>
  </blockquote>
  <p>
      <strong>15. SURVIVAL</strong> In the event this Agreement or Schedule
      terminates, Sections 3, 4, 5, 6, 7, 8, 9, 10 and 14 of this Schedule
      shall survive such expiration or termination.
  </p>
  <h2 id="scheduleb">
  <a href="#scheduleb" name="scheduleb">
      Schedule B
  </a>
  : Terms and Conditions applicable to <Metadata name="title" mdxType="Metadata" /> Corp.
  Email Services
  </h2>
  <p>
      The following terms and conditions of use and any amendments thereto
      (the &#34;Email Terms&#34;) apply to your access to, and use of, the
      email and related services offered by <Metadata name="title" mdxType="Metadata" /> (the
      &#34;Email Service&#34;). These Email Terms may be changed in the future
      without further notice, and your continued use of the Email Service
      following any such changes constitutes your acceptance of the new terms.
      These Email Terms do not alter in any way the non-conflicting terms or
      conditions of this Agreement or any other agreement you may have with{' '}
      <Metadata name="title" mdxType="Metadata" /> for products, services or otherwise. To the
      extent any of the Email Terms are in conflict or inconsistent with any
      other term or condition of the Agreement, these Email Terms shall govern
      to the extent of the conflict or inconsistency.
  </p>
  <p>
      <strong>1. Privacy Policy</strong>
  </p>
  <p>
      In addition to the terms of the <Metadata name="title" mdxType="Metadata" /> privacy
      statement, you agree that <Metadata name="title" mdxType="Metadata" /> may access and
      disclose information about you or your use of the Email Service when{' '}
      <Metadata name="title" mdxType="Metadata" /> deems necessary or appropriate to comply with
      the law or legal process, to protect <Metadata name="title" mdxType="Metadata" />
      &#39;s systems and customers, or to ensure the integrity and operation
      of <Metadata name="title" mdxType="Metadata" />
      &#39;s business and systems. Such disclosure may include, without
      limitation, user profile information (e.g., name, email address, etc.),
      IP address and traffic information, usage history, and posted content.{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s right to disclose any such information shall govern over any
      terms of <Metadata name="title" mdxType="Metadata" />
      &#39;s privacy statement.
  </p>
  <p>
      <strong>2. Access Restriction &amp; Password Security</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> reserves the right to deny in its sole
      discretion any user access to the Email Service or any portion thereof
      without notice. You are responsible for safeguarding the confidentiality
      of your password(s) and user name(s) issued to you by{' '}
      <Metadata name="title" mdxType="Metadata" />, and for any use or misuse of your account or
      the Email Service resulting from any third party using a password or
      user name issued to you.
  </p>
  <p>
      <strong>3. No &#34;Spamming&#34;</strong>
  </p>
  <p>
      You shall not use the Email Service for chain letters, junk mail,
      &#34;spamming&#34; or any use of distribution lists to any person who
      has not given specific permission to be included in such a process. An
      email advertisement which is (a) addressed to a recipient with whom the
      initiator does not have an existing business or personal relationship
      and (b) is not sent at the request of or with the express consent of the
      recipient to receive such communications from you (&#34;spam&#34; or
      &#34;spamming&#34;) is strictly prohibited by <Metadata name="title" mdxType="Metadata" />.
      If any user uses the Email Service for spamming,{' '}
      <Metadata name="title" mdxType="Metadata" /> reserves the right to immediately terminate
      that user&#39;s access to the Email Service and to seek appropriate
      legal recourse as necessary. If any user believes that others are using
      the Email Service for spam, please contact <Metadata name="title" mdxType="Metadata" /> at{' '}
      <Metadata addr="service" name="mailLink" mdxType="Metadata" />.
  </p>
  <p>
      <strong>4. User Conduct</strong>
  </p>
  <blockquote>
      <p>
          4.1 <Metadata name="title" mdxType="Metadata" /> reserves the right, but does not assume
          the responsibility, to monitor or review user conduct on the Email
          Service. Use of the Email Service is subject to all applicable local,
          state, provincial, federal and international laws and regulations. You
          agree: (1) to comply with applicable law regarding the transmission of
          technical data exported from the United States or Canada through the
          Email Service; (2) not to use the Email Service for illegal purposes;
          and (3) not to interfere or disrupt networks connected to the Email
          Service.
      </p>
      <p>4.2 In using the service, you agree not to:</p>
      <blockquote>
          <p>
              4.2.1. Harvest or otherwise collect information about others,
              including without limitation names and email addresses, without
              their consent;
          </p>
          <p>
              4.2.2. Transmit through the Email Service any unlawful, harassing,
              defamatory, abusive, threatening, harmful, vulgar, obscene, sexually
              explicit, or otherwise objectionable material of any kind or nature;
          </p>
          <p>
              4.2.3. Invade another&#39;s privacy or violate rights of publicity
              or intellectual property rights (including but not limited to
              copyright, trademark and patent rights) while using the Email
              Service;
          </p>
          <p>
              4.3.3. Transmit any material that encourages conduct that could
              constitute a criminal offense, give rise to civil liability or
              otherwise violate any applicable local, state, provincial, federal
              or international law or regulation;
          </p>
          <p>
              4.3.4. Interfere with another User&#39;s use and enjoyment of the
              Email Service or another entity&#39;s use and enjoyment of similar
              services;
          </p>
          <p>
              4.3.5. Advertise or offer to sell or buy any goods or services for
              any non-personal purpose;
          </p>
          <p>
              4.3.6. Transmit or upload any material that contains viruses, trojan
              horses, worms, time bombs, cancelbots, or any other harmful or
              deleterious programs;
          </p>
          <p>
              4.3.7. Interfere with or disrupt networks connected to the Email
              Service or violate the regulations, policies or procedures of such
              networks;
          </p>
          <p>
              4.3.8. Attempt to gain unauthorized access to the Email Service,
              other accounts, computer systems or networks connected to the Email
              Service, through password mining or any other means;
          </p>
          <p>
              4.3.9. Use or attempt to use another&#39;s account, service or
              system without authorization from <Metadata name="title" mdxType="Metadata" />, or
              create or use a false identity on this Email Service; or
          </p>
          <p>
              4.3.10. Engage in any other conduct which, in{' '}
              <Metadata name="title" mdxType="Metadata" />
              &#39;s sole discretion, is considered unauthorized or objectionable.
          </p>
      </blockquote>
  </blockquote>
  <p>
      <strong>5. Proprietary Rights</strong>
  </p>
  <blockquote>
      <p>
          5.1 You acknowledge and agree that any material, including but not
          limited to text, compilations, graphics, software, music, sound,
          photographs, video, or other material contained or distributed on or
          through the Email Service, by <Metadata name="title" mdxType="Metadata" />, its
          advertisers or other third parties (&#34;Content&#34;), is protected
          by copyrights, trademarks, service marks, patents or other proprietary
          rights and laws. You may not use or distribute any Content received
          through the Email Service without the authorization of the content
          owner, except for your personal, non-exclusive use. You agree not to
          modify, copy, reproduce, republish, upload, post, transmit, sell or
          distribute Content available through the Email Service, including code
          and software, in violation of applicable copyright and other
          intellectual property laws.
      </p>
      <p>
          5.2 WITHOUT LIMITING THE FOREGOING, COPYING OR REPRODUCTION OF THE{' '}
          <span style={{
            textTransform: 'uppercase'
          }}><Metadata name="title" mdxType="Metadata" /></span>{' '}
          SOFTWARE TO ANY OTHER SERVER OR LOCATION FOR
          FURTHER REPRODUCTION OR REDISTRIBUTION IS EXPRESSLY PROHIBITED. YOU
          MAY NOT DECOMPILE, DISASSEMBLE, REVERSE ENGINEER OR OTHERWISE ATTEMPT
          TO DISCOVER ANY TRADE SECRET CONTAINED IN ANY SOFTWARE PROVIDED
          HEREUNDER.
      </p>
      <p>
          5.3 You acknowledge that the Software, and any accompanying
          documentation and/or technical information, is subject to applicable
          export control laws and regulations of the United States and Canada.
          You agree not to export or re-export the Software, directly or
          indirectly, to any countries that are subject to U.S. or Canadian
          export restrictions.
      </p>
  </blockquote>
  <p>
      <strong>6. Trademarks</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> and the <Metadata name="title" mdxType="Metadata" /> logo are
      trademarks of <Metadata name="title" mdxType="Metadata" />, and may not be copied, imitated
      or used, in whole or in part, without the prior written permission of{' '}
      <Metadata name="title" mdxType="Metadata" />. In addition, all page headers, custom
      graphics, button icons, and scripts are service marks, trademarks,
      and/or trade dress of <Metadata name="title" mdxType="Metadata" /> or its contractors or
      suppliers, and may not be copied, imitated, or used, in whole or in
      part, without the prior written permission of <Metadata name="title" mdxType="Metadata" />.
      All other trademarks, registered trademarks, product names and company
      names or logos mentioned herein are the property of their respective
      owners.
  </p>
  <p>
      <strong>7. Submissions</strong>
  </p>
  <p>
      You agree that any materials, including but not limited to questions,
      comments, suggestions, ideas, plans, notes, drawings, original or
      creative materials or other information, provided by you in the form of
      email or submissions to <Metadata name="title" mdxType="Metadata" />, or postings on this
      Email Service, are non-confidential and shall become the sole property
      of <Metadata name="title" mdxType="Metadata" />. <Metadata name="title" mdxType="Metadata" /> shall own
      exclusive rights, including all intellectual property rights, and shall
      be entitled to the unrestricted use of these materials for any purpose,
      commercial or otherwise, without acknowledgment or compensation to you.
      The submission of any materials to <Metadata name="title" mdxType="Metadata" />, including
      the posting of materials to any forum or interactive area, irrevocably
      waives any and all &#34;moral rights&#34; in such materials, including
      the rights of paternity and integrity.
  </p>
  <p>
      <strong>8. Linking</strong>
  </p>
  <blockquote>
      <p>
          8.1 You may not use, frame or utilize framing techniques to enclose
          any <Metadata name="title" mdxType="Metadata" /> trademark, logo or other proprietary
          information, including the images found at this Email Service, the
          content of any text, or the layout/design of any page or form
          contained on a page, without <Metadata name="title" mdxType="Metadata" />
          &#39;s express written consent. Further, you may not use any meta tags
          or any other &#34;hidden text&#34; utilizing any{' '}
          <Metadata name="title" mdxType="Metadata" /> name, trademark, or product name without{' '}
          <Metadata name="title" mdxType="Metadata" />
          &#39;s express written consent. Except as noted above, you are not
          conveyed any right or license by implication, estoppel, or otherwise
          in or under any patent, trademark, copyright, or proprietary right of{' '}
          <Metadata name="title" mdxType="Metadata" /> or any third party.
      </p>
      <p>
          8.2 <Metadata name="title" mdxType="Metadata" /> makes no claim or representation
          regarding, and accepts no responsibility for, the quality, content,
          nature or reliability of Web sites accessible by hyperlink from this
          Email Service, or Web sites linking to this Email Service. The linked
          sites are not under the control of <Metadata name="title" mdxType="Metadata" />, and{' '}
          <Metadata name="title" mdxType="Metadata" /> is not responsible for the contents of any
          linked site or any link contained in a linked site, or any review,
          changes or updates to such sites. <Metadata name="title" mdxType="Metadata" /> is
          providing these links to you only as a convenience, and the inclusion
          of any link does not imply affiliation, endorsement, or adoption by or
          between <Metadata name="title" mdxType="Metadata" /> and any third party.
      </p>
  </blockquote>
  <p>
      <strong>9. Third Party Content &amp; Email Services</strong>
  </p>
  <blockquote>
      <p>
          9.1 <Metadata name="title" mdxType="Metadata" /> may provide links to Web pages and
          content of third parties (&#34;Third Party Content&#34;) as a service
          to those interested in this information. <Metadata name="title" mdxType="Metadata" />{' '}
          does not monitor, and has no control over, any Third Party Content or
          third party Web sites. <Metadata name="title" mdxType="Metadata" /> does not endorse or
          adopt any Third Party Content and can make no guarantee as to its
          accuracy or completeness. <Metadata name="title" mdxType="Metadata" /> does not represent
          or warrant the accuracy of any information contained therein, and
          undertakes no responsibility to update or review any Third Party
          Content.
      </p>
      <p>
          9.2 When leaving the <Metadata name="title" mdxType="Metadata" /> site, you should be
          aware that <Metadata name="title" mdxType="Metadata" />
          &#39;s terms and policies no longer govern, and, therefore, you should
          review the applicable terms and policies, including privacy and data
          gathering practices, of that site. Your use of these links and Third
          Party Content contained therein is at your sole risk.
      </p>
  </blockquote>
  <p>
      <strong>10. Copyright Policy &amp; Copyright Agent</strong>
  </p>
  <blockquote>
      <p>
          10.1 <Metadata name="title" mdxType="Metadata" /> may remove content that appears to
          infringe the copyright or other intellectual property rights of
          others. In addition, <Metadata name="title" mdxType="Metadata" /> may terminate the
          accounts of users who appear to infringe the copyright or other
          intellectual property rights of others.
      </p>
      <p>
          10.2 If you believe that <Metadata name="title" mdxType="Metadata" /> or any user of our
          site has infringed your copyright in any material way, please notify{' '}
          <Metadata name="title" mdxType="Metadata" />, and provide the following information (the
          &#34;Notice&#34;):
      </p>
      <blockquote>
          <p>
          10.2.1. A physical or electronic signature of the person authorized
          to act on behalf of the owner of the copyright interest.
          </p>
          <p>
          10.2.2. An identification of the copyrighted work claimed to have
          been infringed.
          </p>
          <p>
          10.2.3. An identification of the material that you claim is
          infringing so that we may locate it on the Email Service.
          </p>
          <p>10.2.4. Your address, telephone number, and email address.</p>
          <p>
          10.2.5. A statement by you that you have a good faith belief that
          the disputed use is not authorized by the copyright owner, its
          agent, or the law.
          </p>
          <p>
          10.2.6. A statement by you that the above information in your Notice
          is accurate, made under penalty of perjury, and that you are
          authorized to act on behalf of the owner of the copyright interest
          involved.
          </p>
      </blockquote>
  </blockquote>
  <p>
      However, unless ordered by a court of a competent jurisdiction or an
      administrative body, <Metadata name="title" mdxType="Metadata" /> does not have to take any
      action against an alleged infringement.
  </p>
  <p>
      <strong>11. No Resale</strong>
  </p>
  <p>
      You agree not to resell or make any commercial use of the Email Service
      without <Metadata name="title" mdxType="Metadata" />
      &#39;s express written consent.
  </p>
  <p>
      <strong>12. Termination</strong>
  </p>
  <p>
      Notwithstanding any of these terms and conditions of use,{' '}
      <Metadata name="title" mdxType="Metadata" /> reserves the right, without notice and in its
      sole discretion, to terminate your use of this Email Service, to change
      or eliminate any of the services we provide, and to block or prevent
      future access to and use of this Email Service. If your account is
      terminated for violation of these Email Terms, you will not be entitled
      to any refunds. Should you object to these Email Terms or become
      dissatisfied with the Email Service in any way, your only recourse is to
      immediately discontinue your use of the Email Service and terminate your
      account.
  </p>
  <p>
      <strong>13. Severability</strong>
  </p>
  <p>
      If any provision of these terms and conditions shall be deemed unlawful,
      void, or for any reason unenforceable, then that provision shall be
      deemed severable from these terms and conditions and shall not affect
      the validity and enforceability of any remaining provisions. The terms of
      this section survive any termination of the Email Terms.
  </p>
  <p>
      <strong>14. Modification &amp; Amendments</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> reserves the right to amend at any time any
      policies governing this Email Service, including these Email Terms, by
      posting the amended terms and providing notice of such amendments. The
      amended terms shall be effective upon posting. If you do not accept the
      amended terms, you should cease using this Email Service.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulec">
  <a href="#schedulec" name="schedulec">
      Schedule C
  </a>
  : Terms and Conditions Applicable to all Web Site and Hosting Services
  </h2>
  <p>
      <strong>1. Definitions</strong>
  </p>
  <p>
      For purposes of this Schedule, the following capitalized terms shall
      have the meanings ascribed to them below:
  </p>
  <blockquote>
      <p>
          1.1. &#34;
          <Metadata name="title" mdxType="Metadata" /> Web Site&#34; means any pre-designed,
          customizable <Metadata name="title" mdxType="Metadata" /> Web site template
          including websites provisioned from third parties. licensed by us
          to end users. By using these services,
          end users also agree to such third-party terms and conditions, as applicable.
      </p>
      <p>
          1.2. &#34;Subscription Service&#34; means any of the{' '}
          <Metadata name="title" mdxType="Metadata" /> subscription service packages that are
          available for purchase by end users on a monthly or yearly basis, for a monthly or yearly
          fee, that combine the <Metadata name="title" mdxType="Metadata" /> Web Site
          license, the Web Site Manager Service and the Web Hosting Service, all
          as described on the <Metadata name="title" mdxType="Metadata" /> Web site located
          at the URL <Metadata name="link" mdxType="Metadata" />.{' '}
      </p>
      <p>
          1.3. &#34;Web Site Manager Service&#34; means the{' '}
          <Metadata name="title" mdxType="Metadata" /> on-line tool that allows customers to
          access their <Metadata name="title" mdxType="Metadata" /> Web Site, add/modify
          content, upload images and make generic changes to their{' '}
          <Metadata name="title" mdxType="Metadata" /> Web Site.{' '}
      </p>
      <p>
          1.4. &#34;Web Hosting Service&#34; means the Web hosting services
          provided by a third party through <Metadata name="title" mdxType="Metadata" /> as part of a Subscription Service.
      </p>
  </blockquote>
  <p>
      <strong>2. Payment </strong>
  </p>
  <p>
      In addition to the payment terms under Section 4 under the Main Terms and
      Conditions of the Agreement, the following provisions shall also apply
      solely with respect to the Subscription Service:{' '}
  </p>
  <blockquote>
      <p>
          2.1. <Metadata name="title" mdxType="Metadata" /> in its sole discretion, shall determine
          the prices it will charge for the Subscription Service, and the terms
          and conditions applicable to the same, and <Metadata name="title" mdxType="Metadata" />{' '}
          may, upon providing thirty (30) days&#39; notice to you, amend
          such pricing and/or terms and conditions. If you do not agree to the
          change(s), you may terminate your Subscription Service as provided in
          Section 5 of this Schedule within that thirty (30) days; otherwise all
          such changes shall thereafter be effective with respect to your
          account, and you agree that we are authorized to charge your credit
          card for the new monthly Subscription Service fee.{' '}
      </p>
      <p>
          2.2 Billing for the Subscription Service will be by valid credit card
          (acceptable to <Metadata name="title" mdxType="Metadata" />) at the time of
          purchase. If you elect to subscribe to a service that requires a
          monthly payment, your monthly payments for the same will be
          automatically charged to the credit card provided by you (and
          acceptable to <Metadata name="title" mdxType="Metadata" />) at the time of your
          purchase (with such payments being charged in advance on a monthly
          basis), and you hereby agree that <Metadata name="title" mdxType="Metadata" /> is
          authorized to so charge your credit card.{' '}
      </p>
  </blockquote>
  <p>
      <strong>3. Conduct </strong>
  </p>
  <p>
      You agree to abide by the terms and conditions set forth herein and be
      bound by the applicable provisions of any applicable{' '}
      <Metadata name="title" mdxType="Metadata" /> Acceptable Use Policy and other
      applicable <Metadata name="title" mdxType="Metadata" /> policies and procedures,
      incorporated herein and made part of this Agreement by reference, in
      connection with your use of the services described in this Schedule. You
      are responsible for ensuring that your web site conforms to all local,
      state, federal and international laws. You are also responsible for
      ensuring that you have obtained authorization to use any copyright
      images, audio files, text or other web site elements that are not
      provided by <Metadata name="title" mdxType="Metadata" />. You warrant that the web site
      being hosted by <Metadata name="title" mdxType="Metadata" /> will not be used in
      connection with any illegal activity and that it will not conflict with
      the legal rights of a third party or a third party&#39;s trademarks or
      trade name.
  </p>
  <p>
      <strong>
          4. <Metadata name="title" mdxType="Metadata" />
          &#39;s Rights.
      </strong>
  </p>
  <blockquote>
      <p>
          4.1 <Metadata name="title" mdxType="Metadata" /> explicitly reserves the right and sole
          discretion to{' '}
      </p>
      <blockquote>
          <p>
              4.1.1 suspend any web site (including indefinite suspension) without
              notice for non-payment of fees due hereunder;{' '}
          </p>
          <p>
              4.1.2 censor any web site hosted that, in <Metadata name="title" mdxType="Metadata" />{' '}
              Corp&#39;s sole discretion, is deemed inappropriate;{' '}
          </p>
          <p>
              4.1.3 review every Web Hosting account for excessive space and
              bandwidth utilization and to terminate or apply additional fees to
              those accounts that exceed allowed levels;{' '}
          </p>
          <p>4.1.4 modify its pricing through email notification; </p>
          <p>
              4.1.5 terminate your Subscription Service for unsolicited,
              commercial emailing (i.e., SPAM); illegal access to other computers
              or networks (i.e., hacking); distribution of Internet viruses or
              similar destructive activities; non-payment of Web Hosting fees; and
              other activities whether lawful or unlawful that{' '}
              <Metadata name="title" mdxType="Metadata" /> Corp. determines to be harmful to its
              other customers, operations, or reputation;{' '}
          </p>
          <p>
              4.1.6 terminate Your Subscription Service if the contents of your
              web site result in, or are the subject of, legal action or
              threatened legal action, against <Metadata name="title" mdxType="Metadata" /> Corp. or
              any of its affiliates or partners, without consideration for whether
              such legal action or threatened legal action is eventually
              determined to be with or without merit.
          </p>
      </blockquote>
      <p>
          4.2 You agree you will not be entitled to a refund of any fees paid to{' '}
          <Metadata name="title" mdxType="Metadata" /> if, for any reason,{' '}
          <Metadata name="title" mdxType="Metadata" /> takes corrective action with respect to your
          improper or illegal use of the Subscription Service.{' '}
      </p>
  </blockquote>
  <p>
      <strong>5. Cancellation</strong>{' '}
  </p>
  <p>
      You may cancel your Subscription Service at any time. To cancel your
      Subscription Service you must submit your written notice of cancellation
      to <Metadata name="title" mdxType="Metadata" /> (as provided herein) and include the
      following information: (i) Your <Metadata name="title" mdxType="Metadata" /> customer
      identification number and username; (ii) your <Metadata name="title" mdxType="Metadata" />{' '}
      Web Site Web address; and (iii) your reason for requesting cancellation.
      Unless terminated earlier as provided herein, your Subscription Service
      will be canceled as of the expiration of the monthly billing cycle in
      which your notice was received. In the absence of such written notice of
      cancellation, <Metadata name="title" mdxType="Metadata" /> will automatically renew the
      Subscription Service indefinitely and will charge the credit card you
      have on file with <Metadata name="title" mdxType="Metadata" /> , at{' '}
      <Metadata name="title" mdxType="Metadata" /> then current rates.
  </p>
  <p>
      <strong>6. Term and Termination </strong>
  </p>
  <blockquote>
      <p>
          6.1 Term: Your Subscription Service shall be on a month-to-month basis
          for successive monthly periods, unless either party notifies the other
          of termination in accordance with this Agreement.{' '}
      </p>
      <p>
          6.2 Notice of Service Cancellation by You. Any termination of your
          Subscription Service must be in accordance with our cancellation
          policy. Unless terminated earlier as provided herein, this Schedule,
          and the Agreement (if you have no other services with{' '}
          <Metadata name="title" mdxType="Metadata" /> Corp) will be terminated as of the
          expiration of the monthly billing cycle in which your cancellation
          notice was received and processed by <Metadata name="title" mdxType="Metadata" />{' '}
      </p>
  </blockquote>
  <p>
      <strong>7. Service Uptime Guarantee</strong>{' '}
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> offers a Service uptime guarantee of 99.9%
      (“Service Uptime Guarantee”) of available time per month. The uptime of
      the server is defined as the reported uptime from the operating system
      and the Apache Web Server which may differ from the uptime reported by
      other individual services. If we fail to maintain this Service Uptime
      Guarantee in a particular month (as solely determined by us), you will
      be eligible upon request to receive a credit to apply to future services
      billing cycles based upon the Unavailability for that month. The credit
      may be used only for the purchase of further products and services from
      us, and is exclusive of any applicable taxes. Third party monitoring
      service reports may not be used for justification due to a variety of
      factors including the monitor&#39;s network capacity/transit
      availability. The Service Uptime Guarantee does not apply to service
      interruptions caused by: (1) periodic scheduled maintenance or repairs
      we may undertake from time to time; (2) interruptions caused by you from
      custom scripting, coding or the installation of third-party
      applications; (3) outages that do not affect the appearance of your
      website but merely affect access to your website such as FTP and email;
      (4) causes beyond our control or that are not reasonably foreseeable;
      and (5) outages related to the reliability of certain programming
      environments.
  </p>
  <p>
      <strong>8. Hosting Migrations </strong>
  </p>
  <blockquote>
      <p>
          8.1 If your web hosting is provided by a third-party, we may, at your
          request and in our sole discretion, attempt to assist you to move the
          web hosting and the domain name to us. Hosting Migrations are provided
          as a courtesy service, and we do not make any guarantee regarding the
          availability, possibility, or time required to complete a Hosting
          Migration. Each hosting company is configured differently, and some
          hosting platforms save data in an incompatible or proprietary format,
          which may make us unable to assist you in the transfer of data from a
          third-party host.{' '}
      </p>
      <p>
          8.2 The free Hosting Migration service is available for thirty (30)
          days from your sign up date. Transfers outside of the thirty (30) day
          period will incur a charge; please contact a member of our Hosting
          Migration department to receive a price quote.{' '}
      </p>
      <p>
          8.3 You are solely responsible for reviewing the functionality and
          accuracy of migrated content in its new location following a Hosting
          Migration. We will not perform website backups or archives in
          connection with a Hosting Migration, and we recommend that you back up
          your third-party hosted website before migration to ensure that no
          data is lost. You agree not to make any changes or revisions to your
          website during the migration process.{' '}
      </p>
      <p>
          8.4 You agree that we are not liable for any delay in website
          resolution or loss of data related to your Hosting Migration.{' '}
      </p>
      <p>
          8.5 We may install a plugin on your external WordPress site for the
          purpose of facilitating your WordPress migration into our own Managed
          WordPress hosting environment. This plugin will not change anything on
          your source site. Its purpose is to facilitate the Hosting Migration
          of your WordPress files. You are welcome to disable the plugin on your
          source site after the Hosting Migration has been completed.{' '}
      </p>
  </blockquote>
  <p>
      <strong>9. Backups and Security </strong>
  </p>
  <blockquote>
      <p>
          9.1 You shall be solely responsible for undertaking measures to: (1)
          prevent any loss or damage to your website or server content; (2)
          maintain independent archival and backup copies of your website or
          server content; and (3) ensure the security, confidentiality and
          integrity of all your website or server content transmitted through or
          stored on our servers.{' '}
      </p>
      <p>
          9.2 <Metadata name="title" mdxType="Metadata" />
          &#39;s backup service runs once a day and overwrites any of our
          previous backups. Only four weeks of backups are stored in the remote
          server. This service is provided only to shared and reseller accounts
          as a courtesy and may be modified at any time at{' '}
          <Metadata name="title" mdxType="Metadata" />
          &#39;s sole discretion. <Metadata name="title" mdxType="Metadata" /> is not responsible
          for files and/or data residing on your account. You agree to take full
          responsibility for all files and data transferred and to maintain all
          appropriate backup of files and data stored on{' '}
          <Metadata name="title" mdxType="Metadata" /> &#39;s servers.{' '}
      </p>
      <p>
          9.3 Our servers are not an archive and we shall have no liability to
          you or any other person for loss, damage or destruction of any of your
          content. The Hosting Services are not intended to provide a PCI
          (Payment Card Industry) or HIPAA (Health Insurance Portability and
          Accountability Act) compliant environment and therefore should not be
          used or considered as one. You shall not use the Service in any way,
          in our sole discretion, that shall impair the functioning or operation
          of our services or equipment. Specifically by way of example and not
          as a limitation, you shall not use the Hosting Services as: (1) a
          repository or instrument for placing or storing archived files; and/or
          (2) placing or storing material that can be downloaded through other
          websites. You acknowledge and agree that we have the right to carry
          out a forensic examination in the event of a compromise to your server
          or account.{' '}
      </p>
  </blockquote>
  <p>
      <strong>10. Website/Server Content</strong>{' '}
  </p>
  <p>
      Your website may not include any of the following content: (1) image
      hosting scripts that allow an anonymous user to upload an image for
      display on another website (similar to Photobucket or Tinypic); (2)
      banner ad services for display on other websites or devices (commercial
      banner ad rotation); (3) file dump/mirror scripts that allow an
      anonymous user to upload a file for other to download (similar to
      rapidshare); (4) commercial audio streaming (more than one or two
      streams); (5) push button mail scripts that allow the user to specify
      recipient email addresses; (6) anonymous or bulk SMS gateways; (7)
      backups of content from another computer or website; (8) Bittorrent
      trackers; or (9) any script that causes a degradation in the performance
      of our server or network environment.
  </p>
  <p>
      <strong>11. Disk Space/Bandwidth/Website Plans</strong>{' '}
  </p>
  <p>
    Your use of our Service is subject to your current Plan or package. In the event your Service usage, or the content you host, exceeds your plan or package, presents a risk to the stability, performance or uptime of our servers, data storage, networking or other infrastructure, you may be required to reduce usage, upgrade your current Plan or package, or we may take action to restrict the resources your website is utilizing.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduled">
      <a href="#scheduled" name="scheduled">
          Schedule D
      </a>
  : Terms and Conditions Applicable to the High Security Service
  </h2>
  <p>
      <strong>1.</strong> <Metadata name="title" mdxType="Metadata" /> has introduced a &#34;High
      Security&#34; service to address issues of domain name security. The
      High Security service is provided to you as a courtesy and helps to
      prevent domains you have registered from being unintentionally
      transferred, deleted, or expired. Unless you inform{' '}
      <Metadata name="title" mdxType="Metadata" /> that you do not want this service, you will be
      automatically enrolled for <Metadata name="title" mdxType="Metadata" />
      &#39;s High Security service. The High Security service includes
      &#34;Registrar Lock&#34; and &#34;Auto-renewal&#34;, described below.{' '}
      <Metadata name="title" mdxType="Metadata" /> may introduce additional security features in
      the future.
  </p>
  <p>
      <strong>2. Registrar Lock</strong>
  </p>
  <p>
      When High Security is enabled for a domain name, you are preventing
      registrars, other than <Metadata name="title" mdxType="Metadata" />, to transfer or modify
      your domain name. If you choose to transfer a domain to another
      registrar, you must log into your account and remove the lock prior to
      our receipt of the transfer request from the gaining registrar. This
      service is being provided as a convenience to you but in no way
      guarantees that a domain name will not be maliciously transferred to
      another registrar or registrant, due to technical and policy weaknesses
      in the worldwide domain name system or by <Metadata name="title" mdxType="Metadata" />
      &#39;s error. <Metadata name="title" mdxType="Metadata" /> will, however, use commercially
      reasonable efforts in stopping any such transfer without your express
      consent. Please note that not all registries support the concept of a
      Registrar Lock in which case, High Security will not include a Registrar
      Lock.
  </p>
  <p>
      <strong>3. Auto-renewal</strong>
  </p>
  <blockquote>
      <p>
          3.1 When High Security is enabled for a domain,{' '}
          <Metadata name="title" mdxType="Metadata" /> will attempt to renew the registration of a
          domain approximately 75 days prior to its expiry date. The renewal is
          for a one-year term and extends the existing registration period. For
          example, if the expiry date for your domain name is September 1, 2003,
          the new expiry date will be September 1, 2004. When High Security is
          enabled, you have authorized and consented to{' '}
          <Metadata name="title" mdxType="Metadata" /> to automatically charge your credit card the
          then-current retail price for such one-year renewal. The automatic
          renewal service is provided as a convenience for you but in no way
          guarantees a desired renewal. It is your obligation to affirmatively
          renew any desired domain. In addition, <Metadata name="title" mdxType="Metadata" /> has
          no obligation to attempt to renew your domain if your most recent
          credit card on file with us for your account is not accepted according
          to <Metadata name="title" mdxType="Metadata" />
          &#39;s payment processing systems. After your domains have been
          successfully renewed, you will receive a confirmation email. Note: The
          Auto-renewal process requires a valid credit card to be kept on file
          in your account. You will be notified if the Auto-renewal transaction
          is declined for any reason.{' '}
      </p>
      <p>
          3.2 If you do not choose to have the High Security service as part of
          your Subscription Service, you must contact Customer Support by
          logging into your <Metadata name="title" mdxType="Metadata" /> account at{' '}
          <Metadata name="link" mdxType="Metadata" /> and disabling the High Security feature on
          those domains you choose not to protect. Your failure to expressly opt
          out of the High Security service constitutes your authorization and
          consent for <Metadata name="title" mdxType="Metadata" /> to enable Registrar-Lock and
          Auto-renewal, and attempt to automatically charge your credit card the
          then-current retail price for such renewal.
      </p>
      <p>
          3.3 You are solely responsible for the credit card and billing contact
          information you provide to <Metadata name="title" mdxType="Metadata" /> and you
          acknowledge and agree that you will promptly inform{' '}
          <Metadata name="title" mdxType="Metadata" /> of any changes thereto (e.g., change of
          expiration date or account number).{' '}
      </p>
      <p>
          3.4 You are solely responsible for ensuring the security of your
          domains. <span style={{
            textTransform: 'uppercase'
          }}><Metadata name="title" mdxType="Metadata" /></span>{' '} WILL HAVE NO LIABILITY TO YOU
          OR ANY THIRD PARTY IN CONNECTION WITH THE HIGH SECURITY FEATURES,
          INCLUDING ATTEMPTED OR SUCCESSFUL TRANSFERS OF DOMAINS EVEN THOUGH THE
          HIGH SECURITY SERVICE IN ENABLED, OR RENEWAL OR ANY ATTEMPT TO RENEW
          DOMAINS AS DESCRIBED HEREIN, INCLUDING, BUT NOT LIMITED TO, ANY
          FAILURE OR ERRORS IN TRANSFERS, RENEWING OR ATTEMPTING TO RENEW THE
          DOMAINS. The foregoing limitation of liability is in addition to any
          other limitations of liability set forth in this Agreement.{' '}
      </p>
      <p>
          3.5 You understand and agree that the release, indemnity and other
          obligations in favour of <Metadata name="title" mdxType="Metadata" /> and certain other
          persons in Section 14 of the Main Terms and Conditions apply to your
          use of the High Security feature.
      </p>
  </blockquote>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulee">
      <a href="#schedulee" name="schedulee">
          Schedule E
      </a>
      : Terms and Conditions Applicable to <Metadata name="title" mdxType="Metadata" /> Privacy
      Service
  </h2>
  <p>
      <strong>1.</strong> <Metadata name="title" mdxType="Metadata" /> has introduced a
      &#34;Privacy&#34; service to address issues of domain name privacy
      through the services of Privacy Hero Ltd. By using the Services and/or
      website of Privacy Hero Inc., a Turks and Caicos company (&#34;Privacy
      Hero&#34;), You agree to all the terms and conditions set forth both
      herein and in the Privacy Hero Terms and Conditions, which is
      incorporated by reference and can be found by clicking&nbsp;
      <a href="https://www.privacyhero.company/en/terms" rel="noreferrer" target="_blank">
          here
      </a>
      .&nbsp; You acknowledge that Privacy Hero may amend this Agreement at
      any time upon posting the amended terms on its website, and that any
      new, different or additional features changing the services provided by
      Privacy Hero will automatically be subject to this Agreement. If You do
      not agree to be bound by, or if You object to, the terms and conditions
      of this Agreement and any amendments hereto, do not use or access
      Privacy Hero&#39;s services. Continued use of Privacy Hero&#39;s
      services and its website after any such changes to this Agreement have
      been posted, constitutes Your acceptance of those changes.
  </p>
  <p>
      <strong>2. Good Faith</strong> By enabling the Privacy service, you
      agree to use the domain name and associated websites in good faith.
      Without limiting the generality of the foregoing, you will not use the
      Privacy services for purposes of engaging in, participating in,
      sponsoring or hiding your involvement in illegal or morally
      objectionable activities, including but not limited to, activities which
      are designed, intended to or otherwise: (a) appeal primarily to prurient
      interests; (b) defame, embarrass, harm, abuse, threaten, or harass; (c)
      violate state or federal local laws and/or foreign territories; (d)
      involve hate crimes, terrorism or child pornography; (e) are tortious,
      vulgar, obscene, invasive of a third party&#39;s privacy, race,
      ethnicity, or are otherwise objectionable; (f) impersonate the identity
      of a third party; (g) harm minors in any way; or (h) relate to or
      transmit viruses, Trojan Horses, access codes, backdoors, worms,
      timebombs or any other code, routine, mechanism, device or item that
      corrupts, damages, impairs, interferes with, intercepts or
      misappropriates any software, hardware, firmware, network, system, data
      or personally identifiable information. Any alleged misconduct in
      connection with your use of the domain name and/or the associated
      website in contravention of this Section 2 will be cause for termination
      of the Privacy service in accordance with Section 4 below.
  </p>
  <p>
      <strong>3. Term of Service</strong> Unless otherwise specified, and
      subject to earlier termination as contemplated by Section 2 and Section
      4, the Privacy service will initially be activated for a one-year term.
      At the end of such one-year term, and at the end of each subsequent
      one-year term thereafter, the Privacy service will automatically renew
      for consecutive one-year terms at then current rates, unless you request
      cancellation of the Privacy service by notifying{' '}
      <Metadata name="title" mdxType="Metadata" /> at least thirty (30) days before the end of
      the then-current term. You acknowledge and agree that in connection with
      any automatic renewal <Metadata name="title" mdxType="Metadata" /> will attempt to charge
      the credit card you have on file at the then current rates, and you
      waive any requirement to obtain your ongoing affirmative consent to any
      such automatic renewal. It is your responsibility to keep your credit
      card information current and accurate, including the expiration date. If{' '}
      <Metadata name="title" mdxType="Metadata" /> is unable to collect renewal or other fees,
      you agree that <Metadata name="title" mdxType="Metadata" /> may contact you, but is not
      obliged to do so, and you agree that <Metadata name="title" mdxType="Metadata" /> may
      suspend or terminate the Privacy service as a result of inability to
      obtain payment. FEES WILL NOT BE PRO RATED OR OTHERWISE REFUNDED IF THE
      PRIVACY SERVICE IS CANCELLED OR OTHERWISE TERMINATED BEFORE THE END OF
      THE THEN-CURRENT TERM. Without limiting the generality of the foregoing,
      you understand that the Privacy services term may be different than the
      registration term of a domain which is associated with the Privacy
      services. If a domain expires and is deleted before the end of the term
      of the associated Privacy services, then the Privacy services associated
      with the domain will end when the domain is deleted and you understand
      that there will be no refund for any resulting unused portion of a
      Privacy services term.
  </p>
  <p>
      <strong>4. Disclosure and Termination</strong> You agree that in the
      event:
  </p>
  <blockquote>
      <p>
          (a) <Metadata name="title" mdxType="Metadata" /> or its parent, subsidiary, entity under
          common control and/or entity owned by the same beneficial owner, or
          their respective owners, beneficial owners, directors, officers,
          shareholders, employees, contractors, agents, partners, affiliates,
          successors or assigns is threatened, receives a complaint, notice of
          action or any demand from a third party with respect to a domain name
          and/or associated websites for which the Privacy service is activated,
          or
      </p>
      <p>
          (b) there is alleged infringement, abuse or misuse of, or activity of
          any nature that could result in loss or legal liability (civil or
          criminal) to <Metadata name="title" mdxType="Metadata" /> or its parent, subsidiary, entity under common control and/or entity owned by the same beneficial owner or their respective owners, directors, officers,
          shareholders, employees, contractors, agents, partners, affiliates,
          successors or assigns with respect to a domain name and/or associated
          websites for which the Privacy service is activated, or
      </p>
      <p>
          (c) you are not, in <Metadata name="title" mdxType="Metadata" />
          &#39;s opinion, using the Privacy service in good faith as required by
          Section 2,
      </p>
      <p>
          you have provided us with your prior consent to disable the Privacy
          service and to disclose your technical and administrative contact
          information to any complainant or third party requesting such
          information and to make such information publicly available for a
          WHOIS or RDAP query. You agree that no further prior authorization or approval
          from you or your agent is necessary for such disclosure. You
          understand and agree that <Metadata name="title" mdxType="Metadata" /> is under no
          obligation to provide the Privacy service to you, and that{' '}
          <Metadata name="title" mdxType="Metadata" /> may, in its sole discretion, for any reason
          or no reason, disable the Privacy service without notice or warning,
          either with respect to a specific domain name(s) or with respect to
          all domain names in your account (even if “customer” level Privacy
          service has been selected). YOU WILL NOT BE ENTITLED TO ANY FEE REFUND
          AS A RESULT OF DISCLOSURE OF YOUR ADMINISTRATIVE OR TECHNICAL CONTACT
          INFORMATION AND/OR TERMINATION OF THE PRIVACY SERVICE AS CONTEMPLATED
          BY SECTION 3 OR 4 HEREOF.
      </p>
      <p>
          Without limiting the generality of the foregoing,{' '}
          <Metadata name="title" mdxType="Metadata" /> shall be entitled to suspend access or
          service to your account in order to disable the Privacy service.
      </p>
  </blockquote>
  <p>
      <strong>5. Limitation of Liability</strong> TO THE EXTENT PERMITTED BY
      LAW, NEITHER{' '}
      <span style={{
          textTransform: 'uppercase'
        }}>
          <Metadata name="title" mdxType="Metadata" />
      </span>{' '}
      NOR, ITS PARENT, SUBSIDIARY, ENTITY UNDER COMMON CONTROL AND/OR ENTITY
      OWNED BY THE SAME BENEFICIAL OWNER, AND AFFILIATED COMPANIES, AND/OR
      THEIR RESPECTIVE OWNERS, DIRECTORS, OFFICERS, SHAREHOLDERS, EMPLOYEES,
      CONTRACTORS, AGENTS, PARTNERS, AFFILIATES, SUCCESSORS AND ASSIGNS SHALL
      NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL OR
      CONSEQUENTIAL DAMAGES RESULTING FROM YOUR USE OF THE PRIVACY SERVICE, OR
      THE DISCLOSURE OF YOUR ADMINISTRATIVE OR TECHNICAL CONTACT INFORMATION
      AND/OR TERMINATION OF THE PRIVACY SERVICE AS CONTEMPLATED BY SECTION 3
      OR 4 HEREOF. The foregoing limitation of liability is in addition to any
      other limitations of liability set forth in this Agreement.
  </p>
  <p>
      <strong>6. Indemnity, etc</strong> You understand and agree that the
      release, indemnity and other obligations in favour of{' '}
      <Metadata name="title" mdxType="Metadata" /> and certain other persons in Section 14 of the
      Main Terms and Conditions apply to your use of the Privacy service.
  </p>
  <p>
      <strong>7. Accurate Information</strong> As a condition of your use of
      the Privacy service, you agree to: (a) provide current, complete and
      accurate information about you as required by the domain name
      application and registration process; (b) maintain and update such
      information as needed to keep it current, complete and accurate; and (b)
      respond within five (5) calendar days to a request by us to update or
      confirm the accuracy of your information. We rely on this information to
      carry out our service for you and comply with the requirements of
      registries of domain names and to send you important information and
      notices regarding your account and our services. Any failure by you to
      provide or update such information or to respond to our request is a
      material breach of this Agreement.
  </p>
  <p>
      <strong>8. Forwarded Information</strong> You agree that{' '}
      <Metadata name="title" mdxType="Metadata" /> may review communications sent to the email
      address associated with your Privacy service enabled domain. For
      communications received via certified or traceable courier mail (such as
      UPS or FedEx), or postal mail which does not appear to be unsolicited
      commercial mail, <Metadata name="title" mdxType="Metadata" /> will make commercially
      reasonable efforts to either (a) forward such communication to you or
      (b) attempt to communicate to you a scanned copy of a page of the
      communication to ascertain whether you wish to receive the full
      communication. You specifically acknowledge that{' '}
      <Metadata name="title" mdxType="Metadata" /> may elect to not forward to you (nor to
      otherwise communicate with you) regarding postal mail or email, fax,
      postal mail or telephone communications which appear to be unsolicited
      communications (e.g., communications which offer or advertize the sale
      of goods or services or which solicit charitable contributions). You
      authorize <Metadata name="title" mdxType="Metadata" /> to either discard all such
      communications or return all such communications to sender unopened. You
      agree to waive any and all claims arising from your failure to receive
      communications directed to your domain name but not forwarded to you by{' '}
      <Metadata name="title" mdxType="Metadata" />, including failures which arise from{' '}
      <Metadata name="title" mdxType="Metadata" />
      &#39;s mistake in judging whether a communication appears to be an
      unsolicited communication. You agree that you will reimburse{' '}
      <Metadata name="title" mdxType="Metadata" /> for any reasonable fees for administrative
      tasks outside the scope of regular services incurred as a result of your
      use of the Privacy service. These may include, but are not limited to,
      Customer Support issues that require personal service and disputes that
      require legal services.
  </p>
  <p>
      <strong>9. Terms That Survive</strong> In the event this Agreement or Schedule expires or
      terminates, Sections 4, 5, 6 and 8 of this Schedule shall survive such
      expiration or termination.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulef">
      <a href="#schedulef" name="schedulef">
          Schedule F
      </a>
      : Terms and Conditions Applicable to SSL Certificate Services
  </h2>
  <p>
      The Secure Sockets Layer (SSL) services offered under these SSL Terms is
      an &#34;additional service&#34; as provided under Section 3 of this
      Agreement, &#34;VARIOUS SERVICES&#34;.
  </p>
  <p>
      SSL enterprise and certificate services provided by{' '}
      <Metadata name="title" mdxType="Metadata" /> to you include assisting you in acquiring a
      new SSL certificate(s) and its associated products and services (the
      &#34;SSL Service&#34;).{' '}
  </p>
  <p>The following additional terms apply to the SSL Service: </p>
  <blockquote>
      <p>
          a) You acknowledge and agree <Metadata name="title" mdxType="Metadata" /> cannot
          guarantee the issuance of an SSL certificate following your submission
          of an application thereof. Issuance of an SSL certificate is subject
          to verification and approval of the information you submitted. This
          verification may, in some instances, take several business days.
      </p>
      <p>
          b) <Metadata name="title" mdxType="Metadata" /> is an authorized reseller for GlobalSign.
          You hereby authorize <Metadata name="title" mdxType="Metadata" /> to remit your submitted
          SSL certificate application, including all the information included
          therein, and acquire an SSL certificate from GlobalSign on your
          behalf. You agree to GlobalSign&#39;s terms and conditions
          incorporated herein by reference, as found at{' '}
          <a href="https://www.globalsign.com/repository/globalsign-subscriber-agreement-digital-certificates-and-services.pdf">
          https://www.globalsign.com/repository/globalsign-subscriber-agreement-digital-certificates-and-services.pdf
          </a>
          . You understand and agree that you are entering into and agreeing to
          a separate contractual relationship between you and GlobalSign in
          addition to these SSL Terms and this Agreement. You understand and
          agree that the underwritten Liability Program is provided as a service
          by GlobalSign. In order to provide an enhanced customer experience and
          as a convenience to you, <Metadata name="title" mdxType="Metadata" /> will pay the SSL
          certificate/renewal fees on your behalf as part of the SSL Service
          provided that (i) these SSL Terms have not been cancelled or otherwise
          terminated, (ii) you have paid any amounts due under these SSL Terms,
          (iii) you are not in breach of the Agreement or these SSL Terms, and
          (iv) that GlobalSign agrees to and accepts your SSL certificate
          application/renewal fees. Notwithstanding the immediately forgoing
          sentence, you expressly acknowledge and agree that you shall be
          responsible for all fees, liability and obligations with your
          relationship with GlobalSign.
      </p>
      <p>
          c) You authorize <Metadata name="title" mdxType="Metadata" /> to list itself as a contact
          in connection with the SSL certificate and to take any actions{' '}
          <Metadata name="title" mdxType="Metadata" /> deems necessary or appropriate in connection
          therewith. Upon termination of SSL Services, <Metadata name="title" mdxType="Metadata" />{' '}
          may immediately cease acting in such capacity and reserves the right
          to transfer your account to GlobalSign to serve for all future
          communications in connection with your SSL certificate. You further
          authorize <Metadata name="title" mdxType="Metadata" /> to list you as the subscriber and
          certificate administrator in connection with SSL certificate. You may
          also specify another subscriber and certificate administrator;
          however, such person(s) may be required to enter into a separate
          agreement with GlobalSign for use of SSL certificate services and/or
          access for services in support of your SSL certificate. Upon
          termination of SSL Services, <Metadata name="title" mdxType="Metadata" /> will not be
          responsible for forwarding any notices (email or otherwise) to you or
          for taking any other actions in connection with your SSL certificate.
          You will be solely responsible for any ongoing fees, as well as taking
          all necessary or advisable actions in connection with your SSL
          certificate.
      </p>
  </blockquote>
  <p>
      <strong>1. Automatic Renewals</strong>
  </p>
  <p>
      If you purchased a new SSL certificate using our SSL Service, 
      we may elect, in our sole discretion, to automatically renew and 
      bill you for the SSL certificate registration in
      accordance with Section 2 (Fees) below and this Agreement. Automatic
      renewal will not occur if the option is disabled through the
      administrative module for your account with <Metadata name="title" mdxType="Metadata" />.
      Each new SSL certificate acquired by <Metadata name="title" mdxType="Metadata" /> from
      GlobalSign will be renewed prior to each annual anniversary. Failure to
      electronically approve the renewal or remit Fees in accordance with
      Section 2 and the Fees Policy, may risk the non-renewal of your SSL
      certificate. Your SSL certificate will be renewed with GlobalSign only
      after the annual or multi-year fee is successfully charged to your
      credit card or payment transmitter in a timely manner.
  </p>
  <p>
      <strong>2. Fees</strong>
  </p>
  <p>
      SSL Certificate Registration Fees will be charged yearly and in advance
      (with multi-year certificate subscriptions renewed prior to the
      expiration of the last year and for a period of equal length) in
      accordance with this Agreement.
  </p>
  <p>
      <strong>3. Verification of Information</strong>
  </p>
  <blockquote>
      <p>
          a) You are solely responsible for maintaining that all information
          relating to the use of your SSL certificate is up-to-date with
          GlobalSign. Further, in accordance with the terms and conditions of
          your agreement with GlobalSign and in order to maintain a safe
          ecommerce presence, <Metadata name="title" mdxType="Metadata" /> may from time to time
          request that you verify any information to be supplied to GlobalSign.
          In the event that you fail to respond to any such request or fail to
          verify any such information within 30 days of the request, GlobalSign
          and/or <Metadata name="title" mdxType="Metadata" /> may, in its/our sole and absolute
          discretion, immediately terminate your SSL Services. This remedy is in
          addition to any other remedies available under law or this Agreement.
      </p>
      <p>
          b) You shall protect the confidentiality of any encryption keys used
          by you in connection with your SSL certificate. Further, you shall
          promptly request that GlobalSign revoke any SSL certificate upon any
          actual or suspected loss, disclosure, or other compromise of your
          encryption keys or breach of the SSL certificate.
      </p>
  </blockquote>
  <p>
      <strong>4. Terms and Termination</strong>
  </p>
  <blockquote>
      <p>
          a) Your SSL certificate may only be transferred, if allowed, under the
          terms and conditions of your agreement with GlobalSign.
      </p>
      <p>
          b) <Metadata name="title" mdxType="Metadata" /> may, but has no duty to, immediately
          suspend or terminate your use of the SSL Service and remove any of
          your materials (including without limitation your SSL certificate)
          from <Metadata name="title" mdxType="Metadata" /> servers in the event{' '}
          <Metadata name="title" mdxType="Metadata" />, in its sole discretion, concludes that (i)
          there is any change to the information on the SSL certificate or the
          certificate application, including but not limited to the change of
          the organization name or domain name registration, (ii) there is any
          actual, <Metadata name="title" mdxType="Metadata" /> reasonably suspects, loss,
          disclosure, or other compromise of an encryption key for the SSL
          certificate, (iii) you have engaged in illegal activities, in
          activities or sales that may damage the rights of{' '}
          <Metadata name="title" mdxType="Metadata" /> or others, or (iv) you have violated or
          threatened to violate these SSL Terms, the terms of this Agreement or
          any other agreement you may have with <Metadata name="title" mdxType="Metadata" />. Any
          suspension or termination under this paragraph may take effect
          immediately. In the event that <Metadata name="title" mdxType="Metadata" /> terminates
          your SSL Service in connection with this paragraph, you will not be
          entitled to a refund or credit of any fees you have paid. Without
          limitation, you expressly acknowledge and agree that in addition to
          this Section (4), the terms and conditions of this Agreement also
          apply to your use of the SSL Services.
      </p>
  </blockquote>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduleg">
      <a href="#scheduleg" name="scheduleg">
          Schedule G
      </a>
      : Terms and Conditions Relating to Afternic Fast Transfer
  </h2>
  <p>
      <strong>1. DESCRIPTION OF SERVICE</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> is partnering with Afternic® to provide{' '}
      <Metadata name="title" mdxType="Metadata" /> customers with a means to sell their domain
      name(s) to interested buyers through a network of selected registrars.
      If you choose to list your domain name for sale through the Fast
      Transfer Service and enter into this Agreement, you expressly
      acknowledge, understand and agree that: (i) <Metadata name="title" mdxType="Metadata" />{' '}
      shall not have any liability or obligations to you regarding the listing
      and sale of your domain name through the Fast Transfer Service or the
      transfer of the domain name from you to the buyer; (ii){' '}
      <Metadata name="title" mdxType="Metadata" /> has no control over buyers or Afternic&#39;s
      network of selected registrars and makes no representations as to the
      reliability or capability of the listing service, or the qualifications
      of any potential buyer or the ability of any buyer to pay for a domain
      name; and (iii) <Metadata name="title" mdxType="Metadata" /> does not collect, retain or
      have access to any credit card information of buyers utilizing the Fast
      Transfer Service, nor do we process the payment of funds between you and
      a buyer and therefore cannot be held liable for any non-payment by the
      buyer or any unauthorized disclosure of any personal or credit card
      information concerning the buyer. All terms and conditions related to
      the transfer of funds between Afternic buyers and sellers are covered in
      the Afternic Membership Agreement and Terms of Service located at{' '}
      <a href="https://www.afternic.com/legal">
          https://www.afternic.com/legal
      </a>
      .
  </p>
  <p>
      When you register your domain name with <Metadata name="title" mdxType="Metadata" /> and
      list your domain for sale as part of the Fast Transfer Service, you
      expressly acknowledge and agree that we may instantly transfer any
      domain name successfully sold in the Fast Transfer Service away from
      your <Metadata name="title" mdxType="Metadata" /> account into the account of the
      successful buyer of the domain name. You acknowledge and agree to allow{' '}
      <Metadata name="title" mdxType="Metadata" /> to disable any transfer lock feature
      associated with a domain name enrolled in the Fast Transfer Service,
      including but not limited to the disabling of our domain name transfer
      validation service.
  </p>
  <p>
      You agree to release, indemnify, defend and hold harmless{' '}
      <Metadata name="title" mdxType="Metadata" /> and any of its contractors, agents, employees,
      officers, directors, shareholders, affiliates and assigns from all
      liabilities, claims, damages, costs and expenses, including reasonable
      attorneys&#39; fees and expenses, relating to or arising out of your use
      of the Fast Transfer Service, including, but not limited to, the instant
      transfer of the domain name from your <Metadata name="title" mdxType="Metadata" /> account
      to the account of the buyer.
  </p>
  <p>
      <strong>2. LIMITATIONS AND DISCONTINUATION OF SERVICE</strong>
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> does not and cannot guarantee the sale or
      purchase of any domain name through the Fast Transfer Service. Transfer
      of a domain name to a buyer is not instantaneous at the time of sale and
      may take several days to occur.
  </p>
  <p>
      You may remove a domain name from the Fast Transfer Service at any time.
      In the event that you remove a domain from the Service, please be aware
      that removal of the domain name from the Afternic network is not
      instantaneous, and may take several days to occur.{' '}
      <Metadata name="title" mdxType="Metadata" /> will complete the instant transfer process for
      any domain name enrolled in the Fast Transfer Service and sold through
      the Afternic network during this timeframe.
  </p>
  <p>
      You acknowledge and agree that <Metadata name="title" mdxType="Metadata" /> may remove your
      domain name from the Fast Transfer Service at any time for any reason,
      without prior notification, including, but not limited to: non-payment
      of fees, expiration of domain name, fraud, restrictions on transfer, the
      filing of a trademark or ownership dispute concerning the domain name,
      or in the event of a transfer of the domain name to another registrar.
  </p>
  <p>
      <strong>
          3. DESIGNATED AGENT AND CHANGE OF REGISTRANT INFORMATION
      </strong>
  </p>
  <p>
      “DESIGNATED AGENT” MEANS AN INDIVIDUAL OR ENTITY THAT THE PRIOR
      REGISTRANT OR NEW REGISTRANT EXPLICITLY AUTHORIZES TO APPROVE A CHANGE
      OF REGISTRANT REQUEST ON ITS BEHALF. FOR THE PURPOSE OF FACILITATING THE
      FAST TRANSFER PROCESS, AND IN ACCORDANCE WITH ICANN&#39;S{' '}
      <a href="https://www.icann.org/resources/pages/transfer-policy-2016-06-01-en">
          CHANGE OF REGISTRANT POLICY
      </a>
      , YOU AGREE TO APPOINT <Metadata name="title" mdxType="Metadata" /> AS YOUR DESIGNATED
      AGENT FOR THE SOLE PURPOSE OF EXPLICITLY CONSENTING TO MATERIAL CHANGES
      OF REGISTRATION CONTACT INFORMATION ON YOUR BEHALF.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="scheduleh">
      <a href="#scheduleh" name="scheduleh">
          Schedule H
      </a>
      : Terms and Conditions Relating to Expiry Protection Service and Ownership Protection Services 
  </h2>
  <p>1. DESCRIPTION OF SERVICE</p>
  <p>
      We offer the following optional services to provide even greater domain protection: 
  </p>
  <p>
a) Expiry Protection allows Internic.ca to pay the registry directly for your domain name renewal prior to/upon expiration; this helps protect you from losing your domain name due to billing or payment concerns (e.g., incorrect credit card on file).  The domain name renewal fees are in addition to the Expiry Protection service fee. If you elect this service, we pay for the renewal of your domain name and you agree to reimburse us for that renewal amount. The benefit of this service is that it provides additional time, and a backup plan, to ensure your domain names are renewed.
  </p>
  <p>
      b) Ownership Protection restricts important changes to your domain names. When you elect this service, it ensures a greater level of protection and documentation for any changes to key domain settings including without limitation, changing domain registrant, transferring domains, and domain deletion. 
  </p>
  <p>2. You acknowledge and agree that we may remove your domain name from the services above at any time and for any reason, including but not limited to: non-payment of fees, fraud, restrictions on transfer, the filing of a trademark or ownership dispute concerning the domain name, or in the event of a transfer of the domain name to another registrar.  Fees paid for the above services are non-refundable.</p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="schedulei">
      <a href="#schedulei" name="schedulei">
          Schedule I
      </a>
      : Terms and Conditions Relating to Preferred Partner Program
  </h2>
  <p>
      When enrolled in the Preferred Partner Program, the default payment
      method will be set as account credit, unless <Metadata name="title" mdxType="Metadata" />{' '}
      has otherwise been notified by you. Other payment methods include PayPal, cheque, and
      ACH.
  </p>
  <p>
      When a customer has been referred to <Metadata name="title" mdxType="Metadata" /> by
      someone enrolled in the Preferred Partner Program, their account must be
      in good standing for three (3) months before a payment will be issued.
  </p>
  <p>
      Premium domain purchases are not included in the Preferred Partner
      Program payment structure.
  </p>
  <p>
      <Metadata name="title" mdxType="Metadata" /> reserves the right to deny entry or revoke
      status in the Preferred Partner Program at any time. The terms of this
      program may also be modified at any time and without prior notice.
  </p>
  <p>
      <a href="#top">Back to Top</a>
  </p>
  <h2 id="registrant">
      <a href="#registrant" name="registrant">
          Registrant Rights, Benefits & Responsibilities
      </a>
  </h2>
  <p>
      If you register a domain name, you become the Registered Name Holder
      (also known as Registrant) for that domain. The Internet Corporation for
      Assigned Names and Numbers (<a href="https://www.icann.org/">ICANN</a>)
      has set forth various rights and responsibilities of Registrants over
      the registration and use of a registered Internet domain name. Further
      information about ICANN&#39;s policies and materials for Registrants is
      available on the ICANN website:
  </p>
  <ul>
      <li>
          <a href="https://www.icann.org/resources/pages/educational-2012-02-25-en">
          Registrant Educational Materials
          </a>
      </li>
      <li>
          <a href="https://www.icann.org/resources/pages/responsibilities-2014-03-14-en">
          Registrant Rights &amp; Responsibilities
          </a>
      </li>
      <li>
          <a href="https://www.icann.org/resources/pages/benefits-2013-09-16-en">
          Registrant&#39;s Benefits &amp; Responsibilities
          </a>
      </li>
  </ul>
  <p>
      <a href="#top">Back to Top</a>
  </p>
    </Metadata>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      